var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDioxin04(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 599.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220.26,
    cy: 366.36,
    r: 156.69,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.19,
    cy: 366.29,
    r: 166.52,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.42,48.08V599h399.3V48.08ZM218.27,540.52A174.67,174.67,0,1,1,392.94,365.85,174.67,174.67,0,0,1,218.27,540.52Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.85,207.35A166.51,166.51,0,0,0,67.79,435.61h0L-82.38,514.27a15.05,15.05,0,0,0-6.34,20.32A15,15,0,0,0-79.88,542a15,15,0,0,0,11.47-1L82.75,461.75a166.52,166.52,0,1,0,186.1-254.4Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.68,600.9a4.39,4.39,0,1,0-.63,6.17A4.4,4.4,0,0,0,65.68,600.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,594.94a3.66,3.66,0,1,0,5.14.54A3.67,3.67,0,0,0,90,594.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,590.4a3.58,3.58,0,1,0-.51,5A3.56,3.56,0,0,0,77.32,590.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,579.22a2.19,2.19,0,1,0-.33,3.09A2.19,2.19,0,0,0,100,579.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.87,590.31a3.65,3.65,0,1,0-.53,5.14A3.64,3.64,0,0,0,118.87,590.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81,506.25a4.39,4.39,0,1,0-1.53-6A4.39,4.39,0,0,0,97.81,506.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.88,506.16a4.39,4.39,0,1,0-1.52-6A4.4,4.4,0,0,0,71.88,506.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.27,503.54a2.92,2.92,0,0,0-3.88,4.21,2.17,2.17,0,0,0-1.32,1.08,2.21,2.21,0,0,0,3.9,2.09A2.2,2.2,0,0,0,67,509a2.92,2.92,0,0,0,1.23-5.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44,443.4a3.66,3.66,0,1,0-6.3-3.74,3.63,3.63,0,0,0,1.29,5A3.64,3.64,0,0,0,6.44,443.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.75,358a3.59,3.59,0,1,0,4.93-1.25A3.61,3.61,0,0,0,119.75,358Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,525.68a2.2,2.2,0,1,0-3,.76A2.19,2.19,0,0,0,108.22,525.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87,469.33a2.19,2.19,0,1,0-3,.77A2.18,2.18,0,0,0,101.87,469.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.73,598.14a3.66,3.66,0,1,0-3.73,6.29,3.66,3.66,0,0,0,3.73-6.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,542.77a4.4,4.4,0,1,0,.6,6.2A4.4,4.4,0,0,0,99.17,542.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76,542.38a2.93,2.93,0,1,0,.4,4.12A2.93,2.93,0,0,0,64.76,542.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.52,568A3.67,3.67,0,1,0,68,562.8,3.66,3.66,0,0,0,68.52,568Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,533.19a3.69,3.69,0,1,0-1.33-2.87,1.63,1.63,0,0,0-3,0,1.67,1.67,0,0,0,.79,2.22,1.65,1.65,0,0,0,2.2-.79,1.54,1.54,0,0,0,.12-.34A3.68,3.68,0,0,0,96.71,533.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61,567.29a2.19,2.19,0,0,0-3.09.3,2.21,2.21,0,0,0,.3,3.09,2.2,2.2,0,1,0,2.79-3.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,510.86a2.2,2.2,0,1,0,3.11-.31A2.2,2.2,0,0,0,99.82,510.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,523.35a3.66,3.66,0,1,0-.51-5.17A3.67,3.67,0,0,0,119,523.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,490a4.42,4.42,0,0,0-.26-4.55,4.34,4.34,0,0,0,3.47-.92,4.38,4.38,0,1,0-6.4-1,4.39,4.39,0,0,0-2.16.18,2.92,2.92,0,0,0-4.19-4,2.92,2.92,0,0,0,2.44,5.13,4.11,4.11,0,0,0-.7.94,4.52,4.52,0,0,0-.41,1.15A3.24,3.24,0,0,0,52,485.44a3.3,3.3,0,0,0-2.59-.18,3.68,3.68,0,1,0,1.28,6.41,3.29,3.29,0,0,0,2.75-1.78,2.82,2.82,0,0,0,.19-.48,4.37,4.37,0,0,0,2.06,2.43A4.43,4.43,0,0,0,61.66,490Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,492.87a4.42,4.42,0,0,0,4.18-7.79,4.42,4.42,0,0,0-4.18,7.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.08,495.59a2.95,2.95,0,1,0-1.21-4A2.93,2.93,0,0,0,23.08,495.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.55,492.93a3.68,3.68,0,1,0,1.5,5A3.67,3.67,0,0,0,49.55,492.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.34,188.44a3.69,3.69,0,1,0-1.51-5A3.68,3.68,0,0,0,85.34,188.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18,246.5a3.69,3.69,0,1,0-1.5-5A3.68,3.68,0,0,0,89.18,246.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.38,521.35A4.43,4.43,0,1,0,23,515.24,4.45,4.45,0,0,0,24.38,521.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.75,520.6a4.43,4.43,0,0,0,6.11-1.4A4.43,4.43,0,0,0,3,513.1a4.43,4.43,0,0,0-6.1,1.39A4.44,4.44,0,0,0-1.75,520.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.19,522a3.68,3.68,0,1,0,1.14,5.09A3.7,3.7,0,0,0,18.19,522Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4,504.6a3.7,3.7,0,1,0-1.16-5.1A3.69,3.69,0,0,0,25.4,504.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.81,504.27a3.62,3.62,0,1,0-5,1.13A3.62,3.62,0,0,0,11.81,504.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.31,541.89a2.24,2.24,0,0,0,3.07-.69,2.22,2.22,0,1,0-3.07.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.37,485a2.22,2.22,0,1,0-.71-3.05A2.23,2.23,0,0,0,26.37,485Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,551.08a4.44,4.44,0,1,0-6.26.62A4.45,4.45,0,0,0,27,551.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91,552.7a3,3,0,1,0-4.16.43A3,3,0,0,0,17.91,552.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.68,539.16a3.71,3.71,0,1,0-.52-5.22A3.72,3.72,0,0,0,49.68,539.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.76,573.53a2.23,2.23,0,1,0,.31,3.14A2.24,2.24,0,0,0,53.76,573.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.06,519.73a2.23,2.23,0,0,0,3.12-.31,2.22,2.22,0,1,0-3.43-2.81A2.23,2.23,0,0,0,53.06,519.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,528.61a3.7,3.7,0,1,0-5.21.54A3.7,3.7,0,0,0,77.36,528.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.52,579.17a4.42,4.42,0,1,0,.24,6.25A4.43,4.43,0,0,0,21.52,579.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33,585.2a3.7,3.7,0,0,0-5.21.22,3.68,3.68,0,1,0,5.21-.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.57,569.42a3.69,3.69,0,1,0-.21-5.21A3.68,3.68,0,0,0,19.57,569.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08,561.53a3.61,3.61,0,1,0,.21,5.1A3.59,3.59,0,0,0,6.08,561.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.69,560.59a3.69,3.69,0,0,0,.62-4.05,4.4,4.4,0,0,0,4.53-1.47,4.45,4.45,0,1,0-7.27-.6,3.66,3.66,0,0,0-3.3,1.13,3.71,3.71,0,0,0-.83,1.53,3.58,3.58,0,0,0-1.09-1.54,3.7,3.7,0,1,0,.51,5.21,3.61,3.61,0,0,0,.7-1.36,3.77,3.77,0,0,0,.92,1.37A3.7,3.7,0,0,0,47.69,560.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.26,496.22a3.65,3.65,0,1,0,.53-5.14A3.66,3.66,0,0,0,71.26,496.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.27,477.59a3.66,3.66,0,1,0,.54-5.16A3.65,3.65,0,0,0,89.27,477.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.64,472.93A3.59,3.59,0,0,0,77.76,469a3.72,3.72,0,0,0,.19-.34A3.31,3.31,0,1,0,71.89,466a3.28,3.28,0,0,0-.23,1.82,3.58,3.58,0,0,0,5,5.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,514.45a2.2,2.2,0,1,0,.32-3.1A2.22,2.22,0,0,0,82.91,514.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.76,456.38a2.17,2.17,0,0,0-.31,3.09,2.19,2.19,0,1,0,.31-3.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,468.35a1.68,1.68,0,0,0-.92-2,1.65,1.65,0,0,0-1.65.2,3.6,3.6,0,0,0-2.93.75,3.65,3.65,0,1,0,5.5,1.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,377.72a4.39,4.39,0,1,0,6-1.54A4.4,4.4,0,0,0,96.1,377.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.71,383.64a4.39,4.39,0,1,0-1.54-6A4.39,4.39,0,0,0,71.71,383.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,381a2.92,2.92,0,0,0-3.88,4.2,2.15,2.15,0,0,0-1.31,1.08,2.18,2.18,0,0,0,.9,3,2.2,2.2,0,0,0,3.06-2.84A2.92,2.92,0,0,0,68.1,381Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.79,389.58a3.66,3.66,0,1,0-6.3-3.74,3.61,3.61,0,0,0-.25,3.16,2.2,2.2,0,1,0,.54,4.34,2.19,2.19,0,0,0,1.67-2.18A3.66,3.66,0,0,0,92.79,389.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,362.07a3.67,3.67,0,1,0,5-1.28A3.68,3.68,0,0,0,96.94,362.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,363.44a3.58,3.58,0,1,0,4.92-1.25A3.6,3.6,0,0,0,78.58,363.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,403.93a2.2,2.2,0,1,0-.76-3A2.2,2.2,0,0,0,105,403.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,347.6a2.23,2.23,0,0,0,3-.78,2.2,2.2,0,1,0-3,.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,352.72a3.66,3.66,0,1,0-5,1.29A3.66,3.66,0,0,0,123.77,352.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.31,473.45a4.4,4.4,0,1,0,.6,6.2A4.4,4.4,0,0,0,237.31,473.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21,426.94a3.66,3.66,0,1,0,.5,5.15A3.64,3.64,0,0,0,87.21,426.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,405.51a3.66,3.66,0,0,0,3.76,5.87,1.65,1.65,0,1,0,1.29-.63,3.28,3.28,0,0,0,.61-.57A3.67,3.67,0,1,0,96,405.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.83,273.2a3.59,3.59,0,1,0-.49-5.06A3.59,3.59,0,0,0,92.83,273.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63,448.17a2.21,2.21,0,1,0-.29-3.09A2.21,2.21,0,0,0,97.63,448.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.13,353.55a2.21,2.21,0,1,0-.31-3.1A2.21,2.21,0,0,0,244.13,353.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.33,395.66a3.67,3.67,0,1,0,5.16-.48A3.68,3.68,0,0,0,118.33,395.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.68,363.34a4.42,4.42,0,1,0,6-1.82A4.4,4.4,0,0,0,53.68,363.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.42,370.36a4.42,4.42,0,1,0-1.79-6A4.42,4.42,0,0,0,29.42,370.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9,371.86a3,3,0,1,0-4,1.22A3,3,0,0,0,26.9,371.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,370.42a3.68,3.68,0,1,0,1.5,5A3.68,3.68,0,0,0,49.37,370.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86,347.58a3.68,3.68,0,1,0,5-1.51A3.69,3.69,0,0,0,53.86,347.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,332.94a2.21,2.21,0,1,0,2.09-3.89A2.21,2.21,0,1,0,55,332.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.91,332a3.69,3.69,0,1,0,1.49,5A3.7,3.7,0,0,0,78.91,332Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.81,392.73a4.4,4.4,0,0,0,.61,5.45,3.35,3.35,0,0,0-3.06,2,3.3,3.3,0,1,0,5.65-.73,4.42,4.42,0,1,0-3.2-6.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,168.07A3.69,3.69,0,1,0,6.64,163,3.7,3.7,0,0,0,7.8,168.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.08,377a3.69,3.69,0,1,0,5.09-1.16A3.68,3.68,0,0,0,24.08,377Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52,377.9a3.62,3.62,0,1,0,5-1.13A3.62,3.62,0,0,0,5.52,377.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.14,419.38a2.28,2.28,0,0,0,1.83.24l-.1.15a1.66,1.66,0,1,0,2.21-.78,1.62,1.62,0,0,0-1-.13,1,1,0,0,0,.13-.17,2.22,2.22,0,1,0-3.06.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25,361.74a2.22,2.22,0,1,0-3.05.69A2.22,2.22,0,0,0,29.25,361.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.08,364.32a3.69,3.69,0,1,0,5.1-1.16A3.68,3.68,0,0,0,45.08,364.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,426.3A4.43,4.43,0,0,0,45.38,432,3.68,3.68,0,1,0,48.14,434,4.42,4.42,0,0,0,52,426.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.76,428.56a4.41,4.41,0,0,0-.17-5.79,3.38,3.38,0,0,0,.34-.55,3.31,3.31,0,1,0-6-2.82,3.26,3.26,0,0,0-.05,2.68,4.21,4.21,0,0,0-1,.86,4.43,4.43,0,1,0,6.86,5.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.32,426a3,3,0,1,0,.42,4.16A3,3,0,0,0,17.32,426Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.37,244.11a3.7,3.7,0,1,0,.54,5.21A3.69,3.69,0,0,0,73.37,244.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,560a5.17,5.17,0,1,0,.74,7.28A5.17,5.17,0,0,0,109.87,560Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.46,451.35a2.22,2.22,0,0,0,3.43,2.81c.06-.07.1-.15.15-.22a2.21,2.21,0,1,0,3.21-2.37,2.19,2.19,0,0,0-2.9.74,2.27,2.27,0,0,0-.77-1.29A2.21,2.21,0,0,0,50.46,451.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,397.22A2.22,2.22,0,0,0,56,396.9a2.21,2.21,0,1,0-3.12.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.35,463.16a4.42,4.42,0,1,0-.26-6.24A4.43,4.43,0,0,0,15.35,463.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17,468.1A3.68,3.68,0,1,0,4,462.91,3.68,3.68,0,0,0,4.17,468.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.65,193.28a3.69,3.69,0,1,0-.22-5.21A3.69,3.69,0,0,0,197.65,193.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.55,484.44a2.21,2.21,0,1,0-3.12.12A2.22,2.22,0,0,0,21.55,484.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5,471.73a4.39,4.39,0,1,0,.63-6.18A4.39,4.39,0,0,0,226.5,471.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,457.15a4.39,4.39,0,1,0-.63,6.17A4.39,4.39,0,0,0,209,457.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.64,458.54a2.89,2.89,0,0,0-1.06,2.31,1.52,1.52,0,0,0-.42.58,1.63,1.63,0,0,0,.85,2.17,1.65,1.65,0,0,0,1.44-.05,2.92,2.92,0,1,0-.81-5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,470.38a3.66,3.66,0,1,0-.55,5.15A3.66,3.66,0,0,0,220.48,470.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,451.73a3.66,3.66,0,1,0-.54,5.15A3.66,3.66,0,0,0,238.49,451.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.16,451.69a3.57,3.57,0,0,0,.94-1.16,2.77,2.77,0,1,0,.14-2.9,3.52,3.52,0,0,0-.55-1,3.58,3.58,0,1,0-.53,5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,490.44a2.19,2.19,0,0,0-3.41,2.76,2.19,2.19,0,1,0,3.41-2.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,435.14a2.2,2.2,0,1,0,3.1.32A2.2,2.2,0,0,0,240.29,435.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,451.69a3.65,3.65,0,1,0-5.14-.53A3.65,3.65,0,0,0,261.7,451.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.17,362.5a4.4,4.4,0,1,0-1.54-6A4.38,4.38,0,0,0,241.17,362.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.23,362.41a4.39,4.39,0,1,0-1.52-6A4.41,4.41,0,0,0,215.23,362.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,364.6a3.66,3.66,0,1,0,5-1.28A3.69,3.69,0,0,0,230,364.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.36,347.12a3.59,3.59,0,1,0-1.26-4.92A3.6,3.6,0,0,0,223.36,347.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.81,378.91a2.2,2.2,0,1,0,.77,3A2.21,2.21,0,0,0,250.81,378.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.24,326.35a2.19,2.19,0,1,0-.78-3A2.19,2.19,0,0,0,242.24,326.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,327.74a3.66,3.66,0,1,0,5-1.27A3.66,3.66,0,0,0,261,327.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,399a4.41,4.41,0,1,0,.6,6.19A4.39,4.39,0,0,0,242.53,399Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,191.83a4.39,4.39,0,1,0-.59-6.19A4.4,4.4,0,0,0,146.18,191.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,402.74a2.93,2.93,0,1,0-4.13.42A2.92,2.92,0,0,0,208.52,402.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,97.81a3.66,3.66,0,1,0-.51-5.16A3.66,3.66,0,0,0,80,97.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74,279.8a3.59,3.59,0,1,0-.49-5.06A3.6,3.6,0,0,0,193.74,279.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.88,423.84a2.2,2.2,0,1,0,3.09-.31A2.19,2.19,0,0,0,240.88,423.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,367.11a2.19,2.19,0,1,0,3.11-.31A2.18,2.18,0,0,0,243.18,367.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,379.6a3.67,3.67,0,1,0-.5-5.17A3.65,3.65,0,0,0,262.36,379.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.71,340.5a3.28,3.28,0,0,0-5.09,1.38,3.68,3.68,0,1,0,1.25,5.12,4.21,4.21,0,0,0,.4-.93,3.21,3.21,0,0,0,2,.27,4.42,4.42,0,1,0,1.45-5.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.13,341.33a4.42,4.42,0,1,0,1.82,6A4.42,4.42,0,0,0,177.13,341.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.44,351.84a2.95,2.95,0,1,0-1.21-4A2.93,2.93,0,0,0,166.44,351.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.91,349.17a3.68,3.68,0,1,0,1.5,5A3.68,3.68,0,0,0,192.91,349.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,331.33a3.69,3.69,0,1,0-1.51-5A3.7,3.7,0,0,0,198.89,331.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.75,251.1a2.21,2.21,0,1,0-.9-3A2.21,2.21,0,0,0,242.75,251.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,311.71a2.22,2.22,0,1,0-.9-3A2.23,2.23,0,0,0,198.5,311.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,317.28a3.68,3.68,0,1,0-1.51-5A3.67,3.67,0,0,0,219,317.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23,370.73a4.43,4.43,0,1,0,6.09-1.39A4.44,4.44,0,0,0,140.23,370.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.46,379.44a3.68,3.68,0,1,0,5.1-1.17A3.67,3.67,0,0,0,156.46,379.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,360.85a3.7,3.7,0,1,0-1.17-5.1A3.7,3.7,0,0,0,168.77,360.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.46,278.83a3.62,3.62,0,1,0-1.13-5A3.62,3.62,0,0,0,122.46,278.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,395.09a2.22,2.22,0,1,0,3.06-.7A2.21,2.21,0,0,0,174,395.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,338.14a2.21,2.21,0,1,0,3.05-.69A2.21,2.21,0,0,0,169,338.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,408a4.43,4.43,0,0,0,5.61,0,3.31,3.31,0,1,0,1.63-5.45c-.15,0-.29.1-.43.15a4.32,4.32,0,0,0-1.2-1.57,4.43,4.43,0,0,0-5.61,6.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,404.79a3,3,0,0,0-4.17.41,2.56,2.56,0,0,0-.22.35,2.7,2.7,0,0,0-4.54,2.54,2.71,2.71,0,0,0,3.28,2,2.66,2.66,0,0,0,1.54-1.06,2.59,2.59,0,0,0,.37.37,3,3,0,0,0,3.74-4.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,493.93a3.7,3.7,0,1,0-5.18.52A3.69,3.69,0,0,0,316.08,493.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26,394.88a3.71,3.71,0,1,0-5.22.51A3.7,3.7,0,0,0,198.26,394.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.81,232.16a5.18,5.18,0,1,0,7.3-.74A5.19,5.19,0,0,0,131.81,232.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,266.68a2.22,2.22,0,1,0-.31-3.12A2.22,2.22,0,0,0,110.62,266.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.11,372.86a2.22,2.22,0,1,0,3.13-.32A2.21,2.21,0,0,0,196.11,372.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,380.19a3.69,3.69,0,1,0,5.71,4.67,3.69,3.69,0,1,0-5.71-4.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,214.35a4.42,4.42,0,1,0,6.23-.26A4.42,4.42,0,0,0,81.44,214.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.22,433.26a3,3,0,1,0,4.17-.16A3,3,0,0,0,126.22,433.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.89,446.65a3.68,3.68,0,1,0-5.18.22A3.67,3.67,0,0,0,152.89,446.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,425.67a3.68,3.68,0,0,0,5.21-.22,3.69,3.69,0,0,0-5.43-5A3.69,3.69,0,0,0,162.93,425.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,460.21a2.21,2.21,0,1,0,3.12-.14A2.21,2.21,0,0,0,161.83,460.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,443.45a3.68,3.68,0,1,0-5.2.22A3.66,3.66,0,0,0,337.56,443.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,192.61A3.31,3.31,0,1,0,89,195,3.32,3.32,0,0,0,85,192.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.6,488.27a2.76,2.76,0,1,0,3.33,2A2.74,2.74,0,0,0,172.6,488.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,473.32a2.76,2.76,0,0,0,5.43-.84,2.64,2.64,0,0,0,1.16-1.28,2.76,2.76,0,1,0-5-2.23,2.78,2.78,0,0,0-.23,1.29A2.75,2.75,0,0,0,163.66,473.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,491.54a1.66,1.66,0,1,0-2-1.21A1.65,1.65,0,0,0,190.1,491.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.94,464.62a1.66,1.66,0,1,0-2-1.21A1.66,1.66,0,0,0,156.94,464.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,457.46a2.74,2.74,0,0,0-.41-5.4,1.52,1.52,0,0,0,0-.21,2.19,2.19,0,0,0-2.58-1.62,1.1,1.1,0,0,0,0-.18,1.66,1.66,0,1,0-1.72,2,2.21,2.21,0,0,0,0,.81,2.24,2.24,0,0,0,1.34,1.54,2.83,2.83,0,0,0,.05,1A2.74,2.74,0,0,0,171.1,457.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.31,416.15a3.31,3.31,0,1,0,4,2.42A3.31,3.31,0,0,0,157.31,416.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.63,427.35a2.2,2.2,0,1,0-2.67-1.62A2.21,2.21,0,0,0,156.63,427.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.35,410.85a2.76,2.76,0,1,0,3.33,2A2.78,2.78,0,0,0,204.35,410.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.62,411.74a2.76,2.76,0,1,0-3.35-2A2.77,2.77,0,0,0,267.62,411.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.72,412.66a1.66,1.66,0,1,0,2,1.22A1.66,1.66,0,0,0,186.72,412.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,389a1.66,1.66,0,1,0-2-1.21A1.66,1.66,0,0,0,154.36,389Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,376.44a2.76,2.76,0,1,0,3.33,2A2.77,2.77,0,0,0,167.22,376.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,330.24a3.31,3.31,0,1,0-4-2.43A3.3,3.3,0,0,0,181.39,330.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,445.13a2.76,2.76,0,1,0-3.35-2A2.76,2.76,0,0,0,183.77,445.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,426.84a2.76,2.76,0,1,0-3.34-2A2.75,2.75,0,0,0,176.83,426.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.45,306.14a2.7,2.7,0,1,0-3.27-2A2.69,2.69,0,0,0,146.45,306.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,441.05a1.66,1.66,0,1,0-3.22.79,1.66,1.66,0,0,0,3.22-.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78,416.12a1.66,1.66,0,1,0-2-1.21A1.66,1.66,0,0,0,166.78,416.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.35,299.34a2.75,2.75,0,1,0-3.34-2A2.76,2.76,0,0,0,159.35,299.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,404.58a3.32,3.32,0,1,0,4,2.43A3.33,3.33,0,0,0,136.66,404.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,424.66a3.31,3.31,0,1,0-4-2.43A3.31,3.31,0,0,0,124.25,424.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,429.44a2.21,2.21,0,1,0-2.68-1.62A2.21,2.21,0,0,0,122,429.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,414.69a2.76,2.76,0,1,0,3.34,2A2.76,2.76,0,0,0,135.37,414.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.76,401.76a2.76,2.76,0,1,0-3.33-2A2.77,2.77,0,0,0,129.76,401.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.25,406.9a2.71,2.71,0,1,0,3.28,2A2.71,2.71,0,0,0,119.25,406.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.18,238.85a1.65,1.65,0,1,0-2-1.21A1.65,1.65,0,0,0,202.18,238.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,391a1.65,1.65,0,1,0-2-1.2A1.66,1.66,0,0,0,119.72,391Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,378.53a2.76,2.76,0,1,0,2.57.7,2.9,2.9,0,1,0-.71-.49A2.75,2.75,0,0,0,132.56,378.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,289.84a3.31,3.31,0,1,0-4-2.43A3.31,3.31,0,0,0,87,289.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,452.42a2.21,2.21,0,1,0-2.68-1.62A2.2,2.2,0,0,0,103.75,452.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12,441a2.75,2.75,0,1,0,2-3.34A2.76,2.76,0,0,0,115.12,441Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,419.38a2.76,2.76,0,1,0,3.34,2A2.76,2.76,0,0,0,110.21,419.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,435.14a2.7,2.7,0,1,0-3.26-2A2.72,2.72,0,0,0,102.3,435.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3,404.85a2.76,2.76,0,1,0,2-3.34A2.76,2.76,0,0,0,112.3,404.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.93,527.73a3.31,3.31,0,1,0,4,2.42A3.3,3.3,0,0,0,287.93,527.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.54,332.27a3.3,3.3,0,1,0,4,2.41A3.31,3.31,0,0,0,125.54,332.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,561.62a2.76,2.76,0,1,0,3.33,2A2.77,2.77,0,0,0,304.77,561.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,315.73a2.76,2.76,0,1,0,3.33,2A2.76,2.76,0,0,0,84.75,315.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.24,444.27a2.7,2.7,0,1,0,3.15-3.29l.25,0a1.65,1.65,0,1,0-2-1.21,1.68,1.68,0,0,0,1.18,1.2,2.32,2.32,0,0,0-.59.07A2.7,2.7,0,0,0,131.24,444.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,425.12a1.65,1.65,0,0,0-.79-3.21,1.65,1.65,0,1,0,.79,3.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,248.5a2.76,2.76,0,1,0-3.34-2A2.75,2.75,0,0,0,148,248.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.48,579.7a3.31,3.31,0,1,0,4,2.42A3.3,3.3,0,0,0,240.48,579.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,597.84a3.3,3.3,0,1,0,4,2.41A3.29,3.29,0,0,0,35.5,597.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,484a2.21,2.21,0,1,0-1.61,2.67A2.21,2.21,0,0,0,112.51,484Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,210.14a2.76,2.76,0,1,0-3.35-2A2.76,2.76,0,0,0,76,210.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,512.74a2.76,2.76,0,1,0,3.33,2A2.75,2.75,0,0,0,216.62,512.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.59,141.46a2.7,2.7,0,1,0-3.27-2A2.69,2.69,0,0,0,51.59,141.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,475.2a1.66,1.66,0,1,0-2-1.21A1.65,1.65,0,0,0,141.78,475.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84,446.27a1.68,1.68,0,0,0-1.37-1.26,3.23,3.23,0,0,0,0-1.38,3.3,3.3,0,1,0-2.41,4,2.92,2.92,0,0,0,.71-.28,1.66,1.66,0,0,0,3.11-1.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.51,417.79a3.33,3.33,0,1,0-.94-4.61A3.33,3.33,0,0,0,14.51,417.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.66,378.12a4.21,4.21,0,0,0-1.19-5.8l-.29-.15a2.71,2.71,0,0,0,1.76-1.55A2.75,2.75,0,0,0-1.84,367a2.77,2.77,0,0,0-3.61,1.45,2.75,2.75,0,0,0,.82,3.23,4.16,4.16,0,0,0-3,1.84,4.16,4.16,0,0,0,1.2,5.78A4.17,4.17,0,0,0-.66,378.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78,204.37a4.09,4.09,0,1,0-1.16-5.67A4.1,4.1,0,0,0,4.78,204.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.64,372.37a2.5,2.5,0,1,0-4.18-2.76,2.5,2.5,0,0,0,4.18,2.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,255.54A5,5,0,1,0,6,248.84,4.94,4.94,0,0,0,8.1,255.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.19,282.68a4.95,4.95,0,1,0-6.69,2.07A5,5,0,0,0,16.19,282.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.46,286.88a3.31,3.31,0,1,0,4.45-1.38A3.31,3.31,0,0,0,13.46,286.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81,265.89a4.13,4.13,0,1,0-1.74-5.58A4.12,4.12,0,0,0,17.81,265.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7,276.11a4.13,4.13,0,0,0,1.85.45,4.1,4.1,0,0,0,1.84,2.31,4.13,4.13,0,0,0,5.64-1.51,4.13,4.13,0,0,0-1.51-5.61,4.05,4.05,0,0,0-2.11-.54,4,4,0,0,0-1.93-2.27,4.06,4.06,0,0,0-5.47,1.71A4.06,4.06,0,0,0-7,276.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.08,240.6a2.47,2.47,0,1,0,1,3.35A2.47,2.47,0,0,0,36.08,240.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.24,294a4.95,4.95,0,1,0,1.81,6.75A4.94,4.94,0,0,0,34.24,294Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,331.69a4.94,4.94,0,1,0-1.8-6.74A4.93,4.93,0,0,0,29.51,331.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85,332.78a3.3,3.3,0,1,0,1.2,4.49A3.3,3.3,0,0,0,37.85,332.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,317.75a4.11,4.11,0,1,0-1.5-5.63A4.1,4.1,0,0,0,63.71,317.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.32,300.27a4.12,4.12,0,1,0-5.63,1.52A4.11,4.11,0,0,0,17.32,300.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47,322.42A4,4,0,1,0,12,316.91,4,4,0,0,0,13.47,322.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,289.7a2.47,2.47,0,1,0,3.39-.9A2.47,2.47,0,0,0,54.38,289.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,208.72a4.08,4.08,0,1,0,1.74,5.5A4.1,4.1,0,0,0,53.5,208.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.64,334a4.12,4.12,0,1,0-1.63-5.59A4.11,4.11,0,0,0,146.64,334Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,327.22a3.35,3.35,0,1,0-1.21-4.58A3.36,3.36,0,0,0,106.45,327.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,306.52a2.53,2.53,0,0,0-.92-3.44A2.49,2.49,0,0,0-.75,304a2.49,2.49,0,0,0,.91,3.43A2.53,2.53,0,0,0,3.6,306.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,548.18a3.31,3.31,0,1,0,1.44,4.46A3.3,3.3,0,0,0,173,548.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.58,572.15a3.31,3.31,0,1,0-4.45,1.42A3.31,3.31,0,0,0,175.58,572.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71,577a2.21,2.21,0,1,0-3,1A2.2,2.2,0,0,0,177.71,577Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55,560.92a2.76,2.76,0,1,0-1.21-3.72A2.76,2.76,0,0,0,176.55,560.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7,549.25a2.76,2.76,0,1,0,1.21,3.71A2.77,2.77,0,0,0,160.7,549.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.54,563.1a2.71,2.71,0,0,0-2.46,4.82,2.71,2.71,0,0,0,2.46-4.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,544.62a1.66,1.66,0,0,0,.71,2.23,1.69,1.69,0,0,0,2.24-.72,1.66,1.66,0,1,0-2.95-1.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22,553.53a1.66,1.66,0,1,0-2.23.73A1.67,1.67,0,0,0,147.22,553.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1,538.15a2.76,2.76,0,1,0-3.72,1.19A2.76,2.76,0,0,0,151.1,538.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,465.77a3.31,3.31,0,1,0,1.7,4.35A3.3,3.3,0,0,0,181.06,465.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.34,485.16a3.32,3.32,0,1,0,1.69,4.38A3.32,3.32,0,0,0,183.34,485.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,492.46a2.21,2.21,0,1,0,2.9-1.12A2.19,2.19,0,0,0,183.42,492.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,476.86a2.76,2.76,0,1,0-3.63,1.42A2.77,2.77,0,0,0,189,476.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,293.34A2.71,2.71,0,1,0,137,292,2.71,2.71,0,0,0,133.42,293.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.24,501.66a3.31,3.31,0,1,0-4.43,1.59A3.31,3.31,0,0,0,185.24,501.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.58,522.7a3.31,3.31,0,1,0-1.56-4.4A3.32,3.32,0,0,0,182.58,522.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,527a2.2,2.2,0,1,0-1.05-2.93A2.21,2.21,0,0,0,186.33,527Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.6,509.88a2.76,2.76,0,1,0-1.32-3.68A2.76,2.76,0,0,0,187.6,509.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,502.4a2.76,2.76,0,1,0-3.68,1.31A2.77,2.77,0,0,0,172.71,502.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.37,517.4a2.7,2.7,0,1,0-1.29-3.6A2.68,2.68,0,0,0,171.37,517.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.86,493.29a1.66,1.66,0,0,0,3,1.41,1.66,1.66,0,1,0-3-1.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.06,502a1.65,1.65,0,0,0,.78,2.22,1.62,1.62,0,0,0,2.33-1.22,2.15,2.15,0,0,0,1,0,2.2,2.2,0,1,0-2.72-1.93A1.63,1.63,0,0,0,155.06,502Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43,487.93a2.75,2.75,0,0,0-1.31-3.67,3,3,0,0,0-.48-.16,2.66,2.66,0,0,0,.12-1.63,2.7,2.7,0,1,0-5.25,1.29,2.67,2.67,0,0,0,1.89,1.94,2.75,2.75,0,0,0,5,2.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,188.53a3.36,3.36,0,0,0,1.75,4.37,3.32,3.32,0,1,0-1.75-4.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,485a3.3,3.3,0,1,0-4.34,1.74A3.3,3.3,0,0,0,148.62,485Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19,490.88a2.2,2.2,0,1,0,1.73-4.05,2.2,2.2,0,0,0-1.73,4.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.94,468.71a2.75,2.75,0,1,0,1.47,3.6c0-.06,0-.12.06-.19a1.66,1.66,0,0,0,1,1.37,1.66,1.66,0,0,0,1.34-3,1.64,1.64,0,0,0-2.15.77A2.73,2.73,0,0,0,150.94,468.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,493a2.76,2.76,0,1,0,1.46,3.62A2.76,2.76,0,0,0,261,493Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,481a3.86,3.86,0,1,0-5.05,2A3.85,3.85,0,0,0,137.46,481Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,456a1.57,1.57,0,0,0-.76-.13,2.81,2.81,0,0,0-1.65-2.43,2.76,2.76,0,1,0,.33,4.89,1.65,1.65,0,1,0,2.08-2.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,450.69a2.76,2.76,0,1,0,4.94-.22l0,0a2.7,2.7,0,1,0-1.28-3.6,2.64,2.64,0,0,0,.07,2.43l-.16-.08A2.75,2.75,0,0,0,116.73,450.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.39,487.76a3.31,3.31,0,1,0-4.37,1.73A3.32,3.32,0,0,0,121.39,487.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,507.15a3.3,3.3,0,1,0-4.35,1.72A3.29,3.29,0,0,0,123.77,507.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,510.09a2.21,2.21,0,1,0,2.89-1.13A2.18,2.18,0,0,0,122.16,510.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,495.9a2.76,2.76,0,1,0-1.44-3.64A2.74,2.74,0,0,0,124,495.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,488.9a2.76,2.76,0,1,0-5-2.21C103.22,488.1,108.28,490.29,108.88,488.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,503.93a2.7,2.7,0,1,0-1.39-3.56A2.72,2.72,0,0,0,108,503.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,220.35a1.67,1.67,0,0,0,2.18-.87,1.66,1.66,0,0,0-3.05-1.31A1.68,1.68,0,0,0,161.72,220.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,489.07a1.66,1.66,0,1,0,2.19-.85A1.67,1.67,0,0,0,91.23,489.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,500.05a3.31,3.31,0,1,0,1.57,4.41A3.3,3.3,0,0,0,147.51,500.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,219.69a3.31,3.31,0,1,0-1.58-4.39A3.29,3.29,0,0,0,112.77,219.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,526.81a2.21,2.21,0,1,0,2.94-1.06A2.22,2.22,0,0,0,149.17,526.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,511.35a2.76,2.76,0,1,0-3.66,1.32A2.77,2.77,0,0,0,155.14,511.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,506.52a2.76,2.76,0,1,0-1.32-3.68A2.76,2.76,0,0,0,132.9,506.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72,497.47a1.7,1.7,0,0,0,.06-1.27,3.31,3.31,0,1,0-2.31,2h0l0,0A1.68,1.68,0,0,0,163.72,497.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,272.68A2.76,2.76,0,1,0,62.68,274,2.75,2.75,0,0,0,66.35,272.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18,531.64a3.31,3.31,0,1,0,2.86-6,3.31,3.31,0,0,0-2.86,6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,551.09a3.31,3.31,0,1,0-1.58-4.4A3.29,3.29,0,0,0,119.92,551.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,554.32a2.21,2.21,0,1,0-3,1A2.23,2.23,0,0,0,126.6,554.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,533.31a2.76,2.76,0,1,0,1.31,3.66A2.75,2.75,0,0,0,127.32,533.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.08,530.78a2.76,2.76,0,1,0-3.68,1.3A2.75,2.75,0,0,0,110.08,530.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.19,292.22a2.71,2.71,0,1,0,3.61-1.28A2.72,2.72,0,0,0,90.19,292.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,523.91a1.65,1.65,0,1,0-.79-2.2A1.64,1.64,0,0,0,135.05,523.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.17,517.58a2.72,2.72,0,0,0,3.66-1.3,2.76,2.76,0,1,0-3.66,1.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8,471.83a3.32,3.32,0,1,0-1.43-4.46A3.33,3.33,0,0,0,47.8,471.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,492.73a2.2,2.2,0,1,0,3.93,2,2.2,2.2,0,0,0-3.93-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,473.77a2.75,2.75,0,1,0,1.2,3.7A2.75,2.75,0,0,0,56.88,473.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,462.38a1.66,1.66,0,1,0,2.24-.73A1.67,1.67,0,0,0,64.15,462.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.09,469.77a1.66,1.66,0,1,0,2.23-.71A1.66,1.66,0,0,0,22.09,469.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.72,452.19a2.76,2.76,0,1,0,1.2,3.71A2.78,2.78,0,0,0,27.72,452.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.52,385.22a3.31,3.31,0,1,0,4.36-1.7A3.29,3.29,0,0,0,54.52,385.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,394.61A2.76,2.76,0,1,0,63.17,396,2.75,2.75,0,0,0,66.8,394.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.66,385.31A2.76,2.76,0,1,0,48.08,389,2.77,2.77,0,0,0,46.66,385.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.45,390.39a1.67,1.67,0,0,0-.86-2.19,1.65,1.65,0,1,0,.86,2.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,371.17a2.76,2.76,0,1,0,.32,4.88,1.65,1.65,0,1,0,2.08-2.34,1.7,1.7,0,0,0-.76-.13A2.73,2.73,0,0,0,35,371.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,434.48a3.31,3.31,0,1,0,1.58,4.41A3.29,3.29,0,0,0,63.23,434.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,440.72a2.21,2.21,0,1,0,1.06,2.94A2.2,2.2,0,0,0,66,440.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6,422.59a2.93,2.93,0,0,0-1-2.72,2.82,2.82,0,0,0-1.44-.63,3.32,3.32,0,1,0-3.24,2.08,2.92,2.92,0,0,0,1,3.08,2.88,2.88,0,0,0,3,.41,2.75,2.75,0,1,0,3.91-2.15A2.72,2.72,0,0,0,65.6,422.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,421.47a2.76,2.76,0,1,0-1.33-3.68A2.75,2.75,0,0,0,46.86,421.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,340.39a1.65,1.65,0,1,0-2.19.79A1.65,1.65,0,0,0,136.1,340.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.58,407a2.76,2.76,0,1,0-1.3-3.67A2.77,2.77,0,0,0,35.58,407Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,307.39A3.31,3.31,0,1,0,94.5,303,3.3,3.3,0,0,0,96.26,307.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,408.64a2.2,2.2,0,0,0,2.9-1.16,2.21,2.21,0,1,0-2.9,1.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,564.79a2.75,2.75,0,1,0,1.46,3.61A2.73,2.73,0,0,0,217.48,564.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86,310.92a2.77,2.77,0,1,0,1.73,3.51A2.77,2.77,0,0,0,4.86,310.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.29,398.71a3.86,3.86,0,1,0-5.06,2A3.85,3.85,0,0,0,15.29,398.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.11,407a2.75,2.75,0,0,0,1.55,2.8,2.72,2.72,0,0,0,1,.24A2.75,2.75,0,1,0,4,408.59a2.46,2.46,0,0,0-.88-.21,2.76,2.76,0,0,0-1.36-3.55,2.79,2.79,0,0,0-2.38,0,3.31,3.31,0,0,0-1.92-3.7,3.33,3.33,0,0,0-4.36,1.73,3.32,3.32,0,0,0,1.71,4.35A3.31,3.31,0,0,0-2.11,407Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.75,426.62a3.3,3.3,0,0,0,4.34-1.7,3.31,3.31,0,0,0-1.72-4.36,3.3,3.3,0,0,0-4.35,1.72A3.3,3.3,0,0,0-2.75,426.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11,430.76A2.21,2.21,0,1,0,0,427.85,2.22,2.22,0,0,0,1.11,430.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,301.29a1.66,1.66,0,1,0,.84,2.18A1.66,1.66,0,0,0,73,301.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.76,277.73a3.31,3.31,0,1,0-1.59-4.4A3.31,3.31,0,0,0,39.76,277.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,444.56a2.21,2.21,0,1,0,2.92-1.06A2.2,2.2,0,0,0,27,444.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29,430.43a2.76,2.76,0,0,0,2.35-5,2.76,2.76,0,0,0-2.35,5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.72,424.28A2.76,2.76,0,1,0,9.4,420.6,2.77,2.77,0,0,0,10.72,424.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7,437.16A3.83,3.83,0,0,0,15.87,432,3.86,3.86,0,0,0,12.46,439a1.75,1.75,0,0,0-.38.53,1.65,1.65,0,0,0,3,1.41,1.68,1.68,0,0,0-.1-1.6A3.82,3.82,0,0,0,17.7,437.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76,413a1.66,1.66,0,1,0,.78,2.21A1.66,1.66,0,0,0,40.76,413Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.13,443.42A3.33,3.33,0,0,0-5.56,445,3.32,3.32,0,0,0-4,449.4a3.31,3.31,0,0,0,4.41-1.57A3.32,3.32,0,0,0-1.13,443.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.57,462.88a3.3,3.3,0,0,0-4.4,1.57,3.33,3.33,0,0,0,1.55,4.41,3.33,3.33,0,0,0,4.42-1.57A3.3,3.3,0,0,0,.57,462.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36,469.13a2.21,2.21,0,1,0,1,2.94A2.2,2.2,0,0,0,3.36,469.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46,452.36a2.76,2.76,0,1,0,3.68-1.28A2.76,2.76,0,0,0,1.46,452.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.83,583.29a2.71,2.71,0,1,0,3.61-1.28A2.74,2.74,0,0,0,135.83,583.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.09,273.14a3.65,3.65,0,1,0,.53-5.13A3.64,3.64,0,0,0,400.09,273.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,394.37a3.66,3.66,0,1,0,.31-6.46,3.67,3.67,0,1,0-1.84,2A3.65,3.65,0,0,0,245.5,394.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,505.45a3.59,3.59,0,1,0-4.92,1.26A3.6,3.6,0,0,0,399.21,505.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.24,265.32A3.66,3.66,0,1,0,306,259a3.66,3.66,0,0,0-3.73,6.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,244.17a3.6,3.6,0,1,0-.49-5.06A3.59,3.59,0,0,0,345.67,244.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.46,345.27a3.66,3.66,0,1,0-5.16.49A3.69,3.69,0,0,0,400.46,345.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,222.32a4.39,4.39,0,1,0,.64-6.18A4.39,4.39,0,0,0,325.11,222.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.91,395.11a1.66,1.66,0,0,0,.92,2,1.64,1.64,0,0,0,1.64-.21,3.58,3.58,0,0,0,2.93-.74,3.65,3.65,0,1,0-4.6-5.67A3.63,3.63,0,0,0,399.91,395.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2,510.74a3.65,3.65,0,1,0,5-1.29A3.64,3.64,0,0,0,395.2,510.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66,390a4.4,4.4,0,1,0-.6-6.19A4.4,4.4,0,0,0,281.66,390Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.84,509.91a2.21,2.21,0,1,0,.3,3.1A2.2,2.2,0,0,0,274.84,509.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,467.79a3.68,3.68,0,0,0-.52-5.18,3.67,3.67,0,1,0,.52,5.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.26,230.68a3.61,3.61,0,1,0-.21-5.1A3.61,3.61,0,0,0,393.26,230.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,397.91a4.39,4.39,0,1,0-6.18-.65A4.4,4.4,0,0,0,291.83,397.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,406.3a4.38,4.38,0,1,0,.64-6.16A4.39,4.39,0,0,0,309.92,406.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.32,404.91a2.9,2.9,0,0,0,1.07-2.31,1.58,1.58,0,0,0,.42-.58,1.64,1.64,0,0,0-.85-2.16,1.62,1.62,0,0,0-1.44.05,2.89,2.89,0,0,0-2.88.46,2.92,2.92,0,1,0,3.68,4.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.49,393.07a3.65,3.65,0,1,0,.54-5.14A3.66,3.66,0,0,0,298.49,393.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,406.58a3.66,3.66,0,1,0,5.15.53A3.66,3.66,0,0,0,281,406.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.31,417.33a3.58,3.58,0,0,0-4.51-5.57,3.6,3.6,0,0,0-.93,1.17,2.75,2.75,0,1,0-1.74,4,2.72,2.72,0,0,0,1.6-1.11,3.41,3.41,0,0,0,.55,1A3.57,3.57,0,0,0,303.31,417.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.12,373a2.19,2.19,0,0,0,3.4-2.77,2.19,2.19,0,1,0-3.4,2.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,428.32a2.2,2.2,0,1,0-3.09-.33A2.19,2.19,0,0,0,278.67,428.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.27,411.76a3.65,3.65,0,1,0,5.14.53A3.64,3.64,0,0,0,257.27,411.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.8,501a4.4,4.4,0,1,0,1.54,6A4.4,4.4,0,0,0,277.8,501Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.73,501.05a4.39,4.39,0,1,0,1.53,6A4.41,4.41,0,0,0,303.73,501.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,498.86a3.66,3.66,0,1,0-6.3-3.74,3.66,3.66,0,0,0,6.3,3.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,516.34a3.58,3.58,0,1,0,1.26,4.92A3.59,3.59,0,0,0,295.6,516.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,484.55a2.2,2.2,0,1,0-.77-3A2.22,2.22,0,0,0,268.16,484.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.73,537.1a2.2,2.2,0,1,0,.77,3A2.19,2.19,0,0,0,276.73,537.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,535.72a3.66,3.66,0,1,0-5,1.27A3.66,3.66,0,0,0,258,535.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.44,464.44a4.41,4.41,0,1,0-.6-6.2A4.4,4.4,0,0,0,276.44,464.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.85,464.83a2.93,2.93,0,1,0-.41-4.12A2.93,2.93,0,0,0,310.85,464.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.24,479.69a3.67,3.67,0,1,0,.76-6.14,3.63,3.63,0,1,0-1.84,2A3.66,3.66,0,0,0,274.24,479.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.23,583.65a3.6,3.6,0,1,0,.48,5.06A3.62,3.62,0,0,0,325.23,583.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.09,439.62a2.2,2.2,0,0,0-3.4-2.8,2.2,2.2,0,0,0,3.4,2.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.79,496.35a2.2,2.2,0,1,0-3.11.31A2.2,2.2,0,0,0,275.79,496.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,483.86a3.67,3.67,0,1,0,.5,5.17A3.69,3.69,0,0,0,256.6,483.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.26,523a3.29,3.29,0,0,0,2.81.62,3.34,3.34,0,0,0,2.28-2,3.68,3.68,0,1,0-1.25-5.12,3.31,3.31,0,0,0-.4.93,3.33,3.33,0,0,0-2-.28,4.37,4.37,0,0,0-1.75-1.74,4.43,4.43,0,1,0,.31,7.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.83,522.13a4.42,4.42,0,1,0-1.81-6A4.44,4.44,0,0,0,341.83,522.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.53,511.62a2.95,2.95,0,1,0,1.2,4A2.93,2.93,0,0,0,352.53,511.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,509.29a3.68,3.68,0,1,0,5-1.5A3.69,3.69,0,0,0,324.56,509.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.07,532.12a3.69,3.69,0,1,0,1.51,5A3.69,3.69,0,0,0,320.07,532.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.46,551.74a2.25,2.25,0,0,0-3,.91,2.22,2.22,0,0,0,.9,3,2.19,2.19,0,0,0,3-.9A2.23,2.23,0,0,0,320.46,551.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,546.18a3.68,3.68,0,1,0,1.51,5A3.69,3.69,0,0,0,300,546.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74,492.72a4.43,4.43,0,1,0-6.1,1.39A4.43,4.43,0,0,0,378.74,492.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,484a3.68,3.68,0,1,0-5.1,1.16A3.67,3.67,0,0,0,362.51,484Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,502.61a3.7,3.7,0,1,0,1.18,5.1A3.7,3.7,0,0,0,350.19,502.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,584.63a3.62,3.62,0,1,0,1.14,5A3.62,3.62,0,0,0,396.5,584.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,468.37a2.21,2.21,0,1,0-3.05.7A2.22,2.22,0,0,0,345,468.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.94,525.31a2.21,2.21,0,1,0-3.06.7A2.21,2.21,0,0,0,349.94,525.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.91,455.51a4.44,4.44,0,0,0-5.62,0,3.28,3.28,0,0,0-3.2-1,3.31,3.31,0,1,0,1.58,6.43,3,3,0,0,0,.42-.16,4.49,4.49,0,0,0,1.21,1.58,4.43,4.43,0,0,0,5.61-6.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.11,458.66a3,3,0,0,0,4.17-.41,2.54,2.54,0,0,0,.23-.34,2.66,2.66,0,0,0,2.55.72,2.7,2.7,0,1,0-2.84-4.18,2.59,2.59,0,0,0-.37-.37,3,3,0,0,0-3.74,4.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.89,369.53a3.7,3.7,0,1,0,5.72,4.68,3.7,3.7,0,0,0-5.72-4.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,473.79a3.7,3.7,0,1,0-.52-5.21A3.71,3.71,0,0,0,321.23,473.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,490.6a2.22,2.22,0,1,0-3.14.31A2.22,2.22,0,0,0,322.86,490.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,483.27a3.69,3.69,0,1,0-5.18.52A3.69,3.69,0,0,0,304,483.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.74,430.19a3,3,0,1,0-4.16.17A3,3,0,0,0,392.74,430.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,422a3.68,3.68,0,1,0-.21-5.21A3.69,3.69,0,0,0,366.28,422Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,437.78a3.71,3.71,0,0,0-5.22.23,3.66,3.66,0,0,0,.23,5.2,3.69,3.69,0,1,0,5-5.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,400.14a2.21,2.21,0,1,0,.12,3.1A2.2,2.2,0,0,0,357,400.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,420a3.68,3.68,0,0,0,5.42,5,3.68,3.68,0,1,0-5.42-5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.36,375.18a2.75,2.75,0,1,0-3.33-2A2.75,2.75,0,0,0,346.36,375.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.3,390.14a2.75,2.75,0,0,0-3.33-2,2.78,2.78,0,0,0-2.1,2.86,2.69,2.69,0,0,0-1.15,1.27,2.76,2.76,0,1,0,5,2.24,2.65,2.65,0,0,0,.22-1.29A2.75,2.75,0,0,0,355.3,390.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,375.14a1.66,1.66,0,0,0-.79-3.22,1.66,1.66,0,0,0,.79,3.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,398.84a1.66,1.66,0,1,0,2,1.21A1.67,1.67,0,0,0,362,398.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,447.31a3.31,3.31,0,1,0-4-2.42A3.33,3.33,0,0,0,361.65,447.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,436.11a2.2,2.2,0,1,0,2.66,1.61A2.19,2.19,0,0,0,362.34,436.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.62,452.61a2.76,2.76,0,1,0-3.34-2A2.79,2.79,0,0,0,314.62,452.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,451.71a2.76,2.76,0,1,0,3.35,2A2.76,2.76,0,0,0,251.35,451.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.24,450.79a1.65,1.65,0,1,0-2-1.21A1.65,1.65,0,0,0,332.24,450.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.6,474.51a1.65,1.65,0,0,0,.79,3.21,1.65,1.65,0,0,0-.79-3.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.75,487a2.76,2.76,0,1,0-3.33-2A2.76,2.76,0,0,0,351.75,487Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.57,533.22a3.31,3.31,0,1,0,4,2.43A3.3,3.3,0,0,0,337.57,533.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,423.69a2.76,2.76,0,1,0-3.34-2A2.78,2.78,0,0,0,336.52,423.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.13,436.61a2.76,2.76,0,1,0,3.34,2A2.77,2.77,0,0,0,342.13,436.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,557.31a2.7,2.7,0,1,0,3.26,2A2.7,2.7,0,0,0,372.52,557.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.8,422.41a1.66,1.66,0,1,0,1.23-2A1.66,1.66,0,0,0,317.8,422.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.18,447.34a1.65,1.65,0,1,0,2,1.21A1.65,1.65,0,0,0,352.18,447.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.61,564.11a2.76,2.76,0,1,0,3.34,2A2.76,2.76,0,0,0,359.61,564.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.31,458.87a3.31,3.31,0,1,0-4-2.43A3.32,3.32,0,0,0,382.31,458.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.29,445.22a3.31,3.31,0,1,0-4-2.42A3.3,3.3,0,0,0,396.29,445.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,434a2.2,2.2,0,1,0,2.69,1.61A2.21,2.21,0,0,0,397,434Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.59,448.76a2.76,2.76,0,1,0-3.33-2A2.74,2.74,0,0,0,383.59,448.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.2,461.7a2.76,2.76,0,1,0,3.33,2A2.76,2.76,0,0,0,389.2,461.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,456.55a2.71,2.71,0,1,0-3.27-2A2.7,2.7,0,0,0,399.71,456.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,472.42a1.67,1.67,0,0,0-1.21,2,1.66,1.66,0,0,0,3.23-.79A1.67,1.67,0,0,0,399.24,472.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,484.92a2.75,2.75,0,1,0-3.33-2,2.71,2.71,0,0,0,.77,1.31,2.93,2.93,0,1,0,.7.49A2.69,2.69,0,0,0,386.4,484.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.84,422.44a2.75,2.75,0,1,0-2,3.34A2.74,2.74,0,0,0,403.84,422.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,335.73a3.32,3.32,0,1,0-4-2.42A3.32,3.32,0,0,0,231,335.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,531.19a3.31,3.31,0,1,0-4-2.42A3.32,3.32,0,0,0,393.43,531.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2,301.83a2.76,2.76,0,1,0-3.34-2A2.75,2.75,0,0,0,214.2,301.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,419.19a2.71,2.71,0,1,0-3.16,3.29l-.24,0a1.67,1.67,0,1,0,.82,0,2.44,2.44,0,0,0,.59-.07A2.72,2.72,0,0,0,387.73,419.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.13,412.61a1.65,1.65,0,0,0-1.51-1.24,2.07,2.07,0,0,0,0-.82,2.18,2.18,0,0,0-1.34-1.53,2.88,2.88,0,0,0-.05-1,2.76,2.76,0,1,0-2.91,3.39,1.38,1.38,0,0,0,0,.2,2.19,2.19,0,0,0,2.57,1.63,1.13,1.13,0,0,0,0,.18,1.66,1.66,0,0,0,3.22-.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.29,438.33a1.67,1.67,0,0,0-1.21,2,1.65,1.65,0,1,0,1.21-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.48,283.76a3.32,3.32,0,0,0-1.58-6.44,3.32,3.32,0,0,0,1.58,6.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,350.72a2.76,2.76,0,1,0-3.34-2A2.76,2.76,0,0,0,302.35,350.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.18,388.26a1.66,1.66,0,1,0,2,1.21A1.66,1.66,0,0,0,377.18,388.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.22,167.1a5,5,0,1,0-1.43-6.93A5,5,0,0,0,371.22,167.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.32,529.43A4.12,4.12,0,1,0,374,535,4.12,4.12,0,0,0,372.32,529.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,315.28a3.31,3.31,0,1,0-1.44-4.46A3.31,3.31,0,0,0,346,315.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39,291.31a3.31,3.31,0,1,0,4.44-1.42A3.32,3.32,0,0,0,343.39,291.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25,286.48a2.21,2.21,0,1,0,3-1A2.21,2.21,0,0,0,341.25,286.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42,302.54a2.76,2.76,0,1,0,1.2,3.72A2.76,2.76,0,0,0,342.42,302.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,314.21a2.76,2.76,0,1,0-1.2-3.72A2.77,2.77,0,0,0,358.26,314.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,300.35a2.7,2.7,0,0,0,2.47-4.81,2.7,2.7,0,1,0-2.47,4.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.62,318.84a1.64,1.64,0,0,0-.71-2.23,1.66,1.66,0,1,0-1.52,2.95A1.65,1.65,0,0,0,332.62,318.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.75,309.93a1.65,1.65,0,1,0,2.22-.73A1.65,1.65,0,0,0,371.75,309.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,325.31a2.76,2.76,0,1,0,3.72-1.2A2.75,2.75,0,0,0,367.87,325.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.28,396a3.31,3.31,0,1,0-4.38,1.7A3.31,3.31,0,0,0,342.28,396Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62,378.3a3.32,3.32,0,1,0-1.69-4.38A3.33,3.33,0,0,0,335.62,378.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.55,371a2.21,2.21,0,1,0-2.91,1.12A2.22,2.22,0,0,0,335.55,371Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,386.59a2.76,2.76,0,1,0,3.63-1.41A2.76,2.76,0,0,0,330,386.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.55,570.11A2.71,2.71,0,1,0,382,571.5,2.73,2.73,0,0,0,385.55,570.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.72,361.79a3.32,3.32,0,1,0,4.43-1.58A3.32,3.32,0,0,0,333.72,361.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,346.74a3.31,3.31,0,1,0-1.57-4.42A3.31,3.31,0,0,0,333.55,346.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.63,336.5a2.21,2.21,0,1,0,1.05,2.94A2.21,2.21,0,0,0,332.63,336.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,353.57a2.76,2.76,0,1,0,1.31,3.69A2.78,2.78,0,0,0,331.37,353.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.25,361.05a2.76,2.76,0,1,0,5,2.37,2.75,2.75,0,0,0-1.3-3.67A2.78,2.78,0,0,0,346.25,361.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29,350.94a2.7,2.7,0,1,0-1.29-3.6A2.68,2.68,0,0,0,345.29,350.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.88,371a1.66,1.66,0,1,0,1.43-3,1.68,1.68,0,0,0-2.21.79A1.65,1.65,0,0,0,319.88,371Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.91,361.44a1.65,1.65,0,1,0-3-1.41,1.57,1.57,0,0,0-.13.42,2.19,2.19,0,0,0-2.66,2.66,2.21,2.21,0,0,0,4.34-.73A1.66,1.66,0,0,0,363.91,361.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.54,375.53a2.73,2.73,0,0,0,1.31,3.66,2,2,0,0,0,.47.17,2.65,2.65,0,0,0-.11,1.63,2.7,2.7,0,1,0,3.35-3.24,2.75,2.75,0,0,0-5-2.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.68,376.67a3.31,3.31,0,1,0,1.74,4.35A3.31,3.31,0,0,0,374.68,376.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.92,375.47a2.17,2.17,0,0,0-1.14-2.89,2.2,2.2,0,1,0-1.73,4.05A2.18,2.18,0,0,0,371.92,375.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,394.75a2.75,2.75,0,1,0-1.46-3.61,1.52,1.52,0,0,0-.06.2,1.67,1.67,0,0,0-1-1.37,1.66,1.66,0,0,0-1.34,3,1.67,1.67,0,0,0,2.16-.77A2.72,2.72,0,0,0,368,394.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,370.48a2.76,2.76,0,1,0,2.17-5.08,2.76,2.76,0,1,0-2.17,5.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,382.5a3.86,3.86,0,1,0,5.06-2A3.86,3.86,0,0,0,381.5,382.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.15,407.63a2.76,2.76,0,0,0,1.65,2.42,2.75,2.75,0,1,0-.33-4.88,1.61,1.61,0,0,0-.79-.71,1.65,1.65,0,1,0-.53,3.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,412.76a2.76,2.76,0,1,0-5.07-2.16,2.78,2.78,0,0,0,.13,2.39l0,0a2.73,2.73,0,1,0,1.22,1.17l.15.09A2.75,2.75,0,0,0,402.23,412.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.58,375.69a3.31,3.31,0,1,0,4.36-1.72A3.31,3.31,0,0,0,397.58,375.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26,358.93a3.3,3.3,0,1,0-4.35,1.73A3.32,3.32,0,0,0,401.26,358.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.81,353.37a2.21,2.21,0,1,0-2.9,1.13A2.21,2.21,0,0,0,396.81,353.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,367.56a2.76,2.76,0,0,0-2.2,5.07,2.76,2.76,0,1,0,2.2-5.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47,254.17a2.76,2.76,0,1,0,5,2.21,2.76,2.76,0,0,0-5-2.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.46,363.41a3.31,3.31,0,1,0-1.58-4.41A3.29,3.29,0,0,0,371.46,363.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,336.65a2.21,2.21,0,1,0-2.94,1.05A2.2,2.2,0,0,0,369.79,336.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.83,352.11a2.76,2.76,0,1,0,3.66-1.32A2.74,2.74,0,0,0,363.83,352.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.39,360.61a2.76,2.76,0,1,0-3.69,1.32A2.75,2.75,0,0,0,387.39,360.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.53,207.35a3.86,3.86,0,1,0-1.84-5.15A3.87,3.87,0,0,0,348.53,207.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.25,366a1.61,1.61,0,0,0-.06,1.27,3.25,3.25,0,0,0-.13,2,3.31,3.31,0,1,0,2.43-4h0l-.05,0A1.65,1.65,0,0,0,355.25,366Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.78,331.82a3.31,3.31,0,1,0,1.55,4.41A3.31,3.31,0,0,0,400.78,331.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.21,318.34a3.31,3.31,0,1,0-1.57-4.42A3.33,3.33,0,0,0,396.21,318.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.37,309.14a2.21,2.21,0,1,0,2.95-1.05A2.21,2.21,0,0,0,392.37,309.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,330.15a2.76,2.76,0,1,0-1.3-3.67A2.76,2.76,0,0,0,391.64,330.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,341.75a1.66,1.66,0,1,0-2.22.78A1.66,1.66,0,0,0,384.71,341.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.86,523.07a1.66,1.66,0,1,0,3,1.41,1.65,1.65,0,0,0-.8-2.2A1.67,1.67,0,0,0,382.86,523.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.49,298.66a2.75,2.75,0,1,0-1.47-3.61A2.73,2.73,0,0,0,301.49,298.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.13,280.16a2.7,2.7,0,1,0-3.6,1.28A2.7,2.7,0,0,0,383.13,280.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.77,585.59a4.39,4.39,0,1,0,5.94-1.82A4.38,4.38,0,0,0,333.77,585.59Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.41,574.77a3.59,3.59,0,1,0-1.48-4.86A3.6,3.6,0,0,0,192.41,574.77Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,581.38a2.2,2.2,0,1,0-3,.9A2.19,2.19,0,0,0,361.35,581.38Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.49,588.29a2.2,2.2,0,1,0,3-.9A2.2,2.2,0,0,0,301.49,588.29Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.84,592.8a4.4,4.4,0,1,0-.9-6.16A4.41,4.41,0,0,0,378.84,592.8Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,584a2.2,2.2,0,1,0,.45,3.07A2.21,2.21,0,0,0,348.66,584Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,563.36a3.65,3.65,0,0,0,.73,5.12,3.67,3.67,0,1,0-.73-5.12Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.42,594.13a3.66,3.66,0,1,0,5.16.3A3.65,3.65,0,0,0,308.42,594.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,593.27a2.19,2.19,0,1,0-3.11-.16A2.19,2.19,0,0,0,294.87,593.27Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.84,575.82a3.65,3.65,0,1,0,.83-5.55,1.69,1.69,0,0,0-2,1,1.65,1.65,0,0,0,.29,1.63A3.57,3.57,0,0,0,301.84,575.82Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.22,597.47a4.39,4.39,0,1,0-1.82-6A4.4,4.4,0,0,0,213.22,597.47Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,590.87a3.68,3.68,0,1,0,1.52,5A3.66,3.66,0,0,0,201,590.87Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,587.31a2.2,2.2,0,1,0-3.88-2.06,2.2,2.2,0,0,0,3.88,2.06Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,597.21a2.2,2.2,0,1,0-.91-3A2.22,2.22,0,0,0,180,597.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,572.51A3.66,3.66,0,1,0,187,571,3.67,3.67,0,0,0,182,572.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.2,451.92a4.4,4.4,0,1,0,6.17-.9A4.39,4.39,0,0,0,302.2,451.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.24,591.1a3.67,3.67,0,1,0,6.43,1.1,1.65,1.65,0,1,0-.69-1.26,3.31,3.31,0,0,0-.6-.58A3.67,3.67,0,0,0,240.24,591.1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.45,593.06A2.2,2.2,0,1,0,280,590,2.21,2.21,0,0,0,280.45,593.06Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,451.19a2.2,2.2,0,0,0,2.64-3.52,2.23,2.23,0,0,0-3.09.43A2.2,2.2,0,0,0,179,451.19Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,574.42a3.67,3.67,0,1,0-.73-5.13A3.68,3.68,0,0,0,230.1,574.42Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,575.14a5.17,5.17,0,1,0,7.24-1.08A5.18,5.18,0,0,0,394.69,575.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21,504.71a3.69,3.69,0,1,0-5.2.47A3.71,3.71,0,0,0,24.21,504.71Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.14,456.25a4.39,4.39,0,1,0,6.2.35A4.39,4.39,0,0,0,295.14,456.25Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,487.11a4.39,4.39,0,1,0,.35-6.19A4.39,4.39,0,0,0,286.9,487.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.51,490.1a2.91,2.91,0,0,0,2.12,5.09,1.58,1.58,0,0,0,.6.4,1.64,1.64,0,0,0,2.12-1,1.6,1.6,0,0,0-.12-1.43,2.92,2.92,0,0,0-4.72-3.1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,474a3.65,3.65,0,1,0,.29-5.17A3.65,3.65,0,0,0,299.64,474Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.62,452.05a3.66,3.66,0,1,0-.29,5.17A3.66,3.66,0,0,0,285.62,452.05Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,475.12a3.56,3.56,0,0,0-.92-5.94,2.75,2.75,0,1,0-4.09-1.54,2.7,2.7,0,0,0,1.2,1.54,3.57,3.57,0,1,0,3.81,5.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.52,458.57a2.19,2.19,0,0,0,2.92,3.27,2.19,2.19,0,1,0-2.92-3.27Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,450.9a2.19,2.19,0,1,0-3.1-.16A2.18,2.18,0,0,0,266.89,450.9Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.87,433.44a3.65,3.65,0,1,0,.3-5.15A3.65,3.65,0,0,0,273.87,433.44Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,455.1a4.4,4.4,0,1,0-1.82-6A4.39,4.39,0,0,0,185.25,455.1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.38,481a4.39,4.39,0,1,0-1.81-5.93A4.4,4.4,0,0,0,186.38,481Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,462.8a3.66,3.66,0,1,0-5,1.52A3.67,3.67,0,0,0,198.77,462.8Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,466.94a3.56,3.56,0,0,0-4.84,1.48,3.59,3.59,0,1,0,4.84-1.48Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,442a2.2,2.2,0,1,0,.9,3A2.2,2.2,0,0,0,210.12,442Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.12,451a2.19,2.19,0,1,0,.91,3A2.17,2.17,0,0,0,154.12,451Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,435.09a3.66,3.66,0,1,0-1.5-4.94A3.66,3.66,0,0,0,155.53,435.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,456.37a4.41,4.41,0,1,0-.9-6.17A4.41,4.41,0,0,0,228.5,456.37Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.29,550a4.4,4.4,0,1,0,.89,6.18A4.4,4.4,0,0,0,24.29,550Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.53,488.11a2.93,2.93,0,1,0-4.1.59A2.93,2.93,0,0,0,233.53,488.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.27,448.73a3.67,3.67,0,1,0,6.16.47,3.64,3.64,0,1,0-2.08-1.75A3.65,3.65,0,0,0,212.27,448.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,504.55a3.6,3.6,0,1,0-5,.72A3.61,3.61,0,0,0,110.82,504.55Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.55,450.24a2.2,2.2,0,1,0-3.08.44A2.2,2.2,0,0,0,255.55,450.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,448a2.2,2.2,0,1,0,3.07-.43A2.19,2.19,0,0,0,195.25,448Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.28,431.3a3.67,3.67,0,1,0-5.14.75A3.66,3.66,0,0,0,207.28,431.3Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,522a4.42,4.42,0,1,0-5.9,2.08A4.42,4.42,0,0,0,181,522Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.73,525.89a3,3,0,1,0,3.92-1.38A3,3,0,0,0,178.73,525.89Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,507a3.68,3.68,0,1,0-1.74-4.91A3.69,3.69,0,0,0,181.89,507Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.39,493.79a3.69,3.69,0,1,0,4.92-1.74A3.69,3.69,0,0,0,155.39,493.79Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.52,499.33a2.21,2.21,0,1,0-1.05-3A2.23,2.23,0,0,0,139.52,499.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.15,479.34a3.68,3.68,0,1,0-1.73-4.91A3.68,3.68,0,0,0,142.15,479.34Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.21,552.05a4.43,4.43,0,1,0-6.05,1.67A4.44,4.44,0,0,0,210.21,552.05Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.12,535.69a3.69,3.69,0,1,0-5,1.41A3.67,3.67,0,0,0,217.12,535.69Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,525.67a3.7,3.7,0,1,0-5,1.41A3.7,3.7,0,0,0,193,525.67Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27,577.16a3.62,3.62,0,1,0-1.37-4.93A3.6,3.6,0,0,0,108.27,577.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.91,518a2.21,2.21,0,1,0-3,.83A2.21,2.21,0,0,0,229.91,518Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.26,526.49a2.21,2.21,0,1,0-.84-3A2.2,2.2,0,0,0,170.26,526.49Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29,505.28a3.68,3.68,0,0,0-1.4-5,3.94,3.94,0,0,0-.95-.36,3.24,3.24,0,0,0,.18-2,4.34,4.34,0,0,0,1.65-1.84,4.42,4.42,0,1,0-7.55.67,3.28,3.28,0,0,0,1.61,5,3.68,3.68,0,0,0,6.46,3.53Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,529.08a4.44,4.44,0,0,0,6-6.52,3.31,3.31,0,1,0-5.52-1.37,3.07,3.07,0,0,0,.17.42,4.5,4.5,0,0,0-1.52,1.27A4.44,4.44,0,0,0,234,529.08Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.72,377.42a3.7,3.7,0,1,0-5.18.78A3.68,3.68,0,0,0,319.72,377.42Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.31,499.8a3.7,3.7,0,1,0-5.17.78A3.68,3.68,0,0,0,226.31,499.8Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.14,568.65a5.18,5.18,0,1,0-1.08-7.26A5.19,5.19,0,0,0,66.14,568.65Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.17,585.09a2.22,2.22,0,1,0,.45,3.1A2.21,2.21,0,0,0,101.17,585.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,497.8a2.22,2.22,0,1,0-.46-3.11A2.19,2.19,0,0,0,203.66,497.8Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.09,478.59a3.69,3.69,0,1,0-.76-5.15A3.68,3.68,0,0,0,210.09,478.59Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.29,564.77a3,3,0,1,0-.36-4.16A3,3,0,0,0,267.29,564.77Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.68,543.14a3.68,3.68,0,1,0-.46-5.19A3.66,3.66,0,0,0,274.68,543.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.78,528.93a3.69,3.69,0,1,0-.46-5.19A3.7,3.7,0,0,0,252.78,528.93Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.63,527.66a2.21,2.21,0,1,0-3.1.27A2.21,2.21,0,0,0,295.63,527.66Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,353.18a3.68,3.68,0,1,0,.47,5.19A3.68,3.68,0,0,0,267.52,353.18Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,528.38a3.3,3.3,0,0,0,6.33-1.88h0l0,0a1.67,1.67,0,0,0-.89-2.16,1.72,1.72,0,0,0-1.28,0,3.3,3.3,0,0,0-4.19,4.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.05,515.85a2.75,2.75,0,1,0,1.86-3.42A2.76,2.76,0,0,0,320.05,515.85Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.39,522.06a2.76,2.76,0,0,0-2.95-2,2.66,2.66,0,0,0-1.33-1.09,2.76,2.76,0,1,0-2,5.14,2.62,2.62,0,0,0,1.29.16,2.76,2.76,0,0,0,5-2.25Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.39,534.14a2.7,2.7,0,0,0,1.86-2,2.75,2.75,0,0,0,2-5.13,2.73,2.73,0,0,0-3.59,1.48,2.21,2.21,0,0,0-.15.48,2.66,2.66,0,0,0-1.63,0,2.7,2.7,0,1,0,1.53,5.18Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.38,500.27a1.65,1.65,0,1,0-2.07-1.11A1.67,1.67,0,0,0,321.38,500.27Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.05,534.67a1.66,1.66,0,1,0-2.08-1.12A1.67,1.67,0,0,0,296.05,534.67Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.07,532.64a3.31,3.31,0,1,0-2.23,4.11A3.32,3.32,0,0,0,255.07,532.64Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46,537.41a2.2,2.2,0,1,0-2.74-1.48A2.2,2.2,0,0,0,258.46,537.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66,489.66a2.76,2.76,0,1,0-3.44-1.88A2.77,2.77,0,0,0,244.66,489.66Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,428a2.77,2.77,0,1,0-3.43-1.88A2.77,2.77,0,0,0,237.27,428Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.58,538.45a2.7,2.7,0,1,0,5.17-1.53,2.65,2.65,0,0,0-1.13-1.5A2.11,2.11,0,0,0,242,535a3,3,0,1,0-4.15.62,2.24,2.24,0,0,0,.36.21A2.68,2.68,0,0,0,237.58,538.45Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,506.41a1.66,1.66,0,1,0-2.06-1.11A1.66,1.66,0,0,0,245.92,506.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.64,537.63a1.65,1.65,0,1,0,2.06,1.12A1.66,1.66,0,0,0,219.64,537.63Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,528.37a2.76,2.76,0,1,0-3.43-1.88A2.78,2.78,0,0,0,212,528.37Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.78,514.5a3.31,3.31,0,1,0-2.24,4.13A3.31,3.31,0,0,0,161.78,514.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.48,522.32a2.7,2.7,0,0,0,1-.1,2.75,2.75,0,1,0-3.52-2.75l-.21,0a2.19,2.19,0,0,0-1.5,2.65.86.86,0,0,0-.17,0,1.66,1.66,0,1,0,2.11,1.62,2.31,2.31,0,0,0,.82-.08A2.17,2.17,0,0,0,286.48,522.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.43,506.73a2.76,2.76,0,1,0-1.85,3.44A2.76,2.76,0,0,0,276.43,506.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.63,518a2.76,2.76,0,1,0-3.43-1.86A2.75,2.75,0,0,0,256.63,518Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.53,553.9a2.7,2.7,0,1,0-3.35-1.82A2.69,2.69,0,0,0,137.53,553.9Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,492.73a1.66,1.66,0,1,0-2.06-1.11A1.65,1.65,0,0,0,272.48,492.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.14,527.11a1.65,1.65,0,1,0-2.06-1.11A1.63,1.63,0,0,0,247.14,527.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,541.41a2.76,2.76,0,1,0-3.42-1.87A2.76,2.76,0,0,0,130.09,541.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,555.69a3.31,3.31,0,1,0,2.23-4.11A3.32,3.32,0,0,0,238.15,555.69Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.78,567.14a3.31,3.31,0,1,0-2.23,4.11A3.31,3.31,0,0,0,258.78,567.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.18,571.93a2.21,2.21,0,1,0-2.75-1.5A2.21,2.21,0,0,0,262.18,571.93Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,558.35a2.75,2.75,0,1,0-3.43-1.85A2.74,2.74,0,0,0,251.73,558.35Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.22,560.84a2.76,2.76,0,1,0,3.43,1.87A2.77,2.77,0,0,0,232.22,560.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.48,571.43a2.71,2.71,0,1,0-1.83,3.36A2.71,2.71,0,0,0,246.48,571.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4,500.09A1.65,1.65,0,1,0,66.34,499,1.66,1.66,0,0,0,68.4,500.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,575.32a1.66,1.66,0,1,0-2.07-1.13A1.67,1.67,0,0,0,224.3,575.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,562.87a2.75,2.75,0,1,0-2.84-4.46,2.92,2.92,0,1,0-.46.73,2.74,2.74,0,0,0,3.3,3.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6,584.28a3.81,3.81,0,0,0-.31-.71,1.65,1.65,0,0,0-1.24-3.05,1.67,1.67,0,0,0-1.19,1.43,3.25,3.25,0,0,0-1.38.1,3.3,3.3,0,1,0,4.12,2.23Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,589.07a2.21,2.21,0,1,0-2.74-1.5A2.22,2.22,0,0,0,286,589.07Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,570.21a2.75,2.75,0,1,0,3.43,1.86A2.75,2.75,0,0,0,274,570.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,583.27a2.75,2.75,0,1,0-3.43-1.85A2.74,2.74,0,0,0,257.6,583.27Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,591.93a2.71,2.71,0,1,0-3.35-1.82A2.7,2.7,0,0,0,268.46,591.93Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,574.73a2.75,2.75,0,1,0,3.43,1.85A2.75,2.75,0,0,0,238,574.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,394.68a3.32,3.32,0,1,0,4.12,2.24A3.31,3.31,0,0,0,356.27,394.68Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.78,568.33a3.31,3.31,0,1,0-2.24,4.1A3.32,3.32,0,0,0,172.78,568.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,382.24a2.75,2.75,0,1,0-3.43-1.86A2.75,2.75,0,0,0,390.53,382.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,559.24a2.71,2.71,0,1,0-3.43-3,1,1,0,0,0-.05-.25,1.68,1.68,0,1,0,0,.82,2.43,2.43,0,0,0,.1.59A2.71,2.71,0,0,0,278,559.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,556.59a1.65,1.65,0,1,0,2.05,1.12A1.66,1.66,0,0,0,256.75,556.59Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.84,555.19a2.76,2.76,0,1,0-3.42-1.87A2.76,2.76,0,0,0,79.84,555.19Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35,577.56a2.21,2.21,0,1,0-1.48,2.75A2.2,2.2,0,0,0,321.35,577.56Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42,470.73a2.76,2.76,0,1,0,1.85-3.42A2.75,2.75,0,0,0,342.42,470.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.33,549.3a1.65,1.65,0,1,0-2.07-1.11A1.65,1.65,0,0,0,307.33,549.3Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19,549a4.12,4.12,0,1,0-5.51,1.89A4.11,4.11,0,0,0,167.19,549Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.77,590.94a3.34,3.34,0,1,0-1.43-4.51A3.34,3.34,0,0,0,157.77,590.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,517a3.32,3.32,0,1,0-1.65-4.39A3.32,3.32,0,0,0,381.52,517Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,510.57a3.31,3.31,0,1,0,4.39-1.63A3.32,3.32,0,0,0,399.3,510.57Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.05,504.85a2.73,2.73,0,0,0-3.64,1.36,2.76,2.76,0,1,0,3.64-1.36Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.55,527.15a2.76,2.76,0,1,0-3.66,1.38A2.78,2.78,0,0,0,386.55,527.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,526a2.7,2.7,0,1,0-1.35-3.57A2.7,2.7,0,0,0,396.62,526Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.88,498.66a1.66,1.66,0,1,0-3-1.38,1.66,1.66,0,0,0,3,1.38Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,541.16a1.66,1.66,0,1,0-.81-2.21A1.65,1.65,0,0,0,385.06,541.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.88,535a2.76,2.76,0,1,0,1.37,3.66A2.77,2.77,0,0,0,370.88,535Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.17,508.46a3.31,3.31,0,1,0,4.27-1.9A3.31,3.31,0,0,0,297.17,508.46Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.62,507.65a3.31,3.31,0,1,0-4.27,1.9A3.3,3.3,0,0,0,322.62,507.65Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,504.85a2.21,2.21,0,1,0-1.25-2.85A2.22,2.22,0,0,0,323.72,504.85Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.31,501.62a2.76,2.76,0,1,0,3.57-1.59A2.76,2.76,0,0,0,304.31,501.62Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.18,564.16a2.71,2.71,0,1,0-1.56-3.51A2.71,2.71,0,0,0,127.18,564.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,534.88a2.78,2.78,0,0,0-.29-2.53,1.65,1.65,0,1,0-2.43-2,1.72,1.72,0,0,0-.09.77,2.75,2.75,0,1,0,2.81,3.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,504.38a3.31,3.31,0,1,0,4.32-1.78A3.32,3.32,0,0,0,328.51,504.38Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,506a3.3,3.3,0,1,0-1.78-4.31A3.31,3.31,0,0,0,349.65,506Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,498.62a2.2,2.2,0,1,0,2.87-1.19A2.19,2.19,0,0,0,354,498.62Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.32,501.34a2.76,2.76,0,1,0-1.48-3.61A2.76,2.76,0,0,0,337.32,501.34Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.54,516.57a2.76,2.76,0,1,0,3.62-1.49A2.76,2.76,0,0,0,330.54,516.57Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.21,515.71a2.7,2.7,0,1,0-3.54,1.46A2.71,2.71,0,0,0,349.21,515.71Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.08,490.48a1.67,1.67,0,0,0-.89-2.16,1.66,1.66,0,1,0,.89,2.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87,529.68a1.53,1.53,0,0,0-.42-.11,2.25,2.25,0,0,0,0-1,2.21,2.21,0,1,0-1.81,2.8,1.65,1.65,0,1,0,2.27-1.66Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.69,541.91A3.31,3.31,0,1,0,318,540,3.3,3.3,0,0,0,313.69,541.91Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,541.4a2.17,2.17,0,0,0,2.83-1.29A2.2,2.2,0,1,0,321,541.4Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.06,536.78a1.39,1.39,0,0,0-.19-.06,1.64,1.64,0,0,0,1.31-1,1.66,1.66,0,1,0-2.22.93,2.75,2.75,0,1,0,1.1.17Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.14,425.67a2.76,2.76,0,1,0,1.63,3.56A2.75,2.75,0,0,0,324.14,425.67Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69,558.52a3.86,3.86,0,1,0-2.27-5A3.88,3.88,0,0,0,311.69,558.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.14,573.43a2.76,2.76,0,1,0-.45-4.93l0,0a2.74,2.74,0,1,0-1.11,1.27.8.8,0,0,0-.08.16A2.76,2.76,0,0,0,285.14,573.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.69,569A3.31,3.31,0,1,0,322,567,3.3,3.3,0,0,0,317.69,569Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,569.92a3.3,3.3,0,1,0-1.93-4.26A3.32,3.32,0,0,0,338.87,569.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.07,563.93a2.2,2.2,0,1,0-2.85,1.28A2.19,2.19,0,0,0,347.07,563.93Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,564a2.76,2.76,0,0,0-5.16-1.95A2.76,2.76,0,1,0,330,564Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,583a2.76,2.76,0,1,0-3.56,1.6A2.76,2.76,0,0,0,325.27,583Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.17,576.13a2.7,2.7,0,1,0,1.56,3.5A2.71,2.71,0,0,0,337.17,576.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8,540.3a1.67,1.67,0,0,0,2.13-1,1.65,1.65,0,1,0-2.13,1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,595a1.68,1.68,0,0,0,.95,2.14,1.66,1.66,0,1,0,1.19-3.09A1.68,1.68,0,0,0,323.72,595Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,540.37a3.31,3.31,0,1,0,4.34-1.79A3.3,3.3,0,0,0,333,540.37Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,588.25A3.31,3.31,0,1,0,50.27,590,3.3,3.3,0,0,0,54.58,588.25Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.33,533.37a2.2,2.2,0,1,0,1.2,2.88A2.21,2.21,0,0,0,361.33,533.37Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.92,532.21a2.76,2.76,0,1,0,1.49,3.6A2.76,2.76,0,0,0,343.92,532.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.66,551a2.76,2.76,0,1,0,1.48,3.61A2.75,2.75,0,0,0,338.66,551Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,568.17a3.31,3.31,0,1,0-4.33,1.76A3.31,3.31,0,0,0,365.93,568.17Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.28,565.52a3.31,3.31,0,1,0-4.32,1.79A3.31,3.31,0,0,0,385.28,565.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.3,559.89a2.21,2.21,0,1,0,4.07,1.71,2.21,2.21,0,1,0-4.07-1.71Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.25,561.09a2.75,2.75,0,1,0-3.6,1.49A2.74,2.74,0,0,0,372.25,561.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.93,579.92a2.76,2.76,0,1,0-3.62,1.48A2.77,2.77,0,0,0,366.93,579.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.42,551.69a1.65,1.65,0,1,0-2.16.89A1.65,1.65,0,0,0,357.42,551.69Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,591.79a1.66,1.66,0,0,0,3.07,1.28,1.65,1.65,0,0,0-.9-2.16,1.4,1.4,0,0,0-.35-.1,3.67,3.67,0,1,0-4.17-5.66,3.66,3.66,0,0,0,3.08,5.86A1.68,1.68,0,0,0,365,591.79Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,589.7a2.75,2.75,0,1,0,5.08,2.12,2.75,2.75,0,1,0-5.08-2.12Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.05,559.27a1.65,1.65,0,1,0,.89,2.16A1.67,1.67,0,0,0,174.05,559.27Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,600.62a3.31,3.31,0,1,0-4.26,2A3.31,3.31,0,0,0,143,600.62Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,471a2.76,2.76,0,1,0-1.62-3.54A2.75,2.75,0,0,0,396,471Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.49,270.77a4.39,4.39,0,1,0-6.21-.35A4.4,4.4,0,0,0,73.49,270.77Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.19,245.76a4.38,4.38,0,1,0,.35-6.2A4.38,4.38,0,0,0,75.19,245.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.11,236.91a2.92,2.92,0,1,0-4.12-.22A2.92,2.92,0,0,0,79.11,236.91Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,253a3.67,3.67,0,1,0-.3,5.17A3.67,3.67,0,0,0,69,253Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,275.26A3.66,3.66,0,1,0,83,275,3.66,3.66,0,0,0,88.18,275.26Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,257.24a3.58,3.58,0,1,0-5-.28A3.57,3.57,0,0,0,92.41,257.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.27,265.35a2.19,2.19,0,0,0-3.09-.18,2.2,2.2,0,1,0,3.09.18Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.73,276.11a2.2,2.2,0,1,0,3.11.17A2.2,2.2,0,0,0,101.73,276.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.31,298.45a3.65,3.65,0,1,0,.28-5.16A3.67,3.67,0,0,0,89.31,298.45Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,277.86a4.39,4.39,0,1,0-5.95,1.83A4.38,4.38,0,0,0,185.2,277.86Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.25,246a4.39,4.39,0,1,0,1.81,5.93A4.4,4.4,0,0,0,182.25,246Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,240.43a2.22,2.22,0,1,0-1.09,2.7,2.92,2.92,0,0,0,5.47,1,2.94,2.94,0,0,0-1.2-4A2.91,2.91,0,0,0,174.37,240.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.36,173a3.67,3.67,0,1,0,1.52,5A3.65,3.65,0,0,0,239.36,173Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.55,288.69a3.59,3.59,0,1,0,1.49,4.85A3.6,3.6,0,0,0,326.55,288.69Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,282.08a2.2,2.2,0,1,0,3-.91A2.21,2.21,0,0,0,157.61,282.08Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,275.16a2.2,2.2,0,1,0-3,.9A2.2,2.2,0,0,0,217.48,275.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,396.85a3.66,3.66,0,1,0-6.46-3.43,3.66,3.66,0,0,0,6.46,3.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,270.66a4.4,4.4,0,1,0,.9,6.16A4.39,4.39,0,0,0,140.12,270.66Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09,238.92a2.93,2.93,0,1,0,4.1-.6A2.92,2.92,0,0,0,135.09,238.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.17,252.51a3.67,3.67,0,1,0-.75-5.13A3.65,3.65,0,0,0,115.17,252.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.08,354.46a3.6,3.6,0,1,0-5,.72A3.59,3.59,0,0,0,68.08,354.46Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.15,276.33a2.22,2.22,0,0,0-3.07.45,2.2,2.2,0,1,0,3.07-.45Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.31,279.5a2.2,2.2,0,1,0-.45-3.08A2.2,2.2,0,0,0,170.31,279.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,300.1a3.65,3.65,0,0,0-.73-5.13,3.67,3.67,0,1,0-4.38,5.88A3.65,3.65,0,0,0,167.22,300.1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.69,210.87a4.41,4.41,0,1,0-2.1-5.89A4.42,4.42,0,0,0,189.69,210.87Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,202.51a2.94,2.94,0,1,0-1.4-3.92A2.93,2.93,0,0,0,186,202.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.73,220a3.68,3.68,0,1,0,1.75,4.91A3.67,3.67,0,0,0,186.73,220Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.38,151.62a5.16,5.16,0,1,0-2.43-6.88A5.16,5.16,0,0,0,186.38,151.62Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.58,207.15a4.43,4.43,0,1,0-1.68-6.05A4.44,4.44,0,0,0,160.58,207.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.42,175a4.43,4.43,0,1,0,6-1.67A4.44,4.44,0,0,0,158.42,175Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,168.37a3,3,0,1,0,4-1.13A2.94,2.94,0,0,0,155.83,168.37Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.93,195a3.69,3.69,0,1,0-5,1.38A3.69,3.69,0,0,0,157.93,195Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,201.33a3.7,3.7,0,1,0,5.05-1.39A3.71,3.71,0,0,0,175.67,201.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,181.44a3.62,3.62,0,1,0,1.37,4.92A3.63,3.63,0,0,0,178.93,181.44Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,208.16a2.22,2.22,0,1,0,.84,3A2.23,2.23,0,0,0,141.72,208.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,204.39a2.22,2.22,0,1,0-.84-3A2.21,2.21,0,0,0,196.19,204.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81,223.82a3.65,3.65,0,0,0-1.28-3.23,3.54,3.54,0,0,0-1.57-.76,3.62,3.62,0,0,0,1.48-1.16,3.7,3.7,0,1,0-5.17.75,3.66,3.66,0,0,0,1.39.64,3.8,3.8,0,0,0-1.33,1,3.68,3.68,0,0,0,4.54,5.62,4.44,4.44,0,1,0,1.94-2.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,198.85a4.44,4.44,0,1,0,6.2-.92A4.44,4.44,0,0,0,128.41,198.85Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,196.12a3,3,0,1,0-.63-4.14A3,3,0,0,0,127.28,196.12Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,231.63a3.71,3.71,0,1,0-5.18.76A3.7,3.7,0,0,0,148.25,231.63Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,125.72a5.18,5.18,0,1,0-1.07-7.25A5.18,5.18,0,0,0,255.24,125.72Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.58,230.26a2.22,2.22,0,1,0,3.1-.47A2.22,2.22,0,0,0,104.58,230.26Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,229.22a2.22,2.22,0,1,0,.46,3.12A2.23,2.23,0,0,0,165,229.22Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,254.36a3.7,3.7,0,1,0-.79-5.17A3.69,3.69,0,0,0,154.14,254.36Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,195.28a4.42,4.42,0,1,0,6.23-.55A4.42,4.42,0,0,0,94.23,195.28Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.52,169.55a4.42,4.42,0,1,0,6.21-.53A4.43,4.43,0,0,0,98.52,169.55Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,166.78a3,3,0,1,0-.38-4.14A3,3,0,0,0,97.55,166.78Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.22,189.53a3.68,3.68,0,1,0-.46-5.18A3.69,3.69,0,0,0,89.22,189.53Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.65,198.56a3.69,3.69,0,1,0,5.2-.46A3.69,3.69,0,0,0,110.65,198.56Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,185.17a3.62,3.62,0,1,0-.44-5.09A3.61,3.61,0,0,0,112.81,185.17Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,202.48a2.21,2.21,0,1,0-.28-3.12A2.21,2.21,0,0,0,73.27,202.48Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.57,369.83A4.39,4.39,0,0,0,41,375.68a4.43,4.43,0,0,0,6.2.35A4.39,4.39,0,0,0,47.57,369.83Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.75,240.16a4.38,4.38,0,0,0-5.53-6.78,4.36,4.36,0,0,0-.28-2.15,2.92,2.92,0,0,0,3.79-4.38,2.92,2.92,0,0,0-5,2.69,4.41,4.41,0,0,0-1-.67,4.21,4.21,0,0,0-1.17-.34,3.32,3.32,0,0,0,1.49-1.56,3.24,3.24,0,0,0,.05-2.59,3.68,3.68,0,1,0-6.34,1.57,3.28,3.28,0,0,0,1.91,2.67,4,4,0,0,0,.49.17,4.35,4.35,0,0,0-2.33,2.16,4.42,4.42,0,0,0,6.63,5.45,4.37,4.37,0,0,0,7.27,3.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,251.91a3.65,3.65,0,1,0,.29-5.16A3.63,3.63,0,0,0,185.91,251.91Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.55,269.33a3.67,3.67,0,1,0-5.17-.3A3.67,3.67,0,0,0,210.55,269.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,246a3.58,3.58,0,0,0,3.69,6,2.86,2.86,0,0,0,.35.18,3.31,3.31,0,1,0,2.37-6.18,3.2,3.2,0,0,0-1.83-.15A3.57,3.57,0,0,0,210,246Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.37,262.33a2.2,2.2,0,0,0,3.29-2.91,2.23,2.23,0,0,0-3.11-.18A2.19,2.19,0,0,0,168.37,262.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,270.18a2.19,2.19,0,1,0,2.93,3.26,2.19,2.19,0,1,0-2.93-3.26Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.13,287.64a3.65,3.65,0,1,0-.83,5.54,1.66,1.66,0,0,0,2-1,1.64,1.64,0,0,0-.28-1.63A3.64,3.64,0,0,0,217.13,287.64Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.75,266a4.4,4.4,0,1,0,1.82,5.94A4.4,4.4,0,0,0,305.75,266Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.63,240.08a4.4,4.4,0,1,0,1.81,5.94A4.4,4.4,0,0,0,304.63,240.08Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.18,256.77a3.58,3.58,0,0,0-3.17-.1,2.26,2.26,0,0,0-.08-.51,2.21,2.21,0,1,0-2,2.81,3.66,3.66,0,1,0,5.22-2.2Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,272.58a3.67,3.67,0,1,0-1.51-5A3.66,3.66,0,0,0,318,272.58Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.32,249.3a3.59,3.59,0,1,0,4.86-1.49A3.58,3.58,0,0,0,314.32,249.3Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,276.14a2.2,2.2,0,1,0,3-.9A2.19,2.19,0,0,0,280,276.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.93,266.24a2.2,2.2,0,1,0,.92,3A2.23,2.23,0,0,0,338.93,266.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,290.94a3.66,3.66,0,1,0-4.94,1.51A3.66,3.66,0,0,0,337,290.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,411.54a4.4,4.4,0,1,0-6.16.89A4.39,4.39,0,0,0,216.76,411.54Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.42,254.29a3.66,3.66,0,1,0,.74,5.13A3.66,3.66,0,0,0,255.42,254.29Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.73,272.35a3.67,3.67,0,1,0-6.44-1.1,1.65,1.65,0,0,0-2.55,1.82,1.68,1.68,0,0,0,2.06,1.12,1.66,1.66,0,0,0,1.18-1.67,3.73,3.73,0,0,0,.61.58A3.67,3.67,0,0,0,278.73,272.35Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.52,270.39a2.24,2.24,0,0,0-3.08.44,2.21,2.21,0,1,0,3.08-.44Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.3,415.78a2.2,2.2,0,1,0-.45-3.07A2.21,2.21,0,0,0,337.3,415.78Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87,289a3.67,3.67,0,1,0,.72,5.14A3.68,3.68,0,0,0,288.87,289Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.11,222.94a4.42,4.42,0,1,0,2.1,5.89A4.39,4.39,0,0,0,318.11,222.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,199a4.42,4.42,0,1,0,5.9-2.06A4.42,4.42,0,0,0,310,199Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,192.65a2.95,2.95,0,1,0,3.93-1.4A2.95,2.95,0,0,0,306.94,192.65Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.11,214.05a3.68,3.68,0,1,0,1.73,4.92A3.69,3.69,0,0,0,309.11,214.05Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,224.11a3.69,3.69,0,1,0,4.91-1.74A3.67,3.67,0,0,0,329,224.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6,233.24a2.18,2.18,0,0,0-2.93,1,2.19,2.19,0,0,0,3,2.92,2.89,2.89,0,0,0,1.52,2.19,2.93,2.93,0,1,0-.43-4.89A2.15,2.15,0,0,0,295.6,233.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.47,221.76a2.19,2.19,0,0,0-2.93,1,2.21,2.21,0,1,0,4,1.91A2.19,2.19,0,0,0,351.47,221.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.92,243.47a3.71,3.71,0,0,0,1.76,4.92,3.68,3.68,0,1,0-1.76-4.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.24,161.32a3,3,0,1,0,1.12,4A3,3,0,0,0,282.24,161.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.09,194a3.69,3.69,0,1,0,1.4,5A3.69,3.69,0,0,0,303.09,194Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.3,175.51a3.62,3.62,0,1,0,1.37,4.93A3.62,3.62,0,0,0,301.3,175.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74,194.6a2.21,2.21,0,0,0-2.18,3.85,2.23,2.23,0,0,0,3-.83A2.2,2.2,0,0,0,320.74,194.6Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.73,214.39a3.69,3.69,0,1,0,1.4,5A3.69,3.69,0,0,0,316.73,214.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,186a3,3,0,1,0,4.15-.62A3,3,0,0,0,249,186Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.64,103.56a3.7,3.7,0,1,0-.75-5.16A3.69,3.69,0,0,0,294.64,103.56Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,288.32A5.17,5.17,0,1,0,117,289.4,5.17,5.17,0,0,0,124.28,288.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,227a2.22,2.22,0,1,0-3.11.46c.07.06.15.09.22.14a2.18,2.18,0,0,0-1.47,1.19,2.21,2.21,0,0,0,4,1.91,2.2,2.2,0,0,0-.88-2.87A2.18,2.18,0,0,0,230.52,227Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.23,223.75a2.22,2.22,0,1,0,3.11-.46A2.21,2.21,0,0,0,284.23,223.75Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,189.35a4.42,4.42,0,1,0,6.22-.56A4.41,4.41,0,0,0,216.6,189.35Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.89,163.62a4.42,4.42,0,1,0,6.22-.54A4.41,4.41,0,0,0,220.89,163.62Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.93,160.84a2.95,2.95,0,1,0-.38-4.15A3,3,0,0,0,219.93,160.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.31,177.94a3.68,3.68,0,1,0,.47,5.2A3.69,3.69,0,0,0,216.31,177.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.91,302.48a3.61,3.61,0,1,0,.45,5.08A3.6,3.6,0,0,0,51.91,302.48Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,196.26a2.2,2.2,0,1,0-3.38-2.83,2.2,2.2,0,1,0,3.38,2.83Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72,215.12a3.67,3.67,0,0,0,4.52,5.61,4.44,4.44,0,1,0,1.95-2.85,3.67,3.67,0,0,0-6.47-2.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82,407.21a4.39,4.39,0,1,0-6.2-.35A4.4,4.4,0,0,0,223.82,407.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,382.2a4.38,4.38,0,1,0,.35-6.2A4.38,4.38,0,0,0,225.53,382.2Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.33,373.11a2.92,2.92,0,1,0,2-4.85,1.88,1.88,0,0,0-.6-.39,1.64,1.64,0,0,0-2.13.95,1.68,1.68,0,0,0,.12,1.44A2.89,2.89,0,0,0,225.33,373.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33,389.41a3.66,3.66,0,1,0-.29,5.17A3.65,3.65,0,0,0,219.33,389.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.35,411.41a3.66,3.66,0,1,0,.29-5.18A3.67,3.67,0,0,0,233.35,411.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,388.33a3.57,3.57,0,0,0,.91,5.94,2.75,2.75,0,1,0,4.09,1.55,2.78,2.78,0,0,0-1.19-1.55,3.46,3.46,0,0,0,1-.59,3.58,3.58,0,0,0-4.77-5.35Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,404.89a2.19,2.19,0,1,0-3.1-.17A2.18,2.18,0,0,0,199.44,404.89Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.89,415.65a2.2,2.2,0,1,0,.18-3.1A2.21,2.21,0,0,0,251.89,415.65Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.09,430a3.65,3.65,0,1,0-.3,5.14A3.64,3.64,0,0,0,245.09,430Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.72,408.35a4.4,4.4,0,1,0,1.82,6A4.4,4.4,0,0,0,333.72,408.35Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.59,382.46a4.39,4.39,0,1,0,1.81,5.93A4.38,4.38,0,0,0,332.59,382.46Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,400.65a3.67,3.67,0,1,0,5-1.51A3.69,3.69,0,0,0,320.19,400.65Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.78,396.52a3.59,3.59,0,1,0-1.48-4.85A3.59,3.59,0,0,0,343.78,396.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,421.49a2.2,2.2,0,1,0,2.08-3.88,2.2,2.2,0,0,0-2.08,3.88Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,412.5a2.21,2.21,0,0,0,3-.9,2.2,2.2,0,1,0-3,.9Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,428.36a3.66,3.66,0,1,0,1.5,4.95A3.67,3.67,0,0,0,363.43,428.36Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,414.14a4.4,4.4,0,1,0-.9-6.17A4.39,4.39,0,0,0,285.2,414.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,375.35a2.93,2.93,0,1,0,4.1-.6A2.93,2.93,0,0,0,285.43,375.35Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.69,414.73a3.67,3.67,0,1,0-6.16-.47,3.64,3.64,0,1,0,2.08,1.75A3.66,3.66,0,0,0,306.69,414.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.42,413.21a2.2,2.2,0,1,0,3.07-.44A2.19,2.19,0,0,0,263.42,413.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,415.49a2.2,2.2,0,1,0-3.08.43A2.19,2.19,0,0,0,323.72,415.49Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69,432.15a3.67,3.67,0,1,0,5.14-.74A3.65,3.65,0,0,0,311.69,432.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,341.41a4.42,4.42,0,1,0,5.89-2.08A4.43,4.43,0,0,0,337.93,341.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.23,337.56a2.95,2.95,0,1,0-3.92,1.39A2.94,2.94,0,0,0,340.23,337.56Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.07,356.43a3.68,3.68,0,1,0,1.74,4.91A3.67,3.67,0,0,0,337.07,356.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.57,369.67a3.69,3.69,0,1,0-4.92,1.74A3.7,3.7,0,0,0,363.57,369.67Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.45,364.13a2.21,2.21,0,1,0,1,3A2.2,2.2,0,0,0,379.45,364.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,384.12a3.68,3.68,0,1,0,1.73,4.9A3.69,3.69,0,0,0,376.81,384.12Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.76,311.41a4.43,4.43,0,1,0,6-1.67A4.43,4.43,0,0,0,308.76,311.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.85,327.76a3.69,3.69,0,1,0,5-1.4A3.66,3.66,0,0,0,301.85,327.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,337.78a3.7,3.7,0,1,0,5-1.41A3.68,3.68,0,0,0,326,337.78Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.05,345.44a2.21,2.21,0,1,0,3-.84A2.22,2.22,0,0,0,289.05,345.44Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,337a2.21,2.21,0,1,0,.84,3A2.21,2.21,0,0,0,348.71,337Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,358.18a3.68,3.68,0,0,0,1.41,5,3.3,3.3,0,0,0,.95.35,3.21,3.21,0,0,0-.18,2,4.36,4.36,0,0,0-1.66,1.84,4.42,4.42,0,1,0,7.56-.67,3.28,3.28,0,0,0-1.62-5,3.68,3.68,0,0,0-6.46-3.53Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,334.38A4.43,4.43,0,0,0,279,340.9a3.25,3.25,0,0,0-.82,3.24,3.31,3.31,0,1,0,6.34-1.87,2.63,2.63,0,0,0-.17-.42,4.41,4.41,0,0,0,.59-7.47Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,491.19a3.7,3.7,0,1,0-.76-5.15A3.69,3.69,0,0,0,200,491.19Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,363.65a3.7,3.7,0,1,0,5.17-.77A3.7,3.7,0,0,0,292.65,363.65Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77,368.77a2.22,2.22,0,1,0-3.11.46A2.21,2.21,0,0,0,315.77,368.77Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.87,384.86a3.69,3.69,0,1,0,.76,5.16A3.69,3.69,0,0,0,308.87,384.86Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.68,298.69a3,3,0,1,0,.36,4.15A3,3,0,0,0,251.68,298.69Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.29,320.32a3.68,3.68,0,1,0,.46,5.19A3.67,3.67,0,0,0,244.29,320.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,334.53a3.69,3.69,0,1,0-4.73,5.66,3.64,3.64,0,0,0,5.18-.47A3.69,3.69,0,0,0,266.19,334.53Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.6,338.91a2.22,2.22,0,0,0,3.13-.28,2.21,2.21,0,1,0-3.13.28Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.45,510.27a3.68,3.68,0,0,0,4.73-5.64,3.68,3.68,0,1,0-4.73,5.64Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.78,335.08a3.31,3.31,0,0,0-6.34,1.88h0s0,0,0,.05a1.65,1.65,0,0,0,2.16,2.15,3.23,3.23,0,0,0,2,0A3.3,3.3,0,0,0,194.78,335.08Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.06,351a2.75,2.75,0,1,0-3.43-1.86A2.74,2.74,0,0,0,197.06,351Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.58,341.39a2.76,2.76,0,0,0,2.95,2,2.69,2.69,0,0,0,1.32,1.09,2.76,2.76,0,1,0,2-5.14,2.79,2.79,0,0,0-1.3-.17,2.75,2.75,0,0,0-5,2.25Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.52,366.36a1.65,1.65,0,1,0-2-1.12A1.65,1.65,0,0,0,198.52,366.36Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,329.91a1.66,1.66,0,1,0-3.18.94,1.66,1.66,0,0,0,3.18-.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.89,330.82a3.31,3.31,0,1,0,2.24-4.12A3.32,3.32,0,0,0,263.89,330.82Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,326a2.2,2.2,0,1,0,2.73,1.49A2.19,2.19,0,0,0,260.51,326Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.3,373.79a2.77,2.77,0,1,0,3.45,1.88A2.78,2.78,0,0,0,274.3,373.79Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7,435.47a2.77,2.77,0,1,0,3.43,1.88A2.77,2.77,0,0,0,281.7,435.47Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.39,325a2.7,2.7,0,1,0-4.05,3,4.4,4.4,0,0,0-.35.39,3,3,0,1,0,4.15-.63,2.43,2.43,0,0,0-.35-.2A2.7,2.7,0,0,0,281.39,325Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.1,358.15a1.65,1.65,0,1,0-1.11,2.08A1.66,1.66,0,0,0,275.1,358.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,325.82a1.65,1.65,0,1,0-2.05-1.11A1.64,1.64,0,0,0,299.32,325.82Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,340.39a2.76,2.76,0,1,0-3.43-1.86A2.77,2.77,0,0,0,308.51,340.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,349a3.31,3.31,0,1,0,2.24-4.13A3.3,3.3,0,0,0,357.19,349Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,341.14a2.65,2.65,0,0,0-1,.1A2.75,2.75,0,1,0,235,344l.2,0a2.19,2.19,0,0,0,1.5-2.65l.18,0a1.66,1.66,0,1,0-2.12-1.62,2.24,2.24,0,0,0-.81.08A2.19,2.19,0,0,0,232.48,341.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,356.73a2.76,2.76,0,1,0,1.86-3.44A2.76,2.76,0,0,0,242.53,356.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,345.51a2.76,2.76,0,1,0,3.43,1.86A2.75,2.75,0,0,0,262.34,345.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.43,309.56a2.7,2.7,0,1,0,3.36,1.82A2.69,2.69,0,0,0,381.43,309.56Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.49,370.73a1.66,1.66,0,1,0,2.06,1.11A1.65,1.65,0,0,0,246.49,370.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.83,336.34a1.65,1.65,0,1,0,2.06,1.11A1.65,1.65,0,0,0,271.83,336.34Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87,322.05a2.76,2.76,0,1,0,3.43,1.87A2.76,2.76,0,0,0,388.87,322.05Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.82,307.76a3.31,3.31,0,1,0-2.24,4.11A3.32,3.32,0,0,0,280.82,307.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.18,296.32a3.31,3.31,0,1,0,2.24-4.11A3.31,3.31,0,0,0,260.18,296.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,291.52a2.21,2.21,0,1,0,2.74,1.51A2.21,2.21,0,0,0,256.79,291.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.23,305.1a2.75,2.75,0,1,0,3.43,1.86A2.75,2.75,0,0,0,267.23,305.1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,302.62a2.76,2.76,0,1,0-3.44-1.88A2.78,2.78,0,0,0,286.75,302.62Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.49,292a2.71,2.71,0,1,0,1.83-3.36A2.71,2.71,0,0,0,272.49,292Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67,288.14a1.66,1.66,0,1,0,2.06,1.13A1.65,1.65,0,0,0,294.67,288.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.23,300.59a2.75,2.75,0,1,0,2.84,4.45,2.92,2.92,0,1,0,.46-.73,2.74,2.74,0,0,0-3.3-3.72Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.34,248.67a3.31,3.31,0,1,0,4.11,2.23A3.3,3.3,0,0,0,395.34,248.67Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.37,279.18a2.93,2.93,0,0,0,.31.7,1.66,1.66,0,0,0,1.24,3.06,1.69,1.69,0,0,0,1.19-1.43,3.38,3.38,0,0,0,1.37-.1,3.31,3.31,0,1,0-4.11-2.23Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,274.39a2.21,2.21,0,1,0,2.74,1.5A2.2,2.2,0,0,0,233,274.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,293.24a2.75,2.75,0,1,0-3.42-1.85A2.75,2.75,0,0,0,245,293.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.37,280.18A2.76,2.76,0,1,0,264.8,282,2.76,2.76,0,0,0,261.37,280.18Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,271.53a2.7,2.7,0,1,0,3.36,1.82A2.69,2.69,0,0,0,250.5,271.53Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,288.73a2.76,2.76,0,1,0-3.43-1.86A2.74,2.74,0,0,0,281,288.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,468.77a3.31,3.31,0,1,0-4.13-2.23A3.3,3.3,0,0,0,162.7,468.77Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,295.13a3.31,3.31,0,1,0,2.24-4.1A3.32,3.32,0,0,0,346.19,295.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,481.22a2.75,2.75,0,1,0,3.43,1.86A2.76,2.76,0,0,0,128.43,481.22Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.27,255.15a2.75,2.75,0,1,0-3.43-1.85A2.74,2.74,0,0,0,365.27,255.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,304.22a2.7,2.7,0,1,0,3.44,3c0,.08,0,.16,0,.25a1.66,1.66,0,1,0,1.12-2.06,1.69,1.69,0,0,0-1.14,1.23,2.35,2.35,0,0,0-.1-.58A2.7,2.7,0,0,0,240.92,304.22Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.21,306.87a1.67,1.67,0,0,0,1.12-2.06,1.65,1.65,0,0,0-3.17.94A1.68,1.68,0,0,0,262.21,306.87Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,423.82a3.31,3.31,0,1,0-4.13-2.23A3.3,3.3,0,0,0,108.56,423.82Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.79,219.92a3.31,3.31,0,1,0-4.11-2.24A3.32,3.32,0,0,0,80.79,219.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,283.15a2.21,2.21,0,1,0,2.75,1.49A2.2,2.2,0,0,0,199.1,283.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55,392.72a2.76,2.76,0,1,0-1.86,3.43A2.77,2.77,0,0,0,176.55,392.72Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.64,314.15a1.66,1.66,0,1,0,2.07,1.11A1.68,1.68,0,0,0,211.64,314.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,189.77A3.33,3.33,0,1,0,263,191,3.33,3.33,0,0,0,267.61,189.77Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.08,207a2.51,2.51,0,0,0-2.56,4.31,2.53,2.53,0,0,0,3.45-.86A2.49,2.49,0,0,0,311.08,207Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,143.68a2.5,2.5,0,1,0,3.44-.87A2.5,2.5,0,0,0,300.45,143.68Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,154.43a4.17,4.17,0,1,0-1.45-5.73A4.16,4.16,0,0,0,324.19,154.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92,181.7a5,5,0,1,0-2.38-6.59A5,5,0,0,0,396.92,181.7Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.79,185.15a3.31,3.31,0,1,0-1.6-4.41A3.32,3.32,0,0,0,389.79,185.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.35,193.59a4.94,4.94,0,1,0,2.12,6.67A4.94,4.94,0,0,0,384.35,193.59Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,195.19a4.93,4.93,0,1,0,2.12,6.65A4.94,4.94,0,0,0,355.24,195.19Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,202.66a3.3,3.3,0,1,0,4.45-1.41A3.28,3.28,0,0,0,342,202.66Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.12,230.81a4.11,4.11,0,1,0,5.55-1.77A4.12,4.12,0,0,0,364.12,230.81Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,178.09a4.13,4.13,0,1,0,5.57-1.76A4.14,4.14,0,0,0,377.62,178.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,180.84a4,4,0,1,0,5.43-1.73A4,4,0,0,0,357.1,180.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.7,220.17a2.47,2.47,0,1,0,1.06,3.34A2.46,2.46,0,0,0,391.7,220.17Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,157.34a2.47,2.47,0,1,0-2.27,4.38,2.47,2.47,0,0,0,2.27-4.38Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81,162.07a4.11,4.11,0,1,0,7.75,1.65,4,4,0,1,0-5.17-5.47,4.13,4.13,0,0,0-.36,1.87A4.06,4.06,0,0,0,399.81,162.07Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.27,117.74a5,5,0,1,0,6.61-2.46A5,5,0,0,0,388.27,117.74Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.31,121.84a3.32,3.32,0,0,0-2.78,6,3.34,3.34,0,0,0,4.42-1.64A3.3,3.3,0,0,0,386.31,121.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.85,85.72a5.05,5.05,0,1,0,6.75-2.31A5.05,5.05,0,0,0,376.85,85.72Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.46,94.76a5,5,0,1,0-2.3-6.74A5,5,0,0,0,349.46,94.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.6,93.63a3.36,3.36,0,1,0,4.5-1.54A3.37,3.37,0,0,0,340.6,93.63Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.53,101.54a4.21,4.21,0,0,0,3.7-7.56,4.21,4.21,0,1,0-3.7,7.56Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,73.38a4.21,4.21,0,1,0-1.93-5.63A4.23,4.23,0,0,0,378.31,73.38Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,314.42a4.12,4.12,0,1,0,5.52-1.9A4.11,4.11,0,0,0,351.77,314.42Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,51a2.53,2.53,0,1,0-1.17-3.38A2.51,2.51,0,0,0,377,51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,56.5a4.2,4.2,0,1,0-1.94-5.63A4.2,4.2,0,0,0,400.6,56.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,138.76a5,5,0,1,0,2.16,6.76A5,5,0,0,0,367.35,138.76Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67,139.8a5,5,0,1,0-2.14-6.77A5,5,0,0,0,163.67,139.8Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,272.52a3.35,3.35,0,1,0,1.42,4.5A3.33,3.33,0,0,0,361.2,272.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,150.82a4.19,4.19,0,1,0,5.65-1.8A4.17,4.17,0,0,0,350.15,150.82Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.16,121.21a4.19,4.19,0,1,0,1.79,5.64A4.2,4.2,0,0,0,366.16,121.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.16,124a4.1,4.1,0,1,0-3.77,7.28,4.08,4.08,0,0,0,5.16-1.19,4.17,4.17,0,1,0,.25-4.52A4,4,0,0,0,345.16,124Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.82,165.77a2.51,2.51,0,0,0-2.3,4.46,2.51,2.51,0,1,0,2.3-4.46Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.85,101.9a2.51,2.51,0,1,0-2.31,4.46,2.51,2.51,0,0,0,2.31-4.46Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,106.69a4.17,4.17,0,0,0,1.79,5.64,4.11,4.11,0,0,0,3.23.26,2.52,2.52,0,0,0,4.79,1.17,2.5,2.5,0,0,0-1.17-3.37,2.32,2.32,0,0,0-1.05-.25,4.17,4.17,0,0,0-7.59-3.45Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.92,101.32a5.07,5.07,0,1,0,6.89-2A5.06,5.06,0,0,0,319.92,101.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94,175.25a5.06,5.06,0,1,0-2-6.88A5.08,5.08,0,0,0,132.94,175.25Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,112.22a3.38,3.38,0,1,0-1.34-4.58A3.37,3.37,0,0,0,284.53,112.22Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.59,115.14a4.22,4.22,0,1,0-5.72,1.67A4.21,4.21,0,0,0,316.59,115.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,89a4.24,4.24,0,1,0-1.68-5.74A4.23,4.23,0,0,0,321.94,89Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,91.21a4.14,4.14,0,1,0-1.65-5.62A4.13,4.13,0,0,0,300.78,91.21Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.31,131.18a2.53,2.53,0,1,0-1-3.43A2.55,2.55,0,0,0,331.31,131.18Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.67,66.47a2.54,2.54,0,1,0-1-3.43A2.53,2.53,0,0,0,321.67,66.47Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.07,73a4.22,4.22,0,1,0-1.7-5.74A4.23,4.23,0,0,0,345.07,73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,346.44a3.32,3.32,0,1,0,1.64,4.39A3.31,3.31,0,0,0,137.45,346.44Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,352.88a3.31,3.31,0,1,0-4.4,1.64A3.32,3.32,0,0,0,119.67,352.88Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,352.86a2.21,2.21,0,1,0,1.1,2.93A2.2,2.2,0,0,0,112.37,352.86Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91,358.61a2.76,2.76,0,1,0-1.37-3.65A2.74,2.74,0,0,0,127.91,358.61Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,336.31a2.76,2.76,0,1,0,3.66-1.38A2.78,2.78,0,0,0,132.42,336.31Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.34,337.5a2.7,2.7,0,1,0,1.35,3.58A2.7,2.7,0,0,0,122.34,337.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,364.8a1.69,1.69,0,0,0,.83,2.2,1.68,1.68,0,0,0,2.19-.82,1.66,1.66,0,0,0-3-1.38Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,325.32a1.66,1.66,0,1,0-.83-2.19A1.67,1.67,0,0,0,132.53,325.32Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,328.47a2.76,2.76,0,1,0-1.37-3.66A2.76,2.76,0,0,0,148.08,328.47Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,355a3.31,3.31,0,1,0-4.27,1.89A3.31,3.31,0,0,0,221.79,355Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.34,355.81a3.32,3.32,0,1,0,4.27-1.9A3.31,3.31,0,0,0,196.34,355.81Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,358.6a2.21,2.21,0,1,0,1.26,2.86A2.24,2.24,0,0,0,195.24,358.6Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.65,361.84a2.76,2.76,0,1,0-3.57,1.58A2.75,2.75,0,0,0,214.65,361.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.78,299.29a2.71,2.71,0,1,0,1.56,3.51A2.73,2.73,0,0,0,391.78,299.29Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,330.55a2.76,2.76,0,1,0-4.86.56,1.58,1.58,0,0,0-.68.82,1.68,1.68,0,0,0,1,2.13,1.66,1.66,0,0,0,2.13-1,1.59,1.59,0,0,0,.09-.77A2.78,2.78,0,0,0,233,330.55Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,359.08a3.32,3.32,0,1,0-4.33,1.78A3.34,3.34,0,0,0,190.46,359.08Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31,357.42a3.3,3.3,0,1,0,1.79,4.32A3.31,3.31,0,0,0,169.31,357.42Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,364.84a2.21,2.21,0,1,0-2.88,1.19A2.21,2.21,0,0,0,165,364.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,362.11a2.76,2.76,0,1,0,1.48,3.61A2.79,2.79,0,0,0,181.65,362.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.42,346.89a2.76,2.76,0,1,0-3.62,1.49A2.77,2.77,0,0,0,188.42,346.89Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,347.74a2.7,2.7,0,1,0,3.53-1.45A2.67,2.67,0,0,0,169.76,347.74Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,375.13a1.64,1.64,0,0,0,2.16-.88,1.65,1.65,0,1,0-2.16.88Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.09,333.78a1.63,1.63,0,0,0,.42.11,2.26,2.26,0,0,0,.05,1,2.2,2.2,0,1,0,1.81-2.81,1.66,1.66,0,0,0-1-1.38,1.63,1.63,0,0,0-2.17.88A1.67,1.67,0,0,0,183.09,333.78Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.73,336.43a2.74,2.74,0,0,0,3.6-1.49,2.67,2.67,0,0,0,.15-.48,2.66,2.66,0,0,0,1.63,0,2.71,2.71,0,1,0-1.54-5.19,2.68,2.68,0,0,0-1.85,2,2.75,2.75,0,0,0-2,5.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.28,321.55A3.31,3.31,0,1,0,201,323.5,3.3,3.3,0,0,0,205.28,321.55Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,322.06a2.17,2.17,0,0,0-2.83,1.28,2.2,2.2,0,1,0,4.13,1.54A2.18,2.18,0,0,0,198,322.06Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.9,326.68l.2.05a1.68,1.68,0,0,0-1.32,1,1.66,1.66,0,1,0,2.23-.92,2.76,2.76,0,1,0-1.11-.17Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82,437.79a2.77,2.77,0,1,0-1.62-3.56A2.75,2.75,0,0,0,194.82,437.79Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57,312.16a3.86,3.86,0,1,0-2.27-5A3.86,3.86,0,0,0,204.57,312.16Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,290a2.75,2.75,0,1,0,.46,4.92s0,0,0,.05a2.7,2.7,0,1,0,3.54-1.46,2.66,2.66,0,0,0-2.43.19c0-.06,0-.11.07-.16A2.74,2.74,0,0,0,233.82,290Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.28,294.5a3.31,3.31,0,1,0-4.27,1.92A3.3,3.3,0,0,0,201.28,294.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.1,293.54A3.3,3.3,0,1,0,182,297.8,3.31,3.31,0,0,0,180.1,293.54Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,299.52a2.2,2.2,0,1,0,2.85-1.28A2.2,2.2,0,0,0,171.9,299.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62,303a2.76,2.76,0,1,0-1.61-3.55A2.77,2.77,0,0,0,190.62,303Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7,280.43a2.76,2.76,0,1,0,3.55-1.6A2.75,2.75,0,0,0,193.7,280.43Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8,287.33a2.71,2.71,0,1,0-1.57-3.5A2.71,2.71,0,0,0,181.8,287.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,266.36a1.66,1.66,0,0,0-2.15,1,1.64,1.64,0,0,0,1,2.12,1.65,1.65,0,1,0,1.18-3.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,345.05a2.75,2.75,0,1,0,1.6,3.55A2.73,2.73,0,0,0,79.85,345.05Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,323.09a3.31,3.31,0,1,0-4.33,1.78A3.29,3.29,0,0,0,186,323.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.63,330.09a2.21,2.21,0,1,0-1.2-2.89A2.21,2.21,0,0,0,157.63,330.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,331.25a2.76,2.76,0,1,0-1.49-3.6A2.76,2.76,0,0,0,175,331.25Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.31,312.41a2.76,2.76,0,1,0-1.49-3.6A2.76,2.76,0,0,0,180.31,312.41Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.07,348.29a3.86,3.86,0,1,0,2.09,5A3.87,3.87,0,0,0,29.07,348.29Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,295.28a3.32,3.32,0,1,0,4.34-1.75A3.32,3.32,0,0,0,153,295.28Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,300.49a3.31,3.31,0,1,0-4.33,1.77A3.32,3.32,0,0,0,139.78,300.49Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.59,301.86a2.21,2.21,0,1,0,2.9-1.18A2.22,2.22,0,0,0,129.59,301.86Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,302.36a2.76,2.76,0,1,0,3.61-1.48A2.75,2.75,0,0,0,146.71,302.36Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,283.54a2.76,2.76,0,1,0,5.09,2.13,2.76,2.76,0,1,0-5.09-2.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.33,257.52a2.71,2.71,0,1,0,3.54-1.46A2.7,2.7,0,0,0,387.33,257.52Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55,311.77a1.62,1.62,0,0,0,.88,2.15,1.65,1.65,0,1,0-.88-2.15Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,271.67a1.69,1.69,0,0,0-.88-2.18,1.66,1.66,0,1,0-1.28,3.06,1.33,1.33,0,0,0,.34.1,3.59,3.59,0,0,0-1.7,1.25,3.67,3.67,0,1,0,5.88,4.4,3.65,3.65,0,0,0-3.08-5.85A1.7,1.7,0,0,0,154,271.67Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07,273.76a2.75,2.75,0,1,0-5.08-2.13,2.75,2.75,0,0,0,5.08,2.13Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.85,220.53a3.31,3.31,0,0,0-2.74,6,3.31,3.31,0,1,0,2.74-6Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.77,227a2.2,2.2,0,1,0,1.1,2.91A2.21,2.21,0,0,0,188.77,227Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,229.05a2.76,2.76,0,1,0,3.66-1.37A2.76,2.76,0,0,0,202.94,229.05Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.43,94.3a2.76,2.76,0,1,0-1.38-3.66A2.76,2.76,0,0,0,212.43,94.3Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.83,121.61a2.7,2.7,0,1,0,2.24-4.92,2.7,2.7,0,1,0-2.24,4.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,240.26a1.66,1.66,0,0,0-3-1.38,1.68,1.68,0,0,0,.83,2.19A1.65,1.65,0,0,0,220.51,240.26Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.31,196.39a1.65,1.65,0,1,0,.82,2.19A1.66,1.66,0,0,0,210.31,196.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.12,198.9a2.76,2.76,0,1,0,3.65-1.37A2.75,2.75,0,0,0,223.12,198.9Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,226.7a3.31,3.31,0,1,0,4.28-1.9A3.3,3.3,0,0,0,292,226.7Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21,150.5a2.21,2.21,0,1,0,2.86-1.28A2.19,2.19,0,0,0,311.21,150.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.47,232.37a2.75,2.75,0,1,0,1.58,3.57A2.74,2.74,0,0,0,289.47,232.37Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.25,213.39a2.76,2.76,0,1,0,1.58,3.57A2.77,2.77,0,0,0,294.25,213.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.34,200.91a1.66,1.66,0,0,0-1.2,3.09,1.66,1.66,0,0,0,1.2-3.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.72,231.51a3.31,3.31,0,1,0,1.78,4.31A3.28,3.28,0,0,0,245.72,231.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,237.22a2.21,2.21,0,1,0,2.89-1.17A2.22,2.22,0,0,0,237.32,237.22Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.44,237.69a2.75,2.75,0,1,0,5.08,2.12,2.71,2.71,0,0,0,0-2.18,2.93,2.93,0,0,0,2.67-1.16,2.81,2.81,0,0,0,.56-1.47,3.31,3.31,0,1,0-2.23-3.13,2.93,2.93,0,0,0-3.3,4.14A2.72,2.72,0,0,0,254.44,237.69Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.72,218.86a2.76,2.76,0,1,0,3.61-1.5A2.75,2.75,0,0,0,259.72,218.86Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.91,304.19a1.66,1.66,0,1,0,1.28-3.06,1.66,1.66,0,0,0-1.28,3.06Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.59,205.71a1.66,1.66,0,0,0,3.06,1.27,1.64,1.64,0,0,0,.08-1l.18.13a2.22,2.22,0,1,0-.83-3,2.25,2.25,0,0,0-.16,1.84l-.16-.08A1.65,1.65,0,0,0,258.59,205.71Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,205.44a2.76,2.76,0,1,0,1.49,3.59A2.74,2.74,0,0,0,277.25,205.44Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,262.84a3.31,3.31,0,1,0,4.26-2A3.32,3.32,0,0,0,376,262.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.73,191.39a3.3,3.3,0,0,0-2.31,6.19,3.27,3.27,0,0,0,3.3-.59,4.42,4.42,0,0,0,8.26,2.53,4.42,4.42,0,0,0-7.1-5.18A3.32,3.32,0,0,0,279.73,191.39Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,197.44a2.19,2.19,0,0,0,1.29,2.84,2.21,2.21,0,1,0-1.29-2.84Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.05,397.66a2.75,2.75,0,1,0-1.62-3.54A2.74,2.74,0,0,0,121.05,397.66Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.86,170.19a2.76,2.76,0,1,0,3.42-1.9A2.76,2.76,0,0,0,362.86,170.19Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,186.25a3.86,3.86,0,0,0,2.69-7.24,3.86,3.86,0,1,0-2.69,7.24Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.85,208.14a1.67,1.67,0,0,0,2.14-1,1.54,1.54,0,0,0,.09-.76,2.72,2.72,0,0,0,2.33-1.75,2.76,2.76,0,1,0-4.85.54,1.7,1.7,0,0,0-.68.83A1.66,1.66,0,0,0,304.85,208.14Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.59,165.11a1.65,1.65,0,1,0,2.13-1A1.64,1.64,0,0,0,291.59,165.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,165.09a4.16,4.16,0,1,0-.51,2.8l.14-.3a2.75,2.75,0,1,0,.37-2.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.15,173.8a3.31,3.31,0,1,0-1.91-4.26A3.32,3.32,0,0,0,254.15,173.8Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.59,176.46a2.22,2.22,0,0,0,2.84-1.29,2.21,2.21,0,1,0-2.84,1.29Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.41,173.51a2.76,2.76,0,0,0,5.17,2,2.74,2.74,0,0,0,.16-.89,2.74,2.74,0,0,0,3.34-3.9,3.31,3.31,0,1,0-2.24-1.42,2.68,2.68,0,0,0-2.91,2.65A2.77,2.77,0,0,0,265.41,173.51Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,152.92a2.76,2.76,0,1,0,1.6,3.55A2.75,2.75,0,0,0,273.66,152.92Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.2,161.4a2.7,2.7,0,1,0-1.56-3.48A2.71,2.71,0,0,0,258.2,161.4Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,240.26a1.65,1.65,0,0,0,2.14-.95,1.66,1.66,0,1,0-3.1-1.17A1.64,1.64,0,0,0,378.87,240.26Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51,143.55a1.66,1.66,0,1,0-1-2.14A1.65,1.65,0,0,0,269.51,143.55Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78,144.1a2.75,2.75,0,1,0-3.55,1.6A2.75,2.75,0,0,0,288.78,144.1Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.89,192.94a4.26,4.26,0,0,0-.9-.95,4.44,4.44,0,1,0-5.29,7.13,4.43,4.43,0,0,0,5.77-.44,3.42,3.42,0,0,0,.57.3,3.31,3.31,0,1,0,2.54-6.12A3.27,3.27,0,0,0,257.89,192.94Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,200.11a2.2,2.2,0,1,0,1.19,2.87A2.2,2.2,0,0,0,235.73,200.11Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,201.73a2.76,2.76,0,1,0,3.61-1.49A2.78,2.78,0,0,0,250,201.73Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.71,186.5a2.76,2.76,0,1,0-1.5-3.61A2.76,2.76,0,0,0,256.71,186.5Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.64,183.33a3.87,3.87,0,0,0-5,2,1.48,1.48,0,0,0-.55-.35,1.65,1.65,0,0,0-2.16.89,1.65,1.65,0,0,0,2.48,2,3.86,3.86,0,0,0,7.3.55A3.88,3.88,0,0,0,245.64,183.33Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.83,211.08a1.66,1.66,0,1,0,2.15-.89A1.65,1.65,0,0,0,264.83,211.08Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,173.72a3.32,3.32,0,1,0-1.78-4.33A3.31,3.31,0,0,0,231.21,173.72Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.86,176.34a3.3,3.3,0,1,0-1.78-4.34A3.28,3.28,0,0,0,211.86,176.34Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.18,178.83a2.2,2.2,0,1,0-1.18-2.89A2.19,2.19,0,0,0,207.18,178.83Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19,178.58a2.75,2.75,0,1,0-3.6,1.46A2.76,2.76,0,0,0,228.19,178.58Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.93,161.24a2.76,2.76,0,1,0,2.13-5.09,2.76,2.76,0,1,0-2.13,5.09Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,315.34a2.71,2.71,0,1,0,1.44,3.55A2.72,2.72,0,0,0,102.27,315.34Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,146.64a1.66,1.66,0,1,0-.88-2.17A1.65,1.65,0,0,0,228.23,146.64Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.87,149.33a2.76,2.76,0,1,0-1.48-3.62A2.77,2.77,0,0,0,243.87,149.33Z",
    style: {
      fill: "#dcd8c9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.78,442.36a4.24,4.24,0,1,1,1.49-5.8A4.24,4.24,0,0,1,90.78,442.36Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.77,323.18a2.4,2.4,0,1,1,1-3.26A2.41,2.41,0,0,1,258.77,323.18Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,291.87a3,3,0,1,1,1.24-4.06A3,3,0,0,1,259.52,291.87Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,327.62a5.77,5.77,0,1,1,2-7.91A5.76,5.76,0,0,1,166.07,327.62Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38,357.32a3.64,3.64,0,1,1,1.62-4.88A3.64,3.64,0,0,1,250.38,357.32Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.15,307.45a3.65,3.65,0,1,1,2.21-4.65A3.64,3.64,0,0,1,318.15,307.45Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,354.88a3.63,3.63,0,1,1,2.48-4.49A3.63,3.63,0,0,1,303,354.88Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,362.61a3,3,0,1,1,2-3.66A3,3,0,0,1,182.65,362.61Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,331.22a4.11,4.11,0,1,1-5.48-2A4.09,4.09,0,0,1,130.21,331.22Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,382.82a2.22,2.22,0,1,1-3.1-.55A2.22,2.22,0,0,1,144,382.82Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,366.88a5.77,5.77,0,1,1,2-7.91A5.77,5.77,0,0,1,278,366.88Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3,383.5a5.78,5.78,0,1,1,2-7.91A5.76,5.76,0,0,1,126.3,383.5Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.51,330.1a5.78,5.78,0,1,1,2-7.91A5.76,5.76,0,0,1,347.51,330.1Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.14,356.33a5.77,5.77,0,1,1,2-7.91A5.77,5.77,0,0,1,210.14,356.33Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,264.31a5.77,5.77,0,1,1,2-7.91A5.77,5.77,0,0,1,199.3,264.31Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,446.87a4.4,4.4,0,1,1,2.69-5.61A4.42,4.42,0,0,1,190.52,446.87Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.7,434.77a3.69,3.69,0,1,1,2.24-4.72A3.71,3.71,0,0,1,178.7,434.77Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,487.44a7,7,0,1,1,2.48-9.64A7,7,0,0,1,233.67,487.44Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.7,
    cy: 367.6,
    r: 3.95,
    style: {
      fill: "#e78d38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,347.68a171.16,171.16,0,0,1,60.09-130.39,154.82,154.82,0,0,0,79.95,299A171.58,171.58,0,0,1,113.85,347.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.32,354a2.36,2.36,0,1,0-1.63-2.91A2.35,2.35,0,0,0,80.32,354Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.71,338.9a2.35,2.35,0,1,0-2.9,1.63A2.35,2.35,0,0,0,79.71,338.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.05,335.39a1.57,1.57,0,1,0-1.94,1.08A1.57,1.57,0,0,0,76.05,335.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,348A2,2,0,1,0,75,349.35,2,2,0,0,0,77.43,348Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.82,347.73a2,2,0,0,0-1.07,3.78,2,2,0,0,0,1.07-3.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,340.78a1.92,1.92,0,1,0-2.38,1.32A1.92,1.92,0,0,0,87.92,340.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,358.31a1.18,1.18,0,0,0-.82-1.45,1.16,1.16,0,0,0-1.45.8,1.18,1.18,0,1,0,2.27.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.83,347.3a1.17,1.17,0,0,0-.81-1.46,1.18,1.18,0,1,0,.81,1.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.77,359a2,2,0,1,0-2.42,1.35A2,2,0,0,0,100.77,359Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.19,323.81a2.36,2.36,0,1,0,2.17-2.53A2.36,2.36,0,0,0,131.19,323.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,312.4a2.36,2.36,0,1,0,2.17-2.53A2.35,2.35,0,0,0,123.23,312.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26,310a1.56,1.56,0,0,0-3-.41,1.19,1.19,0,1,0,.28,1.54,1.58,1.58,0,0,0,1.32.55A1.55,1.55,0,0,0,123.26,310Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,264.31a2,2,0,1,0-2.11-1.81A2,2,0,0,0,130.6,264.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.05,287.72a1.93,1.93,0,1,0,2.07,1.77A1.93,1.93,0,0,0,203.05,287.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,334.38a1.17,1.17,0,0,0,1.09-1.27,1.18,1.18,0,1,0-1.09,1.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65,314.21a1.18,1.18,0,1,0-1.26-1.08A1.18,1.18,0,0,0,148.65,314.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,404.38a2,2,0,1,0-3.91.3,2,2,0,0,0,3.91-.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.57,335.67a2.36,2.36,0,1,0-2.54,2.18A2.36,2.36,0,0,0,115.57,335.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,372.62A2.36,2.36,0,1,0,40,374.79,2.36,2.36,0,0,0,42.5,372.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,320.44a1.57,1.57,0,0,0-3.13-.24,1.57,1.57,0,1,0,3.13.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,330a2,2,0,1,0,2.11-1.81A2,2,0,0,0,95.05,330Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,331.64a2,2,0,1,0,2.11-1.82,2,2,0,0,0-1.26.35.89.89,0,1,0-.63.46l.19-.05A2,2,0,0,0,119,331.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.84,391.83a1.94,1.94,0,1,0-2.08,1.77A1.95,1.95,0,0,0,104.84,391.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.25,343.87A1.18,1.18,0,1,0,104,345,1.18,1.18,0,0,0,105.25,343.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.78,326.12a1.18,1.18,0,1,0,1.1,1.27A1.17,1.17,0,0,0,129.78,326.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,338.4a2,2,0,1,0,2.12-1.82A2,2,0,0,0,130.21,338.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.16,302.93a2.37,2.37,0,0,0,1.92-1.51,2.35,2.35,0,1,0-.08-1.87,2.3,2.3,0,0,0-.74-.89,1.58,1.58,0,1,0-1-.42,2.22,2.22,0,0,0-.63,0,2.18,2.18,0,0,0-.63.18,1.86,1.86,0,0,0,.23-1.14,1.81,1.81,0,0,0-.73-1.19,2,2,0,0,0-3.83.76,2,2,0,0,0,1.41,1.78,1.76,1.76,0,0,0,1.63.66,1.07,1.07,0,0,0,.27-.07,2.37,2.37,0,0,0,2.22,3.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,289.73a2.37,2.37,0,1,0,2.07-2.63A2.37,2.37,0,0,0,116,289.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82,287.71a1.58,1.58,0,0,0,3.14-.38,1.58,1.58,0,1,0-3.14.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15,298.51a2,2,0,1,0-1.73,2.2A2,2,0,0,0,122.15,298.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9,220.3a2,2,0,1,0,1.73-2.2A2,2,0,0,0,266.9,220.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.55,262.82a2.76,2.76,0,1,0-2.42,3.08A2.76,2.76,0,0,0,102.55,262.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.59,239.9a2,2,0,1,0,1.73-2.2A2,2,0,0,0,242.59,239.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.91,296.23a2.38,2.38,0,1,0,2.25-2.5A2.37,2.37,0,0,0,101.91,296.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.17,284.52A2.38,2.38,0,1,0,96.43,282,2.38,2.38,0,0,0,94.17,284.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,283.77a1.59,1.59,0,1,0-1.66-1.49A1.58,1.58,0,0,0,92.77,283.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,293.72a2,2,0,1,0-1.88,2.07A2,2,0,0,0,99.7,293.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,291.51a2,2,0,1,0,1.89-2.08A2,2,0,0,0,109.57,291.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,285.44a1.94,1.94,0,1,0-2-1.84A2,2,0,0,0,105.53,285.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,305.6a1.19,1.19,0,1,0,1.12-1.24A1.19,1.19,0,0,0,95,305.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,285.87a1.19,1.19,0,1,0,1.12-1.25A1.19,1.19,0,0,0,118.5,285.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.64,306.53a2.39,2.39,0,1,0-2.2-2.56A2.39,2.39,0,0,0,89.64,306.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14,303.06a1.61,1.61,0,0,0,1.7-1.47,1.59,1.59,0,1,0-1.7,1.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,312.83A2,2,0,1,0,104,311,2,2,0,0,0,101.89,312.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,231.8a2.78,2.78,0,1,0-3,2.57A2.77,2.77,0,0,0,126.86,231.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.05,325.22a1.19,1.19,0,0,0-2.38-.17,1.2,1.2,0,0,0,1.1,1.28A1.19,1.19,0,0,0,88.05,325.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,308.32a1.2,1.2,0,0,0,1.1,1.28,1.19,1.19,0,1,0-1.1-1.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06,321.73a2,2,0,1,0-1.85-2.12A2,2,0,0,0,115.06,321.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,312.8a2.37,2.37,0,1,0-2.67,2A2.36,2.36,0,0,0,75.63,312.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,299.91a2.37,2.37,0,1,0-2.65,2A2.36,2.36,0,0,0,70.17,299.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,297a1.59,1.59,0,0,0-1.36-1.78A1.58,1.58,0,1,0,66,297Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.22,309.31A2,2,0,1,0,67,311,2,2,0,0,0,69.22,309.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,308.94a2,2,0,1,0,2.23-1.7A2,2,0,0,0,79.31,308.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,300.58a1.94,1.94,0,1,0-2.18,1.67A1.94,1.94,0,0,0,78.62,300.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.83,320.44a1.19,1.19,0,1,0-1.33,1A1.18,1.18,0,0,0,64.83,320.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,318.56a2,2,0,0,0,2-1,2.39,2.39,0,1,0,.07-1.84,2,2,0,0,0-1.51-1.1,1.82,1.82,0,0,0-.93.11,2,2,0,1,0-1.79.87,2,2,0,0,0,.81-.11,2,2,0,0,0-.32.83A2,2,0,0,0,91.86,318.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.58,407.6a2.36,2.36,0,1,0-2.91,1.62A2.36,2.36,0,0,0,101.58,407.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4,309.06a2,2,0,1,0,2.42-1.35A2,2,0,0,0,127.4,309.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,311.22a2,2,0,1,0,2.43-1.35A2,2,0,0,0,141.14,311.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.29,304.24a1.93,1.93,0,0,0,2.07-.72l.21,0a1.79,1.79,0,0,0,1.39-2.1,1.77,1.77,0,0,0-2.09-1.38,1.73,1.73,0,0,0-.88.45,1.93,1.93,0,0,0-.7,3.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,319.8a1.18,1.18,0,1,0,1.46-.82A1.2,1.2,0,0,0,123,319.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.76,308a1.17,1.17,0,1,0,.81,1.45A1.17,1.17,0,0,0,152.76,308Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,321.45a.91.91,0,0,0,.61-1,.88.88,0,0,0-.6-.66,1.92,1.92,0,0,0-1.23-1.06,2,2,0,1,0,1.22,2.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,283.41a2.36,2.36,0,1,0,2.53,2.18A2.37,2.37,0,0,0,187.1,283.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,274.53a2.35,2.35,0,1,0,2.17-2.53A2.34,2.34,0,0,0,177,274.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,272.14a1.57,1.57,0,0,0-3-.41,1.19,1.19,0,0,0-.88-.24,1.18,1.18,0,0,0,.28,2.35,1.2,1.2,0,0,0,.88-.57,1.57,1.57,0,0,0,2.76-1.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,285.62a2,2,0,1,0-1.77-3.06,1.12,1.12,0,0,0-.18-.2,1.18,1.18,0,1,0-.08,1.84A2,2,0,0,0,180.87,285.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,279a2,2,0,1,0,2.12,1.81A2,2,0,0,0,194.23,279Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,271.31a2,2,0,0,0-1.77,2.07,1.93,1.93,0,1,0,1.77-2.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.34,295.42a1.18,1.18,0,1,0,1.09-1.26A1.18,1.18,0,0,0,178.34,295.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.12,275.26a1.19,1.19,0,1,0,1.09-1.27A1.19,1.19,0,0,0,201.12,275.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61,287.85a2,2,0,1,0-2.11-1.8A2,2,0,0,0,206.61,287.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.62,375a2.36,2.36,0,1,0-2.54,2.18A2.36,2.36,0,0,0,188.62,375Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,294.69a2,2,0,0,0-1.81-2.11,2,2,0,1,0,1.81,2.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88,292a2,2,0,0,0-1.42,3.47.87.87,0,0,0-.73.3.89.89,0,1,0,1.4.07,1.64,1.64,0,0,0,.44.09,2,2,0,1,0,.31-3.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,249.74a1.93,1.93,0,1,0,2.07-1.78A1.92,1.92,0,0,0,232,249.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,305.82a1.18,1.18,0,1,0,1.26-1.08A1.18,1.18,0,0,0,156.64,305.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.38,341a1.18,1.18,0,1,0,1.26-1.09A1.17,1.17,0,0,0,243.38,341Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08,298.71a2,2,0,1,0-.3,3.92,2,2,0,0,0,.3-3.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,260.35a2.37,2.37,0,1,0,2.64,2.07A2.38,2.38,0,0,0,180.33,260.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,251.86a2.37,2.37,0,1,0,2.08-2.63A2.37,2.37,0,0,0,169.76,251.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.32,251.22a1.59,1.59,0,1,0-1.76-1.38A1.59,1.59,0,0,0,168.32,251.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.89,260.64a2,2,0,1,0-1.73,2.2A2,2,0,0,0,175.89,260.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,255.57a2,2,0,1,0,2.21,1.72A2,2,0,0,0,187.3,255.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,251.54a1.18,1.18,0,1,0,2.35-.28,1.18,1.18,0,0,0-2.35.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.86,261.77a2,2,0,1,0-1.72,2.19A2,2,0,0,0,201.86,261.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.9,255.86a2.38,2.38,0,0,0-2.21,1.95,1.79,1.79,0,0,0-1.82-.72,1.77,1.77,0,1,0,2.06,2.25,2.37,2.37,0,0,0,4.47-1.23A2.37,2.37,0,0,0,157.9,255.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.91,156.29a2.37,2.37,0,1,0,2.25-2.5A2.38,2.38,0,0,0,242.91,156.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,244.41a1.58,1.58,0,1,0,1.5-1.67A1.59,1.59,0,0,0,144.86,244.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,180a2,2,0,1,0,1.88-2.08A2,2,0,0,0,251.92,180Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,251.56a2,2,0,1,0,2.08,1.88A2,2,0,0,0,165.21,251.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.08,243.69a1.94,1.94,0,1,0,2,1.84A1.94,1.94,0,0,0,159.08,243.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.77,267.74a1.18,1.18,0,0,0,.46.87h-.1a.89.89,0,1,0,1,.73.83.83,0,0,0-.25-.48H150a1.18,1.18,0,0,0,1.12-1.26,1.16,1.16,0,0,0-1.24-1.11A1.19,1.19,0,0,0,148.77,267.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,249.13a1.2,1.2,0,0,0,1.13-1.25,1.19,1.19,0,1,0-1.13,1.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,256.88a2,2,0,0,0-1.87,2.08,2,2,0,1,0,1.87-2.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.17,279a2.38,2.38,0,0,0-4.53-1.17,2,2,0,1,0-2,2.83,2,2,0,0,0,2-1,2.37,2.37,0,0,0,4.59-.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,268.65a2.36,2.36,0,0,0,2.48-1.86,2.06,2.06,0,0,0,.35,0,1.78,1.78,0,1,0-.61-3.51,1.74,1.74,0,0,0-1.19.81,2.25,2.25,0,0,0-.69-.17,2.38,2.38,0,1,0-.34,4.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.58,263.72a1.59,1.59,0,1,0-1.69,1.47A1.58,1.58,0,0,0,141.58,263.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.51,211.17a2,2,0,1,0-2.14,1.84A2,2,0,0,0,137.51,211.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.76,232.22a2,2,0,1,0-2.12,1.84A2,2,0,0,0,238.76,232.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29,345.7a2.78,2.78,0,1,0-3,2.57A2.79,2.79,0,0,0,111.29,345.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,286.09a1.19,1.19,0,0,0-1.27,1.09,1.18,1.18,0,0,0,1.1,1.28h.14a1.18,1.18,0,0,0-.33,1,1.19,1.19,0,1,0,1.14-1.33,1.19,1.19,0,0,0-.78-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,270.46a1.19,1.19,0,1,0,1.28-1.1A1.19,1.19,0,0,0,165.21,270.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,274.31a2.38,2.38,0,1,0,2.66-2A2.38,2.38,0,0,0,124.67,274.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.92,262.05a2.37,2.37,0,1,0-2.66,2A2.38,2.38,0,0,0,123.92,262.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.76,259.08a1.58,1.58,0,1,0-3.14-.41,1.58,1.58,0,0,0,3.14.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,270.92a2,2,0,1,0,2.22-1.69A2,2,0,0,0,119.05,270.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.41,271.11a2,2,0,1,0,2.22-1.7A2,2,0,0,0,299.41,271.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,375.09a1.94,1.94,0,1,0-2.17,1.67A1.93,1.93,0,0,0,84.23,375.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.24,283.6a1.19,1.19,0,1,0-1-1.33A1.17,1.17,0,0,0,117.24,283.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,369.67a2.36,2.36,0,1,0,2.91-1.62A2.36,2.36,0,0,0,186,369.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.06,357.51a2.35,2.35,0,1,0-2.9,1.62A2.35,2.35,0,0,0,187.06,357.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,352.06a1.55,1.55,0,0,0-1.34.24,1,1,0,0,0-.38,0,.88.88,0,0,0-.69,1,.84.84,0,0,0,.47.61,1.54,1.54,0,0,0,1.08,1.13,1.57,1.57,0,0,0,.86-3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.78,366.61a2,2,0,1,0-2.43,1.35A2,2,0,0,0,184.78,366.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.52,368.77a2,2,0,1,0-2.42,1.35A2,2,0,0,0,198.52,368.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.89,360.71a1.82,1.82,0,0,0,.8.05,1.48,1.48,0,1,0,2.3-.47,1.5,1.5,0,0,0-1-.36,1.69,1.69,0,0,0,.26-.54,1.92,1.92,0,1,0-2.37,1.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86,376.92a1.18,1.18,0,0,0-2.27-.65,1.2,1.2,0,0,0,.81,1.46A1.18,1.18,0,0,0,178.86,376.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.37,364.44a1.19,1.19,0,0,0-1.46.82,1.18,1.18,0,1,0,1.46-.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.7,379a2,2,0,1,0-1.36-2.42A2,2,0,0,0,205.7,379Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.53,342.42a2.36,2.36,0,1,0,2.17-2.53A2.36,2.36,0,0,0,238.53,342.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.57,331a2.36,2.36,0,1,0,4.7-.36,2.36,2.36,0,0,0-4.7.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.17,338.17a2,2,0,1,0,.3,3.92,2,2,0,0,0-.3-3.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,329.86a1.93,1.93,0,1,0,1.77-2.07A1.93,1.93,0,0,0,239.79,329.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.3,351.72a1.18,1.18,0,1,0-1.09,1.27A1.19,1.19,0,0,0,234.3,351.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.73,331.74a1.18,1.18,0,1,0,1.09-1.27A1.18,1.18,0,0,0,254.73,331.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,340.41a2,2,0,1,0,2.1,1.81A2,2,0,0,0,259.92,340.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.92,354.28a2.37,2.37,0,1,0-2.54,2.18A2.36,2.36,0,0,0,222.92,354.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.17,248.06a2.36,2.36,0,1,0,2.54-2.17A2.37,2.37,0,0,0,284.17,248.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.79,340.5a1.57,1.57,0,1,0-1.46-1.69A1.57,1.57,0,0,0,210.79,340.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.05,190a2,2,0,1,0,2.11-1.81A2,2,0,0,0,305.05,190Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.21,296.08a2,2,0,0,0,1.79,2.08,1.93,1.93,0,1,0-1.79-2.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.51,361.21a1.2,1.2,0,0,0-1.27,1.09,1.18,1.18,0,0,0,2.36.18A1.19,1.19,0,0,0,211.51,361.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,344.72a1.18,1.18,0,0,0-1.26,1.09,1.18,1.18,0,1,0,1.26-1.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,357a2,2,0,1,0,2.12-1.81A2,2,0,0,0,237.56,357Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.09,317a1.76,1.76,0,0,0-.6-1.43,1.74,1.74,0,0,0-1.57-.38,2,2,0,1,0-1.86,2.13,2.38,2.38,0,0,0,.53-.11,1.77,1.77,0,0,0,.49,1,2.4,2.4,0,0,0-.22,1.31,2.37,2.37,0,1,0,4.71-.57A2.35,2.35,0,0,0,235.09,317Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08,307.77a2.4,2.4,0,0,0-2.64-2.07,2.37,2.37,0,1,0,2.64,2.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.16,306.32a1.58,1.58,0,1,0,1.39-1.77A1.58,1.58,0,0,0,220.16,306.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,317.12a2,2,0,1,0-1.73,2.2A2,2,0,0,0,229.5,317.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.18,314.24a2,2,0,1,0,1.72-2.2A2,2,0,0,0,239.18,314.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.94,308.75a1.18,1.18,0,0,0,1.32,1,1.2,1.2,0,0,0,1-1.32,1.19,1.19,0,0,0-2.36.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,308a1.21,1.21,0,0,0,1.33,1,1.19,1.19,0,0,0,1-1.32,1.17,1.17,0,0,0-1.32-1A1.19,1.19,0,0,0,247.67,308Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.54,318.72a2,2,0,1,0,1.72-2.2A2,2,0,0,0,251.54,318.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,300.64a2.37,2.37,0,1,0,2.49,2.24A2.38,2.38,0,0,0,203.78,300.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,310.45a2,2,0,1,0,.21,3.95,2,2,0,1,0-.21-3.95Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,310.12A2,2,0,1,0,218.8,308,2,2,0,0,0,216.93,310.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.66,264.48a1.94,1.94,0,1,0,1.84-2A1.94,1.94,0,0,0,238.66,264.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,323a1.19,1.19,0,1,0,1.25,1.13A1.19,1.19,0,0,0,203.5,323Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,303.23a1.19,1.19,0,1,0,1.25,1.13A1.18,1.18,0,0,0,227,303.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.79,322.58a2.38,2.38,0,0,0,1.73,2.47,1.77,1.77,0,0,0,3.07,1.54,1.79,1.79,0,0,0-.18-2.51,1.15,1.15,0,0,0-.19-.14,2.3,2.3,0,0,0,.31-1,2.38,2.38,0,1,0-4.74-.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.18,320.2a1.59,1.59,0,0,0-1.46-1.71h-.22a1.46,1.46,0,1,0-1.43,1.19.92.92,0,0,0,0,.28,1.58,1.58,0,0,0,3.16.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93,415.86a2,2,0,1,0-1.83-2.12A2,2,0,0,0,203.93,415.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,333.57a2,2,0,1,0-1.84-2.14A2,2,0,0,0,211.08,333.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,254.19a2.78,2.78,0,1,0,2.58,3A2.78,2.78,0,0,0,262,254.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,255.54a1.19,1.19,0,1,0,1.27-1.1A1.19,1.19,0,0,0,240.34,255.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,325.83a1.19,1.19,0,1,0,1.11,1.28A1.19,1.19,0,0,0,220.08,325.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,336.38a2,2,0,1,0,1.83,2.12A2,2,0,0,0,222.69,336.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,226.58a2.37,2.37,0,1,0,2,2.66A2.37,2.37,0,0,0,254.31,226.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,313.78a1.58,1.58,0,1,0,1.36,1.77A1.58,1.58,0,0,0,172,313.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,329.62a2,2,0,1,0-1.7-2.21A2,2,0,0,0,174.35,329.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,327.55a2,2,0,1,0,2.22-1.7A2,2,0,0,0,186.66,327.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.15,337.72a1.19,1.19,0,1,0,1,1.33A1.2,1.2,0,0,0,171.15,337.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72,409.72a2,2,0,1,0-1.7-2.21A2,2,0,0,0,232.72,409.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,221.44a1.78,1.78,0,1,0,.17,2.5A1.78,1.78,0,0,0,265,221.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,351.11a1.48,1.48,0,1,0,.14,2.09A1.47,1.47,0,0,0,162.15,351.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,342.57a1.48,1.48,0,0,0,2,2.13,1.41,1.41,0,0,0,.91.11,1.48,1.48,0,1,0-.57-2.9,1.35,1.35,0,0,0-.64.3A1.48,1.48,0,0,0,166,342.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.12,359.8a.88.88,0,0,0,1.25-.08.89.89,0,1,0-1.34-1.17A.89.89,0,0,0,166.12,359.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71,336.94a.89.89,0,0,0,1.17-1.35.89.89,0,0,0-1.17,1.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22,340.94a1.47,1.47,0,0,0,2.25-1.84l.08-.08a1.17,1.17,0,0,0-.09-1.63l.07-.07a.88.88,0,0,0-.09-1.26.89.89,0,0,0-1.33,1.14,1.14,1.14,0,0,0-.35.27,1.22,1.22,0,0,0-.26,1.06,1.47,1.47,0,0,0-.28,2.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.11,322.15a1.78,1.78,0,1,0,.17,2.51A1.78,1.78,0,0,0,189.11,322.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,325.3a1.18,1.18,0,0,0,1.55-1.78A1.18,1.18,0,1,0,184,325.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.94,341.17a1.48,1.48,0,1,0,.14,2.09A1.49,1.49,0,0,0,205.94,341.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.07,369.23a1.48,1.48,0,1,0-.14-2.1A1.49,1.49,0,0,0,225.07,369.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,334a.88.88,0,0,0-1.25.09.9.9,0,0,0,.08,1.25.91.91,0,0,0,1.26-.08A.89.89,0,0,0,199.71,334Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.14,312.46a.89.89,0,1,0-.09-1.25A.89.89,0,0,0,200.14,312.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6,314.25a1.48,1.48,0,1,0,.14,2.08A1.48,1.48,0,0,0,209.6,314.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.26,306.22a1.78,1.78,0,0,0,2.34-2.68,1.78,1.78,0,0,0-2.34,2.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,342.7a1.48,1.48,0,0,0,2.09-.14,1.48,1.48,0,1,0-2.09.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.43,334a1.48,1.48,0,1,0-.14-2.09A1.48,1.48,0,0,0,190.43,334Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.06,283.44a1.45,1.45,0,0,0,1.91-2.18,1.45,1.45,0,1,0-1.91,2.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,349.08a.89.89,0,1,0-1.26.08A.89.89,0,0,0,191.7,349.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,326.3a.89.89,0,1,0-.09-1.25A.9.9,0,0,0,192,326.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,287a1.48,1.48,0,1,0-.14-2.09A1.49,1.49,0,0,0,241,287Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,309.51A1.78,1.78,0,1,0,188,312,1.78,1.78,0,0,0,187.81,309.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.17,310.26a1.78,1.78,0,1,0-.16-2.51A1.79,1.79,0,0,0,175.17,310.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.37,310.74a1.19,1.19,0,1,0,1.56-1.79,1.19,1.19,0,0,0-1.56,1.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,312.07a1.48,1.48,0,0,0-2.09.14,1.48,1.48,0,1,0,2.23,1.94A1.46,1.46,0,0,0,183,312.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93,305.61a1.48,1.48,0,1,0-.14-2.09A1.48,1.48,0,0,0,186.93,305.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,302.58a1.46,1.46,0,1,0,.13,2.05A1.45,1.45,0,0,0,181.43,302.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8,287.16a.89.89,0,1,0-.08-1.25A.89.89,0,0,0,280.8,287.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54,297.89a.89.89,0,1,0-.09-1.25A.89.89,0,0,0,188.54,297.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,299.68a1.46,1.46,0,0,0-2.08.14,1.47,1.47,0,1,0,2.56,1.2,1.58,1.58,0,0,0,3.15-.3,1.59,1.59,0,0,0-3.15-.16A1.43,1.43,0,0,0,198,299.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,252.32a1.78,1.78,0,1,0-.17-2.51A1.78,1.78,0,0,0,222.89,252.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,309.82a1.18,1.18,0,1,0-.12-1.68A1.19,1.19,0,0,0,156.66,309.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.17,311.29a1.48,1.48,0,1,0,2.23,1.94,1.48,1.48,0,0,0-2.23-1.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,302.46a1.48,1.48,0,1,0,.14,2.09A1.48,1.48,0,0,0,173.16,302.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,303.85a1.45,1.45,0,1,0,1.9-2.18,1.45,1.45,0,0,0-1.9,2.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,298.89a1.5,1.5,0,0,0,.15,2.1,1.48,1.48,0,1,0-.15-2.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,413.92a1.78,1.78,0,1,0,.17,2.51A1.78,1.78,0,0,0,180.4,413.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.14,282.32a1.78,1.78,0,1,0,.18,2.51A1.78,1.78,0,0,0,216.14,282.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,431.77a1.48,1.48,0,1,0,.14,2.09A1.48,1.48,0,0,0,170.71,431.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.82,259.31a1.48,1.48,0,1,0,.14,2.08A1.48,1.48,0,0,0,210.82,259.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,319.37a1.45,1.45,0,1,0,2.41.37l.09.1a.89.89,0,0,0,1.17-1.34.89.89,0,0,0-1.25.09.87.87,0,0,0-.16.88,1.19,1.19,0,0,0-.22-.23A1.44,1.44,0,0,0,168.72,319.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,314.54a.91.91,0,0,0,1.26-.09.9.9,0,0,0-.09-1.25.89.89,0,0,0-1.17,1.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,266.32a1.48,1.48,0,1,0-.14-2.09A1.48,1.48,0,0,0,259.83,266.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.94,409.12a1.78,1.78,0,0,0-2.33,2.68,1.78,1.78,0,1,0,2.33-2.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75,324.7a1.78,1.78,0,1,0,.17,2.51A1.78,1.78,0,0,0,71.75,324.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,323.4a1.18,1.18,0,1,0-1.67.12A1.19,1.19,0,0,0,145.49,323.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.49,222.89a1.48,1.48,0,0,0,1.94-2.23,1.49,1.49,0,0,0-2.09.14A1.48,1.48,0,0,0,254.49,222.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,378a1.48,1.48,0,1,0,.14,2.09A1.48,1.48,0,0,0,165,378Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,191a1.45,1.45,0,1,0-.14-2A1.45,1.45,0,0,0,277.11,191Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.39,333.54a.88.88,0,0,0,1.25-.08.89.89,0,0,0-.08-1.26.9.9,0,0,0-1.26.09A.89.89,0,0,0,158.39,333.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,310.59a.89.89,0,0,0,.13-1,1.82,1.82,0,0,0,.59-.45,1.77,1.77,0,1,0-2.51.18,2.64,2.64,0,0,0,.35.23.89.89,0,0,0,1.44,1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.11,404.38a2.68,2.68,0,1,0-2.6,2.77A2.69,2.69,0,0,0,63.11,404.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.33,260a1.79,1.79,0,1,0,1.74-1.84A1.79,1.79,0,0,0,144.33,260Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,241.05a2.25,2.25,0,0,0,2.18-2.31,1.1,1.1,0,0,0,0-.18,1.48,1.48,0,1,0-.55-1.24,2.24,2.24,0,1,0-1.61,3.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.05,189.84a2.2,2.2,0,1,0,2.13-2.26A2.2,2.2,0,0,0,235.05,189.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,257.85a1.35,1.35,0,1,0-1.38-1.3A1.35,1.35,0,0,0,172.65,257.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92,230.82a1.35,1.35,0,1,0-1.38-1.3A1.36,1.36,0,0,0,150.92,230.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.08,225.38a2.24,2.24,0,1,0,4.47-.13,2.24,2.24,0,0,0-4.47.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,207.08a2.66,2.66,0,1,0,2.3-3A2.66,2.66,0,0,0,213.6,207.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.18,219a2.66,2.66,0,1,0-3-2.3A2.68,2.68,0,0,0,204.18,219Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.49,219.1a1.77,1.77,0,1,0,.46,3.52,1.77,1.77,0,0,0-.46-3.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.06,214.54a2.21,2.21,0,1,0,1.91-2.49A2.2,2.2,0,0,0,212.06,214.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.66,201.22a2.22,2.22,0,1,0-2.48-1.91A2.22,2.22,0,0,0,210.66,201.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.92,206.81a2.17,2.17,0,0,0,.38.95,2.18,2.18,0,0,0-.45,1.52,2.21,2.21,0,1,0,4-1.48,2.16,2.16,0,0,0-2-3.42A2.2,2.2,0,0,0,199.92,206.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,214.76a1.33,1.33,0,1,0-2.64.34,1.32,1.32,0,0,0,1.48,1.15A1.34,1.34,0,0,0,228.8,214.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,191.75a1.33,1.33,0,1,0-1.49-1.15A1.33,1.33,0,0,0,203.6,191.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.07,185.41a2.22,2.22,0,1,0,1.92-2.48A2.22,2.22,0,0,0,213.07,185.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.78,230.42a2.65,2.65,0,1,0-2.4,2.88A2.65,2.65,0,0,0,204.78,230.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,240a2.65,2.65,0,1,0,2.41-2.86A2.65,2.65,0,0,0,186.77,240Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87,244a1.77,1.77,0,1,0-1.61,1.92A1.78,1.78,0,0,0,188.87,244Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.44,250.69a2.21,2.21,0,1,0,2-2.39A2.21,2.21,0,0,0,203.44,250.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.81,224.93a2.21,2.21,0,1,0-2.41-2A2.23,2.23,0,0,0,196.81,224.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,230.07a2.16,2.16,0,1,0,2-2.35A2.16,2.16,0,0,0,185.89,230.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,237.94a1.32,1.32,0,0,0-1.2,1.44,1.33,1.33,0,0,0,2.64-.23A1.33,1.33,0,0,0,212.88,237.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.16,215.21a1.33,1.33,0,0,0-.23-2.64,1.33,1.33,0,1,0,.23,2.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,182.73a2.68,2.68,0,1,0,2.29-3A2.68,2.68,0,0,0,194.31,182.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,194.82a2.68,2.68,0,1,0-3-2.31A2.69,2.69,0,0,0,184.89,194.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,194.93a1.79,1.79,0,1,0,2,1.53A1.78,1.78,0,0,0,182.17,194.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.79,190.26a2.24,2.24,0,1,0,1.92-2.52A2.24,2.24,0,0,0,192.79,190.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,172.41a2.23,2.23,0,1,0,2.51,1.91A2.22,2.22,0,0,0,190.71,172.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,212.57a2.19,2.19,0,1,0-1.88,2.47A2.2,2.2,0,0,0,248.17,212.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,189.23a1.34,1.34,0,1,0,1.51,1.15A1.34,1.34,0,0,0,208.16,189.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.76,164.67a1.35,1.35,0,0,0-1.14,1.52,1.34,1.34,0,0,0,2.66-.36A1.36,1.36,0,0,0,183.76,164.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15,162.8a2.23,2.23,0,1,0-2.51-1.92A2.24,2.24,0,0,0,196.15,162.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89,180.7a2.71,2.71,0,1,0-2.4,3A2.72,2.72,0,0,0,172.89,180.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.69,193.26a2.71,2.71,0,1,0-3-2.4A2.71,2.71,0,0,0,157.69,193.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,193.3a1.81,1.81,0,1,0,2,1.6A1.8,1.8,0,0,0,155,193.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,188.85a2.25,2.25,0,1,0,2-2.49A2.27,2.27,0,0,0,165.78,188.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,172.78a2.26,2.26,0,1,0-2,2.49A2.25,2.25,0,0,0,166.61,172.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.88,292.13a2.21,2.21,0,1,0,2-2.44A2.2,2.2,0,0,0,221.88,292.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.82,189.39a1.34,1.34,0,0,0-1.5-1.19,1.28,1.28,0,0,0-.55.18,2.24,2.24,0,0,0-4.43.62,2.25,2.25,0,0,0,2.44,2.05,2.18,2.18,0,0,0,1.53-.82,1.36,1.36,0,0,0,2.51-.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,164a1.35,1.35,0,1,0-1.19,1.48A1.35,1.35,0,0,0,158.8,164Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,161.22a2.25,2.25,0,1,0-2.5-2A2.25,2.25,0,0,0,169.86,161.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.91,213.43a2.7,2.7,0,1,0-.47-5.38,2.7,2.7,0,0,0,.47,5.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,264.16a2.7,2.7,0,1,0-2.45,2.92A2.7,2.7,0,0,0,88.9,264.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.47,272.38a1.8,1.8,0,1,0,1.64-1.95A1.79,1.79,0,0,0,212.47,272.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.16,216a2.25,2.25,0,1,0,2.43,2A2.25,2.25,0,0,0,176.16,216Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.81,202.88a2.25,2.25,0,1,0,2.05-2.44A2.25,2.25,0,0,0,170.81,202.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.14,210.14a2.22,2.22,0,0,0,2.4,2,2.19,2.19,0,0,0,2-2,2.2,2.2,0,0,0,1.11.27,2.24,2.24,0,1,0-2.29-2.38,2.13,2.13,0,0,0-1.2-.24A2.22,2.22,0,0,0,162.14,210.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.83,220.83a1.35,1.35,0,1,0-1.46-1.22A1.35,1.35,0,0,0,189.83,220.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.49,195a1.35,1.35,0,1,0-1.46-1.22A1.34,1.34,0,0,0,166.49,195Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.08,207.25a2.72,2.72,0,1,0-2.89-2.53A2.71,2.71,0,0,0,149.08,207.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,292a2.72,2.72,0,1,0-2.89-2.53A2.71,2.71,0,0,0,82.71,292Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,219.83a1.81,1.81,0,1,0-1.93-1.69A1.8,1.8,0,0,0,133.29,219.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54,214.34a2.26,2.26,0,1,0-2.41-2.11A2.25,2.25,0,0,0,146.54,214.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68,196.14a2.27,2.27,0,1,0-2.12,2.41A2.28,2.28,0,0,0,145.68,196.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.67,203.28a2.21,2.21,0,1,0-2.06,2.36A2.22,2.22,0,0,0,136.67,203.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.21,213.54a1.37,1.37,0,1,0-1.28,1.44A1.37,1.37,0,0,0,161.21,213.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,187a1.36,1.36,0,1,0-1.27,1.44A1.37,1.37,0,0,0,138.23,187Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56,182.26a2.27,2.27,0,0,0-4.53.3,2.27,2.27,0,1,0,4.53-.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,369.77a1.77,1.77,0,0,0-2-1.52,1.78,1.78,0,1,0,.49,3.52A1.76,1.76,0,0,0,136,369.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,378.29a1.77,1.77,0,0,0,1.52-2,1.78,1.78,0,1,0-1.52,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,380.72a1.19,1.19,0,1,0-.33-2.35,1.19,1.19,0,1,0,.33,2.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,375.25a1.48,1.48,0,1,0,1.26-1.68A1.48,1.48,0,0,0,131.47,375.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,364.69a1.48,1.48,0,1,0-1.26,1.68A1.49,1.49,0,0,0,131.71,364.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19,369.78a1.45,1.45,0,1,0-1.23,1.63A1.45,1.45,0,0,0,126.19,369.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,374.52a.89.89,0,0,0-.76,1,.9.9,0,0,0,1,.76.89.89,0,0,0-.25-1.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67,360.09a.89.89,0,1,0-1-.75A.89.89,0,0,0,125.67,360.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62,357.05a1.48,1.48,0,1,0-1.67-1.26A1.48,1.48,0,0,0,133.62,357.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65,347.88a1.78,1.78,0,1,0-1.4,2.09A1.79,1.79,0,0,0,174.65,347.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.83,354.87a1.77,1.77,0,0,0-2.09-1.39,1.77,1.77,0,1,0,2.09,1.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.65,357.15a1.19,1.19,0,1,0,1.39.93A1.2,1.2,0,0,0,163.65,357.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,354.78a1.48,1.48,0,1,0-1.74-1.16A1.49,1.49,0,0,0,172.21,354.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,273.77a1.46,1.46,0,1,0,1.72,1.15A1.46,1.46,0,0,0,235.66,273.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,360.79a1.78,1.78,0,1,0-2.06-1.46A1.78,1.78,0,0,0,160.17,360.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.11,366.11a1.78,1.78,0,1,0,1.45-2A1.78,1.78,0,0,0,150.11,366.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.4,369.07a1.18,1.18,0,1,0,2.33-.4,1.16,1.16,0,0,0-1.36-1A1.18,1.18,0,0,0,149.4,369.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29,364.36a1.48,1.48,0,0,0,2.92-.5,1.48,1.48,0,0,0-2.92.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,355.52a1.48,1.48,0,1,0-.5-2.92,1.47,1.47,0,0,0-1.21,1.7A1.49,1.49,0,0,0,156,355.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,359.55a1.45,1.45,0,1,0,1.18-1.67A1.44,1.44,0,0,0,149,359.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,363.31a.89.89,0,1,0,.31,1.75.89.89,0,1,0-.31-1.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,347.64a.89.89,0,1,0,.3,1.75.81.81,0,0,0,.22-.07A1.18,1.18,0,1,0,153.1,348a1.18,1.18,0,0,0-1.54,0A.92.92,0,0,0,150.71,347.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86,346.1a1.48,1.48,0,0,0,1.2-1.71,1.11,1.11,0,0,0-.07-.26,1.5,1.5,0,0,0,.75-.45,1.45,1.45,0,1,0-2.46-.48,1.48,1.48,0,0,0,.58,2.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.55,207.09a1.78,1.78,0,1,0,2.11,1.37A1.79,1.79,0,0,0,257.55,207.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.17,339.58a1.77,1.77,0,1,0-2.1-1.36A1.78,1.78,0,0,0,156.17,339.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.48,341.19a1.17,1.17,0,0,0,1.4.92,1.19,1.19,0,0,0,.91-1.41,1.18,1.18,0,0,0-2.31.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,335.56a1.47,1.47,0,1,0-1.13,1.76l.1,0a.89.89,0,0,0,.76,1.54.9.9,0,0,0,.69-1,.88.88,0,0,0-1-.71A1.47,1.47,0,0,0,164.06,335.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,391.39a1.48,1.48,0,0,0-1.76-1.14,1.48,1.48,0,1,0,.62,2.9A1.46,1.46,0,0,0,187.36,391.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.53,333.42a2.07,2.07,0,1,0-2.46-1.59A2.07,2.07,0,0,0,154.53,333.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.33,335.42a.91.91,0,0,0-.18-.37,1.49,1.49,0,0,0,.55-1.47,1.48,1.48,0,0,0-2.9.59,1.48,1.48,0,0,0,.86,1.06.89.89,0,1,0,1.67.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42,315a1.48,1.48,0,1,0,.61,2.9,1.46,1.46,0,0,0,1-.79v0a1.48,1.48,0,1,0,.14-.89.31.31,0,0,0,0-.1A1.47,1.47,0,0,0,161.42,315Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.58,328.46a1.78,1.78,0,0,0-.72-3.48,1.78,1.78,0,1,0,.72,3.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,335.49a1.77,1.77,0,1,0-2.1-1.38A1.77,1.77,0,0,0,138.8,335.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,335.69a1.18,1.18,0,1,0,1.39.92A1.18,1.18,0,0,0,137,335.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,332.13a1.48,1.48,0,0,0,2.9-.6,1.48,1.48,0,1,0-2.9.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,323.32a1.46,1.46,0,0,0,1.16-1.74,1.49,1.49,0,0,0-1.75-1.16C140.83,320.59,141.43,323.49,142.22,323.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.35,327.58a1.45,1.45,0,1,0,1.14-1.71A1.47,1.47,0,0,0,135.35,327.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.45,263.69a.89.89,0,1,0,.69-1.06A.89.89,0,0,0,276.45,263.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,315.62a.89.89,0,0,0,.35,1.75.89.89,0,1,0-.35-1.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.05,387.07a1.47,1.47,0,1,0-1.74-1.15A1.48,1.48,0,0,0,108.05,387.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.24,343.72a1.78,1.78,0,1,0-1.45,2.06A1.78,1.78,0,0,0,149.24,343.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,242a1.78,1.78,0,1,0,1.44-2.05A1.78,1.78,0,0,0,261.63,242Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,352.71a1.18,1.18,0,1,0,1.37,1A1.18,1.18,0,0,0,138,352.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.63,350.56a1.48,1.48,0,1,0-1.71-1.2A1.48,1.48,0,0,0,146.63,350.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,339.3a1.49,1.49,0,0,0,1.72,1.21,1.48,1.48,0,1,0-1.72-1.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,401.93a2.05,2.05,0,0,0-2.39-1.68,2.07,2.07,0,1,0,2.39,1.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,350.05a.9.9,0,0,0,.58-.37,1.81,1.81,0,0,0,.9-.55,1.77,1.77,0,1,0-2.67-2.33,1.75,1.75,0,0,0,.17,2.49h0v0A.89.89,0,0,0,155.37,350.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.05,238a1.48,1.48,0,0,0-.5-2.92,1.48,1.48,0,1,0,.5,2.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.32,340.59a1.78,1.78,0,1,0,1.46-2A1.78,1.78,0,0,0,126.32,340.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,347.35a1.77,1.77,0,1,0,1.45-2.05A1.78,1.78,0,0,0,118.31,347.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,351.28a1.19,1.19,0,1,0-1.37-1A1.19,1.19,0,0,0,119,351.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,345.12a1.48,1.48,0,1,0-1.21,1.7A1.48,1.48,0,0,0,128.41,345.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,336.77a1.49,1.49,0,1,0-1.71-1.22A1.48,1.48,0,0,0,124.2,336.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.82,254.45a1.45,1.45,0,1,0,1.67,1.19A1.45,1.45,0,0,0,222.82,254.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,345.61a.89.89,0,1,0,.72-1A.87.87,0,0,0,134.92,345.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,326.15a1.45,1.45,0,0,0,1.7,1.2,1.47,1.47,0,0,0,1.21-1.7,1.48,1.48,0,1,0-2.91.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,291.24a1.76,1.76,0,0,0,2,1.51,1.78,1.78,0,1,0-2-1.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,299.35a1.19,1.19,0,0,0-1,1.34,1.19,1.19,0,1,0,1-1.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,295.82a1.48,1.48,0,1,0-1.26,1.67A1.48,1.48,0,0,0,132.83,295.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,230.77a1.48,1.48,0,1,0-1.25,1.67A1.47,1.47,0,0,0,96.71,230.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9,241.05a1.45,1.45,0,1,0-1.23,1.64A1.45,1.45,0,0,0,107.9,241.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,295.5a.89.89,0,1,0,.25,1.76.89.89,0,1,0-.25-1.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,279.31a.89.89,0,1,0,1,.76A.9.9,0,0,0,123.85,279.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,276.36A1.48,1.48,0,1,0,132,278,1.48,1.48,0,0,0,133.3,276.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,267.47a1.77,1.77,0,1,0,2.09,1.39A1.76,1.76,0,0,0,171,267.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38,229.51a1.18,1.18,0,1,0,.93-1.4A1.17,1.17,0,0,0,156.38,229.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.64,275.76A1.48,1.48,0,0,0,171.8,274a1.48,1.48,0,0,0-2.9.58A1.48,1.48,0,0,0,170.64,275.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.51,264.05a1.48,1.48,0,1,0-1.15,1.74A1.47,1.47,0,0,0,168.51,264.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.21,259.81a.9.9,0,0,0,.7-1.05.89.89,0,1,0-.7,1.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,254.56a1.48,1.48,0,1,0-2,1.65.82.82,0,0,0-.07.56.88.88,0,1,0,1.73-.37.8.8,0,0,0-.18-.37A1.46,1.46,0,0,0,171.13,254.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,286.49a1.78,1.78,0,1,0-1.45,2.05A1.77,1.77,0,0,0,152,286.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16,289.65a1.16,1.16,0,0,0-1.36-1,1.18,1.18,0,0,0-1,1.36,1.2,1.2,0,0,0,1.38,1A1.18,1.18,0,0,0,150.16,289.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,283.86a1.59,1.59,0,0,0,.88-1.29,1.65,1.65,0,0,0-.17-.83,1.77,1.77,0,1,0-2.17-1.42,1.9,1.9,0,0,0,.25.64,1.59,1.59,0,0,0-1.05,1.38,1.55,1.55,0,0,0,.75,1.45,1.47,1.47,0,0,0-.77,1.55,1.48,1.48,0,1,0,2.28-1.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.7,275.29a1.48,1.48,0,1,0,1.2-1.72A1.48,1.48,0,0,0,152.7,275.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.83,289.46a.88.88,0,0,0,.73-1,.89.89,0,1,0-1.75.3A.88.88,0,0,0,215.83,289.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.58,265.87a1.48,1.48,0,1,0,1.2-1.7A1.47,1.47,0,0,0,155.58,265.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,261.79a1.78,1.78,0,1,0,1.37-2.12A1.78,1.78,0,0,0,218,261.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,262.18a1.17,1.17,0,0,0,1.4.91,1.19,1.19,0,0,0-.49-2.32A1.18,1.18,0,0,0,151.91,262.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,394.42a1.47,1.47,0,1,0-1.13,1.76A1.47,1.47,0,0,0,142.39,394.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.29,222.75a1.48,1.48,0,1,0-1,1.84A1.5,1.5,0,0,0,188.29,222.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,254.4a2.07,2.07,0,1,0-.86-4.05,2.07,2.07,0,0,0,.86,4.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,241.77a.88.88,0,1,0,.68-1.06A.88.88,0,0,0,151.69,241.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,249.33a1.47,1.47,0,0,0-.75,1.54,1.44,1.44,0,0,0,.19.5,1.47,1.47,0,0,0-1.13,1.73,1.48,1.48,0,1,0,2.9-.59,1.29,1.29,0,0,0-.18-.45,1.48,1.48,0,0,0,1.14-1.7,1.5,1.5,0,0,0-.74-1,1.78,1.78,0,1,0-1.43,0Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.13,255.09a1.77,1.77,0,1,0,1.38-2.1A1.77,1.77,0,0,0,135.13,255.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.51,258.07a1.18,1.18,0,1,0,2.32-.48,1.18,1.18,0,1,0-2.32.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,242.55a1.47,1.47,0,0,0-1.74-1.15,1.48,1.48,0,1,0,1.74,1.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.78,248.56a1.45,1.45,0,1,0,1.13-1.71A1.45,1.45,0,0,0,133.78,248.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.54,249.69a.89.89,0,0,0-1-.69.9.9,0,0,0-.7,1.05.87.87,0,0,0,1.05.68A.89.89,0,0,0,213.54,249.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,237.3a.88.88,0,0,0-1-.69.89.89,0,1,0,1,.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,234.81a1.48,1.48,0,1,0-1.74-1.16A1.48,1.48,0,0,0,143.22,234.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.63,227.83a1.77,1.77,0,0,0,2.05,1.45,1.78,1.78,0,1,0-.61-3.5A1.76,1.76,0,0,0,213.63,227.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.43,273.69a1.16,1.16,0,0,0-1,1.36,1.18,1.18,0,1,0,1-1.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34,270.34a1.48,1.48,0,0,0,2.92-.51,1.46,1.46,0,0,0-1.71-1.2A1.48,1.48,0,0,0,143.34,270.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,260.28a1.49,1.49,0,1,0,1.21-1.71A1.49,1.49,0,0,0,140.31,260.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,267.32a2.06,2.06,0,0,0,1.69-2.39,2.07,2.07,0,0,0-4.09.64,1,1,0,0,0-.35,0,.89.89,0,0,0,.3,1.75.92.92,0,0,0,.68-.54A2,2,0,0,0,136.81,267.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.53,270a.9.9,0,0,0-1-.73.89.89,0,0,0,.31,1.76A.91.91,0,0,0,154.53,270Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,261a1.78,1.78,0,1,0-1.46,2A1.79,1.79,0,0,0,128.26,261Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.24,267.73a1.78,1.78,0,1,0-1.46,2A1.77,1.77,0,0,0,120.24,267.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35,270.89a1.18,1.18,0,1,0-2.33.4,1.18,1.18,0,0,0,2.33-.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13,264.88a1.48,1.48,0,1,0,1.7,1.22A1.47,1.47,0,0,0,125.13,264.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,256.53a1.48,1.48,0,1,0,1.21-1.71A1.49,1.49,0,0,0,120.92,256.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,364.27a1.46,1.46,0,1,0,1.68,1.19A1.47,1.47,0,0,0,109.08,364.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39,250.59a.89.89,0,1,0-1.75.3.89.89,0,1,0,1.75-.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,248.34a1.48,1.48,0,1,0-1.72-1.21A1.49,1.49,0,0,0,125.53,248.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,389.66a2.36,2.36,0,1,0,1.62,2.91A2.37,2.37,0,0,0,347.25,389.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.85,404.74a2.35,2.35,0,1,0,2.9-1.63A2.36,2.36,0,0,0,347.85,404.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,408.25a1.57,1.57,0,1,0,1.93-1.09A1.57,1.57,0,0,0,351.52,408.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,395.63a2,2,0,1,0,2.42-1.35A2,2,0,0,0,350.14,395.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,395.9a2,2,0,1,0-1.35-2.42A2,2,0,0,0,337.74,395.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.65,402.86a1.92,1.92,0,1,0,2.37-1.33A1.92,1.92,0,0,0,339.65,402.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.05,385.33a1.18,1.18,0,0,0,2.27.64,1.18,1.18,0,1,0-2.27-.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,396.34a1.18,1.18,0,1,0,1.46-.81A1.19,1.19,0,0,0,327.73,396.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,384.64a2,2,0,1,0,3.77,1.07,1.94,1.94,0,0,0-1.35-2.42A2,2,0,0,0,326.79,384.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,419.82a2.36,2.36,0,1,0-2.18,2.53A2.36,2.36,0,0,0,296.38,419.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.34,431.24a2.37,2.37,0,0,0-2.54-2.17,2.35,2.35,0,1,0,2.54,2.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.3,433.63a1.57,1.57,0,0,0,3.05.41,1.19,1.19,0,1,0,.59-2.12,1.19,1.19,0,0,0-.88.58,1.54,1.54,0,0,0-1.32-.56A1.57,1.57,0,0,0,304.3,433.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.87,354.15a2,2,0,1,0,2.94-1.85,2,2,0,0,0,1.48-1.76,2,2,0,1,0-2.93,1.56A2,2,0,0,0,225.87,354.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,479.33a2,2,0,1,0,2.11,1.81A2,2,0,0,0,297,479.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.51,455.92a1.93,1.93,0,1,0-2.07-1.78A1.93,1.93,0,0,0,224.51,455.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,409.26a1.18,1.18,0,1,0,1.26,1.09A1.18,1.18,0,0,0,301.7,409.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,429.43a1.17,1.17,0,0,0-1.09,1.26,1.19,1.19,0,0,0,1.28,1.09,1.17,1.17,0,0,0,1.07-1.28A1.16,1.16,0,0,0,278.91,429.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,339.26A2,2,0,1,0,304,339a2,2,0,0,0-3.92.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,408a2.37,2.37,0,1,0,2.54-2.17A2.35,2.35,0,0,0,312,408Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,371a2.36,2.36,0,1,0,2.54-2.18A2.37,2.37,0,0,0,385.06,371Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,423.19a1.57,1.57,0,1,0,3.14.24,1.57,1.57,0,0,0-3.14-.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.51,413.65a2,2,0,1,0-2.11,1.82A2,2,0,0,0,332.51,413.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,412a2,2,0,1,0-3.93-.3,2,2,0,0,0,1.81,2.11,1.93,1.93,0,0,0,1.27-.35.93.93,0,0,0-.11.57.91.91,0,0,0,1,.73.89.89,0,1,0-.3-1.76.55.55,0,0,0-.18.06A2,2,0,0,0,308.55,412Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.73,351.81A1.93,1.93,0,1,0,324.8,350,1.93,1.93,0,0,0,322.73,351.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,399.76a1.18,1.18,0,1,0,1.27-1.08A1.17,1.17,0,0,0,322.31,399.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,417.52a1.18,1.18,0,0,0,.17-2.35,1.18,1.18,0,1,0-.17,2.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.23,407.06a2,2,0,1,0,.3-3.93,2,2,0,0,0-.3,3.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,454.47a2.37,2.37,0,1,0,4.71-.57,2.37,2.37,0,0,0-4.71.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.75,455.93a1.58,1.58,0,1,0-1.39,1.76A1.58,1.58,0,0,0,314.75,455.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41,445.13a2,2,0,1,0,1.73-2.2A2,2,0,0,0,305.41,445.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,523.34a2,2,0,1,0-1.73,2.2A2,2,0,0,0,160.67,523.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,480.81a2.76,2.76,0,1,0,2.41-3.08A2.76,2.76,0,0,0,325,480.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,503.74a2,2,0,1,0-1.73,2.2A2,2,0,0,0,185,503.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.4,449.91a2.38,2.38,0,1,0-2.49-2.26A2.38,2.38,0,0,0,323.4,449.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.39,459.12a2.38,2.38,0,1,0-2.26,2.49A2.39,2.39,0,0,0,333.39,459.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.79,459.87a1.57,1.57,0,0,0-1.5,1.65,1.59,1.59,0,1,0,1.5-1.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.87,449.92a2,2,0,1,0,1.88-2.07A2,2,0,0,0,327.87,449.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,452.13a2,2,0,1,0-1.88,2.08A2,2,0,0,0,318,452.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,458.2a1.94,1.94,0,1,0,2,1.84A1.94,1.94,0,0,0,322,458.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.54,438a1.19,1.19,0,1,0-2.38.12,1.19,1.19,0,0,0,2.38-.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.06,457.76a1.19,1.19,0,1,0-1.12,1.26A1.19,1.19,0,0,0,309.06,457.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,437.11a2.39,2.39,0,1,0,2.2,2.56A2.4,2.4,0,0,0,337.92,437.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.42,440.58a1.59,1.59,0,1,0,1.48,1.69A1.59,1.59,0,0,0,341.42,440.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,430.81a2,2,0,1,0-2.12,1.83A2,2,0,0,0,325.67,430.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.71,511.84a2.77,2.77,0,1,0,3-2.57A2.76,2.76,0,0,0,300.71,511.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.51,418.41a1.19,1.19,0,0,0,2.38.18,1.19,1.19,0,1,0-2.38-.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,434a1.19,1.19,0,1,0,1.1,1.27A1.19,1.19,0,0,0,315,434Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.51,421.91a2,2,0,0,0-2.12,1.83,2,2,0,1,0,4,.29A2,2,0,0,0,312.51,421.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.93,430.83a2.37,2.37,0,1,0,4.7.63,2.37,2.37,0,0,0-4.7-.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.39,443.72a2.37,2.37,0,1,0,2.66-2A2.37,2.37,0,0,0,357.39,443.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.55,446.69a1.58,1.58,0,1,0,1.78-1.36A1.59,1.59,0,0,0,361.55,446.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.34,434.32a2,2,0,1,0,2.22-1.7A2,2,0,0,0,358.34,434.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.25,434.69a2,2,0,1,0-2.22,1.7A2,2,0,0,0,348.25,434.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,443.05a1.94,1.94,0,1,0,2.17-1.67A1.93,1.93,0,0,0,349,443.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.73,423.19a1.19,1.19,0,1,0,1.34-1A1.18,1.18,0,0,0,362.73,423.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.7,425.07a2,2,0,0,0-2,1,2.38,2.38,0,1,0-.06,1.85,1.94,1.94,0,0,0,1.51,1.1,2.08,2.08,0,0,0,.93-.11,1.88,1.88,0,0,0-.34.95A2,2,0,1,0,337.9,428a2,2,0,0,0-.82.12,2,2,0,0,0-1.38-3.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,336a2.35,2.35,0,1,0,2.91-1.62A2.35,2.35,0,0,0,326,336Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.73,445.5a2.35,2.35,0,0,0,2.83-1.41,2.31,2.31,0,0,0,.75.89,1.57,1.57,0,1,0,1.49,2,1.59,1.59,0,0,0-.45-1.57,2.63,2.63,0,0,0,.63,0,2.68,2.68,0,0,0,.63-.18,1.69,1.69,0,0,0-.23,1.13,1.75,1.75,0,0,0,.72,1.19,2,2,0,1,0,2.42-2.53,1.76,1.76,0,0,0-1.63-.66,1.31,1.31,0,0,0-.27.06,2.37,2.37,0,0,0-2.22-3.73,2.39,2.39,0,0,0-1.92,1.52,2.35,2.35,0,1,0-2.75,3.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.16,434.57a2,2,0,1,0-2.42,1.36A2,2,0,0,0,300.16,434.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,432.42a2,2,0,1,0-2.44,1.35A2,2,0,0,0,286.43,432.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.27,439.4a1.91,1.91,0,0,0-2.06.72.75.75,0,0,0-.21,0,1.77,1.77,0,1,0,.7,3.48,1.71,1.71,0,0,0,.87-.46,1.9,1.9,0,0,0,2-1.38A1.92,1.92,0,0,0,288.27,439.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,423.84a1.18,1.18,0,0,0-2.27-.64,1.18,1.18,0,0,0,2.27.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,435.67a1.18,1.18,0,0,0,1.46-.82,1.18,1.18,0,1,0-1.46.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,422.19a.89.89,0,0,0,0,1.69,2,2,0,0,0,1.24,1.06,2,2,0,1,0-1.22-2.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.46,460.22a2.36,2.36,0,1,0-2.53-2.17A2.35,2.35,0,0,0,240.46,460.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,469.11a2.36,2.36,0,1,0-2.17,2.53A2.35,2.35,0,0,0,250.59,469.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,471.49a1.58,1.58,0,0,0,1.68,1.46,1.59,1.59,0,0,0,1.37-1,1.22,1.22,0,0,0,.88.24,1.18,1.18,0,0,0,1-1.32,1.2,1.2,0,0,0-1.32-1,1.17,1.17,0,0,0-.87.58,1.57,1.57,0,0,0-2.77,1.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,460.12a2,2,0,0,0,3.58.95,1.18,1.18,0,0,0,.18.21,1.18,1.18,0,1,0,1.56-1.78,1.16,1.16,0,0,0-1.47-.06,2,2,0,0,0-3.85.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.33,464.68a2,2,0,1,0-2.11-1.82A2,2,0,0,0,233.33,464.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,472.32a1.93,1.93,0,0,0-.29-3.84,1.93,1.93,0,1,0,.29,3.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.87,448.39a1.18,1.18,0,1,0,1.09-1.27A1.19,1.19,0,0,0,246.87,448.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44,468.38a1.18,1.18,0,1,0-1.09,1.27A1.2,1.2,0,0,0,226.44,468.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,455.78a2,2,0,1,0,2.11,1.81A2,2,0,0,0,221,455.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.94,368.68a2.36,2.36,0,1,0,2.54-2.17A2.37,2.37,0,0,0,238.94,368.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.82,448.94a2,2,0,0,0,3.92.3,2,2,0,1,0-3.92-.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.69,451.68a2,2,0,0,0,2.11-1.81,2,2,0,0,0-.69-1.65.86.86,0,0,0,.72-.3.9.9,0,0,0-.09-1.26.89.89,0,0,0-1.25.09.88.88,0,0,0-.06,1.09,2.85,2.85,0,0,0-.44-.09,2,2,0,0,0-.3,3.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57,493.9a1.93,1.93,0,1,0-2.06,1.78A1.92,1.92,0,0,0,195.57,493.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.57,437.63a1.18,1.18,0,0,0,1.09,1.27,1.18,1.18,0,1,0,.18-2.36A1.18,1.18,0,0,0,268.57,437.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,402.68a1.19,1.19,0,0,0-1.09-1.27,1.18,1.18,0,1,0,1.09,1.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.49,444.93a2,2,0,0,0,2.11-1.83,2,2,0,0,0-3.92-.29A2,2,0,0,0,241.49,444.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,483.29a2.37,2.37,0,1,0-2.65-2.07A2.37,2.37,0,0,0,247.24,483.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,491.78a2.37,2.37,0,1,0-2.08,2.63A2.37,2.37,0,0,0,257.8,491.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,493.79a1.59,1.59,0,1,0-1.38,1.77A1.59,1.59,0,0,0,261,493.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,483a2,2,0,1,0,1.73-2.19A2,2,0,0,0,251.67,483Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.26,488.07a2,2,0,0,0-.47-3.93,2,2,0,1,0,.47,3.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,492.09a1.18,1.18,0,0,0-2.35.29,1.19,1.19,0,0,0,1.33,1A1.16,1.16,0,0,0,233.48,492.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.71,481.87a2,2,0,0,0,3.93-.47,2,2,0,0,0-2.21-1.73A2,2,0,0,0,225.71,481.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,487.77a2.36,2.36,0,0,0,2.21-1.94,1.8,1.8,0,0,0,1.83.72,1.77,1.77,0,0,0-.74-3.47,1.75,1.75,0,0,0-1.32,1.21,2.37,2.37,0,0,0-4.47,1.23A2.36,2.36,0,0,0,269.66,487.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.65,587.35a2.37,2.37,0,1,0-2.24,2.49A2.38,2.38,0,0,0,184.65,587.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,499.39a1.59,1.59,0,1,0,1.5-1.66A1.58,1.58,0,0,0,279.54,499.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,563.67a2,2,0,1,0-3.95.2,2,2,0,0,0,3.95-.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,492.08a2,2,0,1,0-2.08-1.88A2,2,0,0,0,262.36,492.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.45,498.1a1.94,1.94,0,1,0,1.84-2A1.94,1.94,0,0,0,266.45,498.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8,475.9a1.25,1.25,0,0,0-.46-.88h.1a.89.89,0,1,0-1-.73.92.92,0,0,0,.25.49h-.11a1.19,1.19,0,1,0,1.25,1.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,494.51a1.19,1.19,0,1,0,.12,2.37,1.19,1.19,0,0,0-.12-2.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,486.76a2,2,0,1,0-2.08-1.88A2,2,0,0,0,250.32,486.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.39,464.59a2.38,2.38,0,0,0,2.2,2.54,2.35,2.35,0,0,0,2.33-1.37,2,2,0,0,0,3.73-.6,2,2,0,0,0-1.7-2.22,2,2,0,0,0-2,1,2.38,2.38,0,0,0-4.6.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,479.92a1.59,1.59,0,1,0,1.7-1.47A1.59,1.59,0,0,0,286,479.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.06,532.46a2,2,0,1,0,2.13-1.83A2,2,0,0,0,290.06,532.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.8,511.42a2,2,0,1,0,2.13-1.84A2,2,0,0,0,188.8,511.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.28,397.94a2.77,2.77,0,1,0,3-2.57A2.76,2.76,0,0,0,316.28,397.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,457.55a1.19,1.19,0,0,0,.17-2.37h-.14a1.18,1.18,0,0,0,.32-1,1.19,1.19,0,0,0-1.31-1,1.21,1.21,0,0,0-1.05,1.32,1,1,0,0,1,.9,1.78A1.19,1.19,0,0,0,286.88,457.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,473a1.19,1.19,0,1,0,1.27-1.09A1.18,1.18,0,0,0,260,473Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.23,471.37a2.38,2.38,0,1,0-2-2.67A2.37,2.37,0,0,0,300.23,471.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.64,481.59a2.37,2.37,0,1,0,2.66-2A2.38,2.38,0,0,0,303.64,481.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.81,484.55a1.58,1.58,0,1,0,1.77-1.35A1.57,1.57,0,0,0,307.81,484.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,472.71a2,2,0,1,0-2.21,1.7A2,2,0,0,0,308.51,472.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,472.52a2,2,0,1,0-2.22,1.71A2,2,0,0,0,128.15,472.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,368.55a1.94,1.94,0,1,0,2.18-1.67A1.94,1.94,0,0,0,343.33,368.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33,460a1.19,1.19,0,1,0-.32,2.35,1.19,1.19,0,0,0,.32-2.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.61,375.59a2.36,2.36,0,1,0-1.62-2.91A2.35,2.35,0,0,0,238.61,375.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,386.12a2.35,2.35,0,1,0,2.9-1.62A2.35,2.35,0,0,0,240.51,386.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.25,391.58a1.57,1.57,0,0,0,1.34-.24,1,1,0,0,0,.39,0,.88.88,0,0,0,.69-1,.91.91,0,0,0-.47-.62,1.57,1.57,0,1,0-1.95,1.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,377a2,2,0,1,0,2.43-1.35A2,2,0,0,0,242.79,377Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.47,373.51a2,2,0,1,0,1.35,2.43A2,2,0,0,0,231.47,373.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.63,386.62A1.91,1.91,0,0,0,236,385.3a1.93,1.93,0,0,0-1.32-2.38,2.18,2.18,0,0,0-.8-.05,1.48,1.48,0,1,0-1.32.84,1.93,1.93,0,0,0-.26.54A1.91,1.91,0,0,0,233.63,386.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,366.72a1.18,1.18,0,1,0,1.46-.81A1.18,1.18,0,0,0,248.7,366.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2,379.19a1.18,1.18,0,1,0-.81-1.46A1.17,1.17,0,0,0,221.2,379.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,364.69a2,2,0,1,0,1.35,2.42A2,2,0,0,0,221.87,364.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,401.22a2.36,2.36,0,1,0-2.17,2.53A2.36,2.36,0,0,0,189,401.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,412.63a2.36,2.36,0,1,0-2.17,2.53A2.36,2.36,0,0,0,197,412.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39,405.46a2,2,0,1,0-2.11-1.81A2,2,0,0,0,193.39,405.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,413.78a1.93,1.93,0,0,0-3.84.29,1.94,1.94,0,0,0,2.07,1.78A1.91,1.91,0,0,0,187.77,413.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,391.92a1.18,1.18,0,0,0,2.36-.18,1.18,1.18,0,0,0-2.36.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.83,411.9a1.18,1.18,0,1,0-1.08,1.27A1.17,1.17,0,0,0,172.83,411.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65,403.22a2,2,0,1,0-2.11-1.8A2,2,0,0,0,167.65,403.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,389.35a2.37,2.37,0,1,0,2.53-2.17A2.36,2.36,0,0,0,204.65,389.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,495.57a2.36,2.36,0,1,0-2.54,2.17A2.37,2.37,0,0,0,143.39,495.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,404.59a1.57,1.57,0,1,0,1.69-1.45A1.56,1.56,0,0,0,215.09,404.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.51,553.63a2,2,0,0,0-1.8-2.11,2,2,0,1,0,1.8,2.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.28,393.09a2,2,0,0,0,3.92.3,2.19,2.19,0,0,1,.49-3.91,9.54,9.54,0,0,0-4.41,3.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,447.55a1.93,1.93,0,1,0-2.07,1.78A1.93,1.93,0,0,0,167.35,447.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.05,382.42a1.18,1.18,0,1,0-1.08-1.26A1.17,1.17,0,0,0,216.05,382.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.43,398.91a1.18,1.18,0,1,0-1.09-1.27A1.17,1.17,0,0,0,190.43,398.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,386.63a2,2,0,1,0-2.11,1.82A2,2,0,0,0,190,386.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,426.65a1.76,1.76,0,0,0,.6,1.42,1.79,1.79,0,0,0,1.57.39,2,2,0,1,0,1.87-2.13,1.85,1.85,0,0,0-.53.11,1.76,1.76,0,0,0-.5-1,2.31,2.31,0,0,0,.22-1.31,2.37,2.37,0,1,0-3.23,2.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.49,435.87a2.37,2.37,0,1,0,2.06-2.65A2.37,2.37,0,0,0,199.49,435.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.4,437.32a1.58,1.58,0,1,0-1.38,1.76A1.56,1.56,0,0,0,207.4,437.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,424.32a2,2,0,1,0,2.19,1.73A2,2,0,0,0,199.8,424.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.39,429.39a2,2,0,1,0-1.73,2.2A2,2,0,0,0,188.39,429.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,434.89a1.19,1.19,0,1,0-1,1.31A1.18,1.18,0,0,0,139.63,434.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.89,435.62a1.19,1.19,0,1,0-1,1.32A1.2,1.2,0,0,0,179.89,435.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,424.92a2,2,0,0,0-2.21-1.72,2,2,0,1,0,2.21,1.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,443a2.38,2.38,0,1,0-2.49-2.25A2.37,2.37,0,0,0,223.78,443Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,433.19a2,2,0,1,0-2.08-1.88A2,2,0,0,0,222.6,433.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64,433.52a2,2,0,1,0-1.88,2.08A2,2,0,0,0,210.64,433.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.91,479.15a1.94,1.94,0,1,0-1.84,2A2,2,0,0,0,188.91,479.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,420.66a1.18,1.18,0,0,0,1.12-1.24,1.2,1.2,0,0,0-1.24-1.13,1.19,1.19,0,1,0,.12,2.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.59,440.41a1.19,1.19,0,0,0-.12-2.38,1.19,1.19,0,0,0,.12,2.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.77,421.06a2.37,2.37,0,0,0-1.72-2.47,1.77,1.77,0,1,0-2.9,1l.2.14a2.31,2.31,0,0,0-.32,1,2.38,2.38,0,0,0,4.74.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,423.44a1.58,1.58,0,0,0,1.47,1.7.83.83,0,0,0,.22,0,1.45,1.45,0,1,0,1.43-1.19,2.33,2.33,0,0,0,.05-.28,1.59,1.59,0,0,0-3.17-.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,327.78a2,2,0,1,0-.29,4,2,2,0,0,0,2.12-1.85A2,2,0,0,0,223.64,327.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,411.91a2,2,0,1,0,2.13-1.84A2,2,0,0,0,214.36,411.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.53,489.44a2.78,2.78,0,1,0-2.58-3A2.77,2.77,0,0,0,165.53,489.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.23,488.1a1.2,1.2,0,0,0-1.1-1.28,1.19,1.19,0,0,0-.18,2.38A1.2,1.2,0,0,0,187.23,488.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48,417.81a1.2,1.2,0,0,0,1.27-1.11,1.19,1.19,0,0,0-1.1-1.27,1.19,1.19,0,0,0-.17,2.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87,407.25a2,2,0,1,0,.29-3.95,2,2,0,0,0-.29,3.95Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,517.06a2.37,2.37,0,1,0-2-2.66A2.39,2.39,0,0,0,173.25,517.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,429.86a1.58,1.58,0,1,0-1.35-1.78A1.59,1.59,0,0,0,255.56,429.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,415.72a2,2,0,0,0,1.71,2.21,2,2,0,0,0,.52-3.91A2,2,0,0,0,251,415.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.91,416.09a2,2,0,0,0-1.71-2.23,2,2,0,0,0-.51,3.93A2,2,0,0,0,240.91,416.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,404.9a1.19,1.19,0,1,0-2.35-.31,1.17,1.17,0,0,0,1,1.32A1.19,1.19,0,0,0,257.74,404.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,333.92a2,2,0,0,0-.52,3.91,2,2,0,1,0,.52-3.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.6,522.2a1.78,1.78,0,1,0,2.34-2.68,1.78,1.78,0,0,0-2.34,2.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.41,392.53a1.48,1.48,0,1,0,1.94-2.23,1.48,1.48,0,0,0-1.94,2.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,401.07a1.48,1.48,0,0,0-2-2.13,1.45,1.45,0,0,0-.92-.11,1.47,1.47,0,0,0-1.17,1.73,1.49,1.49,0,0,0,1.75,1.17,1.54,1.54,0,0,0,.63-.3A1.48,1.48,0,0,0,261.6,401.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,385.17a.87.87,0,0,0,1.25-.09.88.88,0,1,0-1.33-1.16A.87.87,0,0,0,260.28,385.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,406.7a.89.89,0,0,0-1.17,1.34.89.89,0,1,0,1.17-1.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,421.49a1.78,1.78,0,1,0-.18-2.51A1.77,1.77,0,0,0,238.46,421.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.59,418.33a1.19,1.19,0,1,0,.11,1.67A1.19,1.19,0,0,0,243.59,418.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,402.47a1.48,1.48,0,1,0-.14-2.09A1.49,1.49,0,0,0,221.62,402.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5,374.41a1.49,1.49,0,0,0-2.1.15,1.49,1.49,0,0,0,2.24,1.95A1.5,1.5,0,0,0,202.5,374.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,409.65a.9.9,0,0,0,1.26-.09.89.89,0,0,0-1.35-1.17A.9.9,0,0,0,227.85,409.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.42,431.17a.9.9,0,0,0-1.25.09.89.89,0,0,0,.09,1.25.88.88,0,0,0,1.25-.08A.89.89,0,0,0,227.42,431.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,429.39a1.48,1.48,0,1,0-.14-2.09A1.48,1.48,0,0,0,218,429.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,437.41a1.77,1.77,0,0,0-2.5.19,1.75,1.75,0,0,0,.17,2.49,1.77,1.77,0,0,0,2.51-.16A1.8,1.8,0,0,0,193.3,437.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07,403.17a1.5,1.5,0,0,0,2.1-.15,1.48,1.48,0,0,0-2.23-1.95A1.5,1.5,0,0,0,241.07,403.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,409.62a1.48,1.48,0,1,0,.15,2.09A1.48,1.48,0,0,0,237.13,409.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,460.19a1.45,1.45,0,1,0,.14,2.05A1.45,1.45,0,0,0,193.5,460.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,394.55a.89.89,0,0,0,1.35,1.17.89.89,0,0,0-.09-1.25A.91.91,0,0,0,235.86,394.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.52,417.34a.89.89,0,1,0-1.16,1.34.89.89,0,0,0,1.16-1.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,456.62a1.48,1.48,0,1,0,.14,2.09A1.49,1.49,0,0,0,186.54,456.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.75,434.13a1.78,1.78,0,1,0-.17-2.51A1.78,1.78,0,0,0,239.75,434.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06,436.06a1.78,1.78,0,1,0-.17-2.51A1.77,1.77,0,0,0,250.06,436.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,432.9a1.18,1.18,0,1,0,.12,1.68A1.2,1.2,0,0,0,255.19,432.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58,431.57a1.48,1.48,0,1,0-.13-2.09A1.48,1.48,0,0,0,244.58,431.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.64,438a1.48,1.48,0,1,0-1.95,2.24,1.48,1.48,0,0,0,2.09-.15A1.49,1.49,0,0,0,240.64,438Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14,441.05A1.45,1.45,0,1,0,246,439,1.46,1.46,0,0,0,246.14,441.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.76,456.48a.88.88,0,0,0-1.25.08.89.89,0,0,0,.08,1.26.9.9,0,0,0,1.26-.09A.89.89,0,0,0,146.76,456.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,445.74a.89.89,0,1,0,.1,1.26A.89.89,0,0,0,239,445.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,444a1.48,1.48,0,1,0-.14-2.08,1.4,1.4,0,0,0-.34.74,1.57,1.57,0,1,0,0,.46A1.51,1.51,0,0,0,229.57,444Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68,491.32a1.78,1.78,0,1,0,.16,2.5A1.79,1.79,0,0,0,204.68,491.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.91,433.82a1.18,1.18,0,1,0,.11,1.68A1.18,1.18,0,0,0,270.91,433.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.39,432.35a1.48,1.48,0,1,0-2.09.14A1.48,1.48,0,0,0,262.39,432.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.41,441.18a1.48,1.48,0,0,0,1.94-2.24,1.48,1.48,0,0,0-1.94,2.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,442a1.45,1.45,0,1,0-.14-2.05A1.44,1.44,0,0,0,261.86,442Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.38,444.74a1.48,1.48,0,1,0-2.23-1.94,1.48,1.48,0,0,0,2.23,1.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,329.71a1.77,1.77,0,0,0,2.51-.16,1.78,1.78,0,1,0-2.68-2.34A1.76,1.76,0,0,0,247.16,329.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43,461.32a1.78,1.78,0,1,0-.18-2.51A1.77,1.77,0,0,0,211.43,461.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.85,311.86a1.48,1.48,0,1,0-.14-2.08A1.48,1.48,0,0,0,256.85,311.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.74,484.33a1.48,1.48,0,1,0,1.95-2.23,1.46,1.46,0,0,0-2.08.14A1.48,1.48,0,0,0,216.74,484.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,424.26a1.45,1.45,0,1,0-2.19-1.9,1.44,1.44,0,0,0-.23,1.53l-.09-.09a.89.89,0,1,0,.08,1.25.91.91,0,0,0,.17-.89,1.21,1.21,0,0,0,.21.24A1.45,1.45,0,0,0,258.85,424.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,407.48a.89.89,0,0,0,.09-1,1.44,1.44,0,0,0,.34-.27,1.19,1.19,0,0,0,.26-1.06,1.37,1.37,0,0,0,.42-.34,1.47,1.47,0,1,0-2.38-.23l-.08.07a1.19,1.19,0,0,0,.08,1.64l-.07.06a.88.88,0,0,0,.1,1.26A.87.87,0,0,0,251.37,407.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69,429.1a.9.9,0,0,0-1.25.08.89.89,0,1,0,1.25-.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.73,477.31a1.48,1.48,0,1,0,.14,2.09A1.49,1.49,0,0,0,167.73,477.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.62,334.52a1.78,1.78,0,0,0,2.34-2.68,1.78,1.78,0,1,0-2.34,2.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.82,418.93a1.77,1.77,0,1,0,2.33-2.67,1.77,1.77,0,1,0-2.33,2.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.07,420.23a1.18,1.18,0,0,0,.11,1.67,1.2,1.2,0,0,0,1.68-.11,1.19,1.19,0,0,0-1.79-1.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,520.74a1.48,1.48,0,1,0,.15,2.09A1.5,1.5,0,0,0,173.08,520.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.58,365.65a1.48,1.48,0,1,0-.15-2.08A1.48,1.48,0,0,0,262.58,365.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45,552.65a1.45,1.45,0,1,0,.14,2A1.44,1.44,0,0,0,150.45,552.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,410.09a.91.91,0,0,0-1.26.08.89.89,0,0,0,.09,1.26.88.88,0,0,0,1.25-.09A.9.9,0,0,0,269.18,410.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,433a.89.89,0,0,0-.13,1,1.83,1.83,0,0,0-.6.44,1.78,1.78,0,1,0,2.51-.17,1.85,1.85,0,0,0-.34-.23.89.89,0,0,0-1.44-1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.45,339.25a2.69,2.69,0,1,0,2.61-2.76A2.69,2.69,0,0,0,364.45,339.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65,483.79a1.79,1.79,0,1,0,1.74-1.85A1.8,1.8,0,0,0,279.65,483.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,535.56a2.24,2.24,0,0,0,4.47.08,2.08,2.08,0,0,0,1.19.24,2.2,2.2,0,1,0-2.38-2.36,2.22,2.22,0,0,0-3.28,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.49,502.59a2.25,2.25,0,0,0-2.18,2.31c0,.06,0,.12,0,.17a1.46,1.46,0,0,0-1.22-.29,1.48,1.48,0,1,0,1.78,1.54,2.24,2.24,0,1,0,1.6-3.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.51,553.8a2.19,2.19,0,1,0-2.13,2.25A2.19,2.19,0,0,0,192.51,553.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6,487.16a1.34,1.34,0,0,0,1.39,1.31,1.32,1.32,0,0,0,1.3-1.38,1.35,1.35,0,0,0-2.69.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.64,512.82a1.35,1.35,0,1,0,1.38,1.3A1.33,1.33,0,0,0,276.64,512.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.31,520.55a2.24,2.24,0,1,0-2.3-2.16A2.23,2.23,0,0,0,264.31,520.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,536.56a2.66,2.66,0,1,0-2.3,3A2.66,2.66,0,0,0,214,536.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.35,526.93a2.66,2.66,0,1,0-2.29,3A2.65,2.65,0,0,0,226.35,526.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,524.53a1.77,1.77,0,1,0-2-1.52A1.78,1.78,0,0,0,226.07,524.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,529.1a2.21,2.21,0,0,0-4.39.56,2.21,2.21,0,1,0,4.39-.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,544.9a2.22,2.22,0,1,0,1.92-2.49A2.22,2.22,0,0,0,215,544.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,536.82a2,2,0,0,1,.07-2.47,3.25,3.25,0,0,0-4.38,3,2.17,2.17,0,1,0,4.31-.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,528.87a1.33,1.33,0,1,0,1.15-1.48A1.33,1.33,0,0,0,198.77,528.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,551.88a1.35,1.35,0,0,0-1.15,1.49,1.33,1.33,0,1,0,1.15-1.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.49,558.23a2.21,2.21,0,1,0-1.92,2.47A2.21,2.21,0,0,0,214.49,558.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,513.21a2.65,2.65,0,1,0,2.41-2.87A2.65,2.65,0,0,0,222.78,513.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.79,503.66a2.65,2.65,0,1,0-2.4,2.87A2.64,2.64,0,0,0,240.79,503.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,499.67a1.77,1.77,0,1,0,1.6-1.92A1.76,1.76,0,0,0,238.7,499.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,492.94a2.21,2.21,0,1,0-2,2.4A2.2,2.2,0,0,0,224.12,492.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.76,518.7a2.21,2.21,0,1,0,2.4,2A2.21,2.21,0,0,0,230.76,518.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,514a2.16,2.16,0,0,0,2.35,2,2.14,2.14,0,0,0,2-2.34,2.16,2.16,0,1,0-4.31.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.69,505.69a1.33,1.33,0,0,0-.23-2.64,1.33,1.33,0,1,0,.23,2.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4,528.43a1.32,1.32,0,1,0,1.45,1.2A1.33,1.33,0,0,0,237.4,528.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,560.91a2.68,2.68,0,0,0-3-2.31,2.69,2.69,0,1,0,.72,5.33A2.68,2.68,0,0,0,233.25,560.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,551.12a2.68,2.68,0,1,0-2.29,3A2.68,2.68,0,0,0,245.69,551.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39,548.7a1.78,1.78,0,1,0-.47-3.53,1.78,1.78,0,1,0,.47,3.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.77,553.38a2.24,2.24,0,1,0-1.92,2.51A2.22,2.22,0,0,0,234.77,553.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,571.23a2.23,2.23,0,0,0,1.92-2.52,2.24,2.24,0,1,0-1.92,2.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,531.06a2.19,2.19,0,1,0,1.87-2.46A2.19,2.19,0,0,0,179.4,531.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,554.41a1.34,1.34,0,1,0-1.51-1.15A1.35,1.35,0,0,0,219.4,554.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,579a1.34,1.34,0,0,0-.37-2.66,1.34,1.34,0,0,0,.37,2.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,582.76a2.23,2.23,0,1,0-1.92,2.51A2.24,2.24,0,0,0,233.93,582.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,562.94a2.71,2.71,0,1,0,2.39-3A2.72,2.72,0,0,0,254.68,562.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,552.77a2.71,2.71,0,1,0-2.39,3A2.72,2.72,0,0,0,272.86,552.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.62,550.34a1.81,1.81,0,1,0-2-1.6A1.81,1.81,0,0,0,272.62,550.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78,554.78a2.25,2.25,0,1,0-2,2.5A2.26,2.26,0,0,0,261.78,554.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.45,572.85a2.26,2.26,0,1,0-2.5-2A2.24,2.24,0,0,0,263.45,572.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,451.51a2.21,2.21,0,1,0-2,2.44A2.21,2.21,0,0,0,205.69,451.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,554.25a1.35,1.35,0,0,0,1.5,1.19,1.29,1.29,0,0,0,.55-.19,2.24,2.24,0,1,0,2-2.66,2.21,2.21,0,0,0-1.54.81,1.36,1.36,0,0,0-2.51.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.76,579.62a1.36,1.36,0,1,0,1.2-1.49A1.36,1.36,0,0,0,268.76,579.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.2,584.41a2.25,2.25,0,1,0-2,2.49A2.26,2.26,0,0,0,260.2,584.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,530.21a2.7,2.7,0,1,0,.47,5.37,2.7,2.7,0,1,0-.47-5.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.67,479.48a2.7,2.7,0,1,0,2.45-2.92A2.71,2.71,0,0,0,338.67,479.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,471.25a1.79,1.79,0,1,0-1.63,1.95A1.78,1.78,0,0,0,215.09,471.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.41,527.61a2.24,2.24,0,1,0-2.43-2A2.24,2.24,0,0,0,251.41,527.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.27,541.15a2.25,2.25,0,1,0,2-2.44A2.26,2.26,0,0,0,252.27,541.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.19,524a1.35,1.35,0,1,0-1.22,1.46A1.34,1.34,0,0,0,239.19,524Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,548.6a1.35,1.35,0,0,0,.24,2.68,1.35,1.35,0,1,0-.24-2.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,536.38a2.72,2.72,0,1,0,2.89,2.54A2.72,2.72,0,0,0,278.49,536.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,451.66a2.72,2.72,0,1,0,2.89,2.54A2.73,2.73,0,0,0,344.85,451.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.28,523.8a1.82,1.82,0,0,0-1.69,1.94,1.81,1.81,0,1,0,1.69-1.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,529.29a2.26,2.26,0,1,0,2.41,2.11A2.25,2.25,0,0,0,281,529.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,547.5a2.27,2.27,0,1,0,2.12-2.42A2.27,2.27,0,0,0,281.89,547.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.89,540.36A2.22,2.22,0,1,0,293,538,2.22,2.22,0,0,0,290.89,540.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.36,530.1a1.36,1.36,0,1,0,1.27-1.44A1.36,1.36,0,0,0,266.36,530.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.33,556.65a1.36,1.36,0,1,0,2.72-.18,1.35,1.35,0,0,0-1.45-1.26A1.37,1.37,0,0,0,289.33,556.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.53,561.07a2.27,2.27,0,1,0-2.12,2.41A2.28,2.28,0,0,0,280.53,561.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.59,373.87a1.78,1.78,0,1,0,1.52-2A1.77,1.77,0,0,0,291.59,373.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,365.35a1.77,1.77,0,1,0,2,1.51A1.78,1.78,0,0,0,301.33,365.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.79,362.92a1.19,1.19,0,0,0-1,1.34,1.19,1.19,0,1,0,2.35-.33A1.19,1.19,0,0,0,302.79,362.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,368.39a1.48,1.48,0,1,0-1.26,1.67A1.48,1.48,0,0,0,296.09,368.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.86,378.94a1.48,1.48,0,1,0,1.26-1.67A1.48,1.48,0,0,0,295.86,378.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.37,373.86a1.45,1.45,0,0,0,2.88-.4,1.45,1.45,0,0,0-2.88.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.92,369.11a.89.89,0,0,0,.76-1,.91.91,0,0,0-1-.76.89.89,0,1,0,.25,1.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,383.54a.91.91,0,0,0-.76,1,.89.89,0,0,0,1,.76.88.88,0,0,0,.75-1A.89.89,0,0,0,301.9,383.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,386.58a1.48,1.48,0,1,0,1.67,1.27A1.49,1.49,0,0,0,294,386.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,397.15a1.77,1.77,0,1,0-2.09-1.4A1.78,1.78,0,0,0,255,397.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.73,388.77a1.78,1.78,0,1,0,1.4-2.09A1.79,1.79,0,0,0,260.73,388.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.91,386.49a1.19,1.19,0,1,0-.46-2.33,1.19,1.19,0,0,0,.46,2.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.35,388.86a1.48,1.48,0,1,0,1.74,1.15A1.48,1.48,0,0,0,255.35,388.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9,469.86a1.45,1.45,0,1,0-1.71-1.14A1.46,1.46,0,0,0,191.9,469.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.39,382.85a1.78,1.78,0,0,0,.61,3.5,1.78,1.78,0,1,0-.61-3.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,378.13a1.78,1.78,0,1,0,1.45-2.06A1.8,1.8,0,0,0,274,378.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.16,374.56a1.18,1.18,0,1,0-1,1.37A1.18,1.18,0,0,0,278.16,374.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27,379.28a1.48,1.48,0,1,0-2.91.5,1.48,1.48,0,1,0,2.91-.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.58,388.12a1.48,1.48,0,1,0,1.71,1.21A1.48,1.48,0,0,0,271.58,388.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73,384.58a1.45,1.45,0,1,0,1.18-1.68A1.44,1.44,0,0,0,275.73,384.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,379.6a.89.89,0,1,0,1.75-.3.91.91,0,0,0-1-.73A.88.88,0,0,0,259.1,379.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,396a.88.88,0,0,0,.73-1,.87.87,0,0,0-1.26-.65,1.17,1.17,0,0,0-.31-.46,1.2,1.2,0,0,0-1.68.11,1.19,1.19,0,0,0,.12,1.67,1.17,1.17,0,0,0,1.54,0A.88.88,0,0,0,276.86,396Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.71,397.54a1.47,1.47,0,0,0-1.21,1.71,2.5,2.5,0,0,0,.07.26,1.32,1.32,0,0,0-.74.45,1.45,1.45,0,1,0,2.45.47,1.47,1.47,0,0,0-.57-2.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,536.55a1.78,1.78,0,1,0-.73-3.48,1.78,1.78,0,0,0,.73,3.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,405.42a1.77,1.77,0,1,0-3.47.74,1.77,1.77,0,0,0,3.47-.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.17,403.84a1.17,1.17,0,0,0,.92-1.4,1.19,1.19,0,1,0-2.32.49A1.18,1.18,0,0,0,273.17,403.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5,408.07a1.48,1.48,0,1,0,1.13-1.75l-.1,0a.88.88,0,1,0-.45.21A1.47,1.47,0,0,0,263.5,408.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,352.24a1.5,1.5,0,0,0,1.76,1.15,1.48,1.48,0,1,0-1.76-1.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,410.21a2.07,2.07,0,1,0,2.45,1.6A2.07,2.07,0,0,0,273,410.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.42,408.59a1.48,1.48,0,1,0,1.48-.18.85.85,0,0,0,.07-.57.88.88,0,1,0-1.73.37A.84.84,0,0,0,255.42,408.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,428.65a1.48,1.48,0,1,0-1.62-2.1v0a1.45,1.45,0,1,0-1.19,1.67,1.42,1.42,0,0,0,1.05-.78s0,.06,0,.09A1.47,1.47,0,0,0,266.14,428.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,415.17a1.78,1.78,0,1,0,2.1,1.39A1.78,1.78,0,0,0,281,415.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.48,411.62a1.79,1.79,0,0,0,1.38-2.09,1.78,1.78,0,1,0-1.38,2.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.55,408a1.2,1.2,0,0,0,.93-1.4,1.18,1.18,0,1,0-.93,1.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75,411.51a1.49,1.49,0,1,0-1.15,1.75A1.49,1.49,0,0,0,283.75,411.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.93,423.21a1.48,1.48,0,0,0-.59-2.9,1.48,1.48,0,1,0,.59,2.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.21,416.06a1.45,1.45,0,1,0-1.13,1.7A1.45,1.45,0,0,0,292.21,416.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,480a.89.89,0,0,0-1.75.36.9.9,0,0,0,1.06.7A.91.91,0,0,0,151.12,480Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,428a.89.89,0,1,0-.35-1.74.89.89,0,1,0,.35,1.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,356.56a1.48,1.48,0,1,0,.59,2.9,1.48,1.48,0,0,0-.59-2.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.32,399.91a1.78,1.78,0,1,0,1.45-2.05A1.78,1.78,0,0,0,278.32,399.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.93,501.65a1.78,1.78,0,1,0-1.44,2.05A1.78,1.78,0,0,0,165.93,501.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,390.93a1.19,1.19,0,0,0,1-1.37,1.19,1.19,0,1,0-1,1.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,393.08a1.48,1.48,0,1,0,1.71,1.2A1.47,1.47,0,0,0,280.93,393.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46,406.05a1.49,1.49,0,1,0-1.71-1.22A1.49,1.49,0,0,0,284.46,406.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.78,341.7a2.07,2.07,0,1,0,1.69-2.39A2.07,2.07,0,0,0,339.78,341.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.19,393.59a.88.88,0,0,0-.58.37,1.78,1.78,0,0,0-.9.55,1.78,1.78,0,1,0,2.51-.17h0a0,0,0,0,1,0,0A.89.89,0,0,0,272.19,393.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.52,505.69a1.48,1.48,0,0,0-1.21,1.71,1.48,1.48,0,1,0,2.92-.51A1.47,1.47,0,0,0,203.52,505.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,403.05a1.77,1.77,0,1,0-1.46,2A1.78,1.78,0,0,0,301.24,403.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.75,396.88a1.78,1.78,0,1,0,1.46-2.05A1.78,1.78,0,0,0,305.75,396.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,392.36a1.18,1.18,0,0,0-1,1.36,1.18,1.18,0,1,0,2.33-.39A1.18,1.18,0,0,0,308.6,392.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.15,398.52a1.48,1.48,0,1,0,1.21-1.71A1.49,1.49,0,0,0,299.15,398.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.36,406.87a1.48,1.48,0,1,0,1.71,1.21A1.48,1.48,0,0,0,303.36,406.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.74,489.19a1.47,1.47,0,0,0,1.19-1.68,1.45,1.45,0,1,0-1.19,1.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.92,399.05a.9.9,0,0,0,.73-1,.89.89,0,1,0-.73,1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.17,417.49a1.48,1.48,0,1,0-2.91.49,1.48,1.48,0,1,0,2.91-.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.68,450.88a1.78,1.78,0,1,0,.49,3.52,1.77,1.77,0,0,0,1.52-2A1.79,1.79,0,0,0,294.68,450.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.69,444.28a1.18,1.18,0,1,0-1.33-1A1.18,1.18,0,0,0,304.69,444.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.67,447.41a1.48,1.48,0,1,0-1.27,1.67A1.48,1.48,0,0,0,297.67,447.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.85,512.87a1.48,1.48,0,1,0,1.26-1.67A1.47,1.47,0,0,0,330.85,512.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.66,502.59A1.45,1.45,0,1,0,320.9,501,1.45,1.45,0,0,0,319.66,502.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.25,447.13a.89.89,0,1,0-.76,1A.89.89,0,0,0,288.25,447.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,463.57a.89.89,0,0,0,1,.76.89.89,0,1,0-1-.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,467.28a1.48,1.48,0,1,0,1.26-1.68A1.48,1.48,0,0,0,294.26,467.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.58,476.17a1.77,1.77,0,1,0-2.09-1.39A1.78,1.78,0,0,0,256.58,476.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,515.53a1.19,1.19,0,0,0-.46-2.33,1.18,1.18,0,0,0-.93,1.39A1.19,1.19,0,0,0,270.26,515.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,467.88a1.48,1.48,0,1,0,1.75,1.15A1.48,1.48,0,0,0,256.92,467.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,479.59a1.48,1.48,0,1,0,1.16-1.75A1.49,1.49,0,0,0,259.05,479.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.66,484.88a.87.87,0,0,0,1,.69.89.89,0,1,0-1-.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,489.07a1.48,1.48,0,0,0,2.9-.58,1.5,1.5,0,0,0-.86-1.06.92.92,0,0,0,.07-.57.89.89,0,0,0-1.74.38.85.85,0,0,0,.18.37A1.45,1.45,0,0,0,256.44,489.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.53,457.15a1.77,1.77,0,1,0,1.45-2.06A1.78,1.78,0,0,0,275.53,457.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,454a1.19,1.19,0,1,0,1-1.37A1.19,1.19,0,0,0,277.4,454Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.58,459.78a1.55,1.55,0,0,0-.88,1.29,1.48,1.48,0,0,0,.17.83,1.77,1.77,0,0,0,.7,3.47,1.79,1.79,0,0,0,1.46-2.05,1.76,1.76,0,0,0-.25-.65,1.57,1.57,0,0,0,.31-2.82,1.48,1.48,0,1,0-2.16-1.06A1.5,1.5,0,0,0,269.58,459.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.15,467.14a1.48,1.48,0,1,0,1.72,1.21A1.48,1.48,0,0,0,273.15,467.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.73,454.17a.9.9,0,0,0-.73,1,.89.89,0,0,0,1.76-.31A.91.91,0,0,0,211.73,454.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,477.76a1.48,1.48,0,1,0-1.21,1.71A1.48,1.48,0,0,0,272,477.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.53,481.85a1.78,1.78,0,1,0-1.36,2.11A1.78,1.78,0,0,0,209.53,481.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.34,482a1.19,1.19,0,1,0,2.32-.49,1.18,1.18,0,0,0-1.4-.92A1.2,1.2,0,0,0,273.34,482Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.17,349.22a1.48,1.48,0,1,0,1.13-1.76A1.47,1.47,0,0,0,285.17,349.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.28,520.89a1.48,1.48,0,1,0,1-1.84A1.47,1.47,0,0,0,239.28,520.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,493.29a2.08,2.08,0,1,0-2.46-1.6A2.08,2.08,0,0,0,275.47,493.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,501.86a.89.89,0,1,0-.69,1.06A.88.88,0,0,0,275.88,501.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,488.54a1.77,1.77,0,1,0-1.37,2.1A1.77,1.77,0,0,0,292.43,488.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.06,485.57a1.19,1.19,0,1,0-.93,1.39A1.19,1.19,0,0,0,293.06,485.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6,491.58a1.47,1.47,0,0,0-.39,2.73,1.75,1.75,0,0,0-1,2,1.78,1.78,0,1,0,2.45-2,1.49,1.49,0,0,0,.75-1.55,1.39,1.39,0,0,0-.19-.49,1.48,1.48,0,1,0-1.77-1.14A1.46,1.46,0,0,0,282.6,491.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.76,501.08a1.48,1.48,0,1,0,1.15-1.75A1.48,1.48,0,0,0,285.76,501.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,495.65a1.45,1.45,0,1,0,1.14-1.7A1.44,1.44,0,0,0,290.94,495.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,493.94a.89.89,0,1,0,.69-1A.89.89,0,0,0,214,493.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.39,506.33a.89.89,0,1,0,1.74-.35.89.89,0,0,0-1.74.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,508.83a1.48,1.48,0,1,0,1.75,1.15A1.49,1.49,0,0,0,284.34,508.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.89,478.93a1.78,1.78,0,0,0,3.26.64,2.18,2.18,0,0,0,.68.16,2.38,2.38,0,1,0-2.14-2.88,1.4,1.4,0,0,0-.35,0A1.8,1.8,0,0,0,279.89,478.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.94,515.81a1.78,1.78,0,1,0-1.45,2.05A1.78,1.78,0,0,0,213.94,515.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.1,468.58a1.18,1.18,0,1,0-1,1.37A1.18,1.18,0,0,0,292.1,468.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.5,472.1a1.48,1.48,0,1,0,1.72,1.2A1.48,1.48,0,0,0,282.5,472.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,485.07a1.49,1.49,0,1,0-1.71-1.21A1.49,1.49,0,0,0,286,485.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,476.31a2.06,2.06,0,0,0-1.69,2.39,2.07,2.07,0,0,0,4.09-.64.82.82,0,0,0,.35,0,.89.89,0,0,0-.3-1.75.85.85,0,0,0-.67.54A2,2,0,0,0,290.75,476.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,473.63a.89.89,0,1,0,1.75-.29.89.89,0,1,0-1.75.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.31,482.65a1.77,1.77,0,1,0,1.45-2A1.78,1.78,0,0,0,299.31,482.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.33,475.9a1.77,1.77,0,1,0,1.45-2A1.77,1.77,0,0,0,307.33,475.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.21,472.75a1.19,1.19,0,1,0,1-1.36A1.18,1.18,0,0,0,309.21,472.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,478.75a1.48,1.48,0,1,0-1.7-1.21A1.47,1.47,0,0,0,302.44,478.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.72,487.6a1.48,1.48,0,0,0,1.71,1.21,1.48,1.48,0,0,0-.5-2.92A1.49,1.49,0,0,0,303.72,487.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,379.36a1.45,1.45,0,1,0-1.67-1.19A1.45,1.45,0,0,0,318.48,379.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.17,493.05a.89.89,0,0,0,1,.72.89.89,0,0,0-.3-1.75A.89.89,0,0,0,309.17,493.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,495.29a1.49,1.49,0,1,0,.49,2.93,1.49,1.49,0,0,0-.49-2.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,327.71a2.36,2.36,0,1,0,2.94,1.57A2.36,2.36,0,0,0,332.35,327.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,340.07a2.36,2.36,0,1,0,1.57-2.94A2.36,2.36,0,0,0,341,340.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,341a1.56,1.56,0,0,0,1.95,1,1.57,1.57,0,1,0-.91-3A1.56,1.56,0,0,0,346,341Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,331.17a2,2,0,1,0,1.31-2.45A2,2,0,0,0,338,331.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,338.1a2,2,0,1,0-2.45-1.32A2,2,0,0,0,327.72,338.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09,342.92a1.92,1.92,0,1,0,1.28-2.4A1.92,1.92,0,0,0,333.09,342.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,319.3a1.19,1.19,0,0,0,1.48.79,1.17,1.17,0,0,0,.78-1.47,1.19,1.19,0,0,0-1.47-.79A1.18,1.18,0,0,0,337.41,319.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,343.87a1.17,1.17,0,0,0,1.47.79,1.18,1.18,0,1,0-1.47-.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,334.54a2,2,0,1,0,1.3-2.45A2,2,0,0,0,312.43,334.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,380.57a2.36,2.36,0,1,0-.46,3.31A2.35,2.35,0,0,0,305.84,380.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,385.88a2.36,2.36,0,1,0-.47,3.3A2.36,2.36,0,0,0,318.71,385.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,387.91a1.57,1.57,0,0,0,2.78-1.3,1.22,1.22,0,0,0,.88-.27,1.19,1.19,0,0,0,.15-1.66,1.18,1.18,0,0,0-2.1.78,1.57,1.57,0,0,0-1.71,2.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.49,430.33a2,2,0,1,0,2.75.38A2,2,0,0,0,338.49,430.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87,449.78a1.92,1.92,0,1,0-2.7-.38A1.93,1.93,0,0,0,264.87,449.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.61,368.81a1.17,1.17,0,0,0-.23,1.65,1.18,1.18,0,1,0,.23-1.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.34,398.09a1.18,1.18,0,1,0,1.42,1.88,1.19,1.19,0,0,0,.22-1.66A1.18,1.18,0,0,0,296.34,398.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.4,310.8a2,2,0,1,0,.38-2.74A1.94,1.94,0,0,0,265.4,310.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.57,362.15a2.36,2.36,0,1,0,1-3.2A2.35,2.35,0,0,0,312.57,362.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.1,291.59a2.36,2.36,0,1,0,.95-3.2A2.36,2.36,0,0,0,354.1,291.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.59,369.33a1.58,1.58,0,1,0,.63-2.13A1.58,1.58,0,0,0,329.59,369.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91,355.86a2,2,0,1,0-.79,2.66A2,2,0,0,0,332.91,355.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.85,367.42a2,2,0,1,0,.08,1.69.86.86,0,0,0,.22.53.89.89,0,1,0,1.31-1.21.89.89,0,0,0-1.25-.05l-.13.15A1.84,1.84,0,0,0,311.85,367.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.26,309.1a1.94,1.94,0,1,0,.79-2.61A1.94,1.94,0,0,0,291.26,309.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.83,349.68a1.18,1.18,0,0,0,1.6.48,1.19,1.19,0,0,0,.48-1.6,1.18,1.18,0,0,0-1.6-.48A1.17,1.17,0,0,0,316.83,349.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.78,377.88a1.18,1.18,0,1,0-1.61-.48A1.19,1.19,0,0,0,305.78,377.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,367.78a2,2,0,1,0-.8,2.67A2,2,0,0,0,298.78,367.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,396a2.37,2.37,0,0,0-.8,2.31,2.34,2.34,0,0,0-3.47,2.69,2.35,2.35,0,0,0,4.55-1.16,2.34,2.34,0,0,0,1.11.35,1.56,1.56,0,0,0,1.27,2.83,1.56,1.56,0,0,0-.17-3,2.52,2.52,0,0,0,.54-.33,2.15,2.15,0,0,0,.43-.48,1.77,1.77,0,0,0,.43,1.07,1.73,1.73,0,0,0,1.25.61,2,2,0,1,0,.66-3.44,1.75,1.75,0,0,0-1.73.33,1.8,1.8,0,0,0-.19.2,2.36,2.36,0,0,0-3.88-1.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,401.06a2.37,2.37,0,1,0-.32,3.33A2.37,2.37,0,0,0,337,401.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.81,401a1.58,1.58,0,1,0-.21,2.23A1.59,1.59,0,0,0,340.81,401Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.12,397a2,2,0,1,0,.26-2.78A2,2,0,0,0,327.12,397Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.58,541a2,2,0,1,0-.27,2.79A2,2,0,0,0,247.58,541Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89,416.42a2.77,2.77,0,1,0,.37-3.9A2.77,2.77,0,0,0,362.89,416.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.45,511.38a2,2,0,1,0-.27,2.78A2,2,0,0,0,257.45,511.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,388a2.38,2.38,0,1,0-.55,3.31A2.37,2.37,0,0,0,345.39,388Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.22,393.64a2.38,2.38,0,1,0-.55,3.32A2.38,2.38,0,0,0,358.22,393.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.8,393.51a1.59,1.59,0,1,0,2.21.36A1.6,1.6,0,0,0,359.8,393.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,388.88a2,2,0,1,0,.46-2.76A2,2,0,0,0,348.6,388.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,396.08a2,2,0,1,0-.46,2.77A2,2,0,0,0,341.48,396.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,399a1.94,1.94,0,1,0,2.71.45A1.95,1.95,0,0,0,348.17,399Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.11,376.36a1.21,1.21,0,0,0-1.67-.29,1.19,1.19,0,1,0,1.67.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,405.65a1.17,1.17,0,0,0-1.65-.28,1.19,1.19,0,1,0,1.39,1.94A1.18,1.18,0,0,0,337,405.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,372.67a2.39,2.39,0,1,0,3.23,1A2.39,2.39,0,0,0,350.14,372.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,373.7a1.59,1.59,0,1,0,2.16.63A1.6,1.6,0,0,0,355,373.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.43,374a2,2,0,0,0-2.7-.8,2,2,0,1,0,2.7.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,455.66a2.78,2.78,0,1,0,1.11-3.76A2.78,2.78,0,0,0,359.2,455.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38,356.08a1.19,1.19,0,1,0,.48-1.62A1.18,1.18,0,0,0,341.38,356.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.81,383a1.19,1.19,0,1,0-.48,1.62A1.21,1.21,0,0,0,330.81,383Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,373.61a2,2,0,0,0,1.9,3.49,2,2,0,1,0-1.9-3.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.54,359.82a2.37,2.37,0,1,0,1.14-3.16A2.37,2.37,0,0,0,358.54,359.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,367.72a2.37,2.37,0,0,0,4.29-2,2.37,2.37,0,1,0-4.29,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.2,368a1.58,1.58,0,1,0,.76-2.1A1.58,1.58,0,0,0,375.2,368Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.81,359.29a2,2,0,1,0,3.58-1.68,2,2,0,0,0-3.58,1.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.53,365.06a2,2,0,1,0-1,2.63A2,2,0,0,0,357.53,365.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,371.71a1.93,1.93,0,1,0,.93-2.57A1.92,1.92,0,0,0,362.63,371.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5,347.56a1.19,1.19,0,1,0,.57-1.59A1.19,1.19,0,0,0,363.5,347.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.77,363.74a2,2,0,0,0-1.14,1.89,2.34,2.34,0,0,0-2.54-.19,2.39,2.39,0,1,0,3.49,1.77,1.94,1.94,0,0,0,1.86.11,2,2,0,0,0,.73-.59,1.91,1.91,0,0,0,.23,1,2,2,0,1,0,3.49-1.89,2,2,0,0,0-2.69-.8,2.06,2.06,0,0,0-.63.54,1.91,1.91,0,0,0-.17-.87A2,2,0,0,0,341.77,363.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.48,294.08a2.36,2.36,0,1,0,1.57-2.94A2.38,2.38,0,0,0,285.48,294.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,390.94a2,2,0,0,0-2.44-1.31,2,2,0,1,0,2.44,1.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.27,396.55A2,2,0,1,0,303,399,2,2,0,0,0,304.27,396.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.6,401.42a1.94,1.94,0,0,0-1.35,1.73l-.17.13a1.78,1.78,0,1,0,2.47,2.55A1.63,1.63,0,0,0,311,405a1.92,1.92,0,0,0-1.44-3.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.91,379.52a1.18,1.18,0,0,0-2.26.69,1.19,1.19,0,0,0,1.47.79A1.21,1.21,0,0,0,314.91,379.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.25,405.56a1.17,1.17,0,0,0,.78-1.47,1.18,1.18,0,1,0-.78,1.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,395.1a.88.88,0,0,0,.9,1.43,2,2,0,1,0-.9-1.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,444.78a2.36,2.36,0,1,0-3.3-.46A2.36,2.36,0,0,0,280.62,444.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94,446.79a2.36,2.36,0,1,0-.46,3.3A2.35,2.35,0,0,0,293.94,446.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,448.81a1.57,1.57,0,0,0,2.2.32,1.6,1.6,0,0,0,.59-1.62,1.15,1.15,0,0,0,.87-.27,1.17,1.17,0,0,0,.15-1.66,1.19,1.19,0,0,0-1.67-.17,1.21,1.21,0,0,0-.42,1,1.57,1.57,0,0,0-1.72,2.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.67,439.56a2,2,0,1,0,2.37,3.13,1.92,1.92,0,0,0,.77-1.52,1.12,1.12,0,0,0,.26.08,1.19,1.19,0,0,0,1.35-1,1.18,1.18,0,0,0-2.27-.6A2,2,0,0,0,284.67,439.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,452.38a2,2,0,1,0-2.76-.38A2,2,0,0,0,277,452.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,455.43a1.92,1.92,0,1,0-2.7-.38A1.93,1.93,0,0,0,286.43,455.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,429.94a1.18,1.18,0,1,0-.23,1.65A1.18,1.18,0,0,0,281.5,429.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.23,459.22a1.2,1.2,0,0,0-1.66-.23,1.19,1.19,0,0,0,1.43,1.89A1.2,1.2,0,0,0,273.23,459.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.81,451.59a2,2,0,1,0,2.74.37A2,2,0,0,0,261.81,451.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,368.57a2.36,2.36,0,1,0,1-3.2A2.35,2.35,0,0,0,229.88,368.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,422.13a2,2,0,1,0,.8-2.66A2,2,0,0,0,295,422.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,431a2,2,0,0,0-.67-3.68.92.92,0,0,0,.45-.65.89.89,0,1,0-1.22.7,1.52,1.52,0,0,0-.42.16,2,2,0,0,0,1.86,3.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.05,497.37a1.93,1.93,0,1,0-.78,2.61A1.94,1.94,0,0,0,261.05,497.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,409.46a1.19,1.19,0,1,0-.48,1.6A1.2,1.2,0,0,0,294.15,409.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.17,426.76a1.17,1.17,0,0,0-1.59-.47,1.18,1.18,0,1,0,1.12,2.07A1.18,1.18,0,0,0,202.17,426.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.22,431.35a2,2,0,1,0-2.67-.8A2,2,0,0,0,273.22,431.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,460.53a2.37,2.37,0,1,0-3.34-.31A2.37,2.37,0,0,0,298.78,460.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.26,462a2.37,2.37,0,1,0-.33,3.34A2.37,2.37,0,0,0,312.26,462Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.82,461.73a1.58,1.58,0,1,0,2.23.2A1.58,1.58,0,0,0,313.82,461.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,457.88a2,2,0,1,0,.27-2.78A2,2,0,0,0,302.36,457.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.5,468.32a2,2,0,1,0-2.79-.26A2,2,0,0,0,295.5,468.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,475.37a1.19,1.19,0,1,0-1.83,1.51,1.19,1.19,0,0,0,1.83-1.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,471a2,2,0,1,0,.26-2.77A2,2,0,0,0,279.9,471Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.08,452.19a2.39,2.39,0,0,0,.81-2.84,1.77,1.77,0,1,0-1-1.16,2.38,2.38,0,1,0,.22,4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,581.9a2.38,2.38,0,1,0-.54,3.32A2.38,2.38,0,0,0,302.35,581.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.24,454.78a1.57,1.57,0,0,0-2.21-.36,1.58,1.58,0,1,0,2.21.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,566.85a2,2,0,1,0-.45,2.76A2,2,0,0,0,282,566.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.26,459.75a2,2,0,1,0-2.77-.45A2,2,0,0,0,316.26,459.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.66,463.06a1.94,1.94,0,1,0-2.71-.45A1.95,1.95,0,0,0,325.66,463.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35,437.26a1.22,1.22,0,0,0-.86-.49l.08-.06a.9.9,0,0,0,.05-1.26.89.89,0,0,0-1.31,1.2.94.94,0,0,0,.47.27l-.1.06a1.19,1.19,0,0,0-.26,1.67,1.17,1.17,0,0,0,1.65.26A1.19,1.19,0,0,0,321.35,437.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,466.28a1.19,1.19,0,1,0,1.65.27A1.18,1.18,0,0,0,310.6,466.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,461.78a2,2,0,1,0-2.77-.45A2,2,0,0,0,303.25,461.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.37,429.58a2.38,2.38,0,0,0,4.45-1.46,2,2,0,1,0-.95-1.59,2.38,2.38,0,0,0-3.5,3.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.38,433.58a2.38,2.38,0,0,0-1.09,2.91,1.78,1.78,0,1,0,2.13,2.83A1.74,1.74,0,0,0,327,438a2.23,2.23,0,0,0,.66-.22,2.38,2.38,0,0,0-2.27-4.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,436.76a1.59,1.59,0,1,0,.64-2.15A1.59,1.59,0,0,0,329.56,436.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,478.77a2,2,0,1,0,.8-2.69A2,2,0,0,0,361.39,478.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.81,515.77a2,2,0,1,0,.8-2.69A2,2,0,0,0,264.81,515.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76,351.41a2.78,2.78,0,1,0,1.11-3.77A2.77,2.77,0,0,0,310.76,351.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,417.45a1.19,1.19,0,0,0-1.14-2.09l-.11.08a1.18,1.18,0,1,0-2.08.53,1.17,1.17,0,0,0,1.59.22,1.22,1.22,0,0,0,.12.79A1.19,1.19,0,0,0,318.23,417.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,443.85a1.19,1.19,0,1,0-.48,1.62A1.19,1.19,0,0,0,306,443.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.07,418.71a2.38,2.38,0,1,0-1.13,3.15A2.38,2.38,0,0,0,338.07,418.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.33,428.62a2.37,2.37,0,1,0,1.14-3.15A2.38,2.38,0,0,0,345.33,428.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.43,428.87a1.59,1.59,0,1,0,.76-2.1A1.59,1.59,0,0,0,350.43,428.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63,418.52a2,2,0,1,0-.95,2.62A2,2,0,0,0,344.63,418.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.76,515.81a2,2,0,1,0-.95,2.64A2,2,0,0,0,192.76,515.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.65,312.05a1.93,1.93,0,1,0,.93-2.58A1.92,1.92,0,0,0,317.65,312.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.31,406.88a1.18,1.18,0,1,0,1.57.57A1.17,1.17,0,0,0,339.31,406.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9,371.62a2.35,2.35,0,1,0-1.57,2.95A2.34,2.34,0,0,0,234.9,371.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,382.41a2.35,2.35,0,1,0,1.57-2.94A2.36,2.36,0,0,0,240.62,382.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.56,384.43a1.55,1.55,0,0,0,1-.93.83.83,0,0,0,.32-.2.88.88,0,0,0,0-1.25.89.89,0,0,0-.73-.27,1.57,1.57,0,1,0-.61,2.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,373.51a2,2,0,1,0,1.32-2.44A2,2,0,0,0,237.62,373.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.89,379.13a2,2,0,1,0,1.31-2.45A2,2,0,0,0,224.89,379.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,382.86a1.84,1.84,0,0,0-.7.39,1.48,1.48,0,1,0-1.68,1.64,1.39,1.39,0,0,0,1-.23,1.76,1.76,0,0,0,.07.6,1.92,1.92,0,1,0,1.29-2.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,361.65a1.18,1.18,0,1,0,.79-1.47A1.18,1.18,0,0,0,237,361.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.63,387a1.19,1.19,0,0,0,.78-1.48,1.18,1.18,0,1,0-.78,1.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.35,374.44a2,2,0,1,0,2.45,1.3A2,2,0,0,0,213.35,374.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.46,422.92a2.36,2.36,0,1,0-.45,3.3A2.35,2.35,0,0,0,205.46,422.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.33,428.22a2.36,2.36,0,1,0-3.76,2.85,2.36,2.36,0,0,0,3.76-2.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43,424.14a2,2,0,0,0-2.37-3.14,2,2,0,1,0,2.37,3.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,434.17a1.92,1.92,0,1,0-.37,2.7A1.93,1.93,0,0,0,211.19,434.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,412.81a1.18,1.18,0,0,0,1.65.22,1.18,1.18,0,1,0-1.42-1.88A1.17,1.17,0,0,0,204,412.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,440.66a1.18,1.18,0,1,0-.23,1.65A1.17,1.17,0,0,0,197.6,440.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,436.16a2,2,0,1,0-2.75-.38A2,2,0,0,0,188.55,436.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,404.5a2.37,2.37,0,1,0,1-3.2A2.36,2.36,0,0,0,212.19,404.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,527a2.36,2.36,0,1,0-1,3.19A2.36,2.36,0,0,0,218,527Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.84,409.54a1.58,1.58,0,0,0-.63,2.13,1.57,1.57,0,1,0,.63-2.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,587.11a2,2,0,1,0-.79,2.67A2,2,0,0,0,231.84,587.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.25,473.62a1.93,1.93,0,1,0-.78,2.62A1.95,1.95,0,0,0,212.25,473.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,392.5a1.18,1.18,0,1,0-1.59-.47A1.18,1.18,0,0,0,218,392.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4,420.22a1.19,1.19,0,0,0,.47-1.6,1.18,1.18,0,1,0-.47,1.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4,410.12a2,2,0,1,0-.8,2.67A2,2,0,0,0,198.4,410.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,442.46a1.76,1.76,0,0,0,2.8.35,2,2,0,0,0,3.18-2.35,2,2,0,0,0-2.76-.45,2,2,0,0,0-.39.38,1.72,1.72,0,0,0-.93-.54,2.41,2.41,0,0,0-.52-1.22,2.37,2.37,0,1,0-3.66,3A2.34,2.34,0,0,0,222.1,442.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,446.42a2.37,2.37,0,1,0,.31-3.34A2.39,2.39,0,0,0,233,446.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,443.37a1.58,1.58,0,1,0-.22,2.23A1.58,1.58,0,0,0,240.43,443.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,439.33a2,2,0,0,0,3-2.52,2,2,0,1,0-3,2.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.14,447a2,2,0,1,0-.26,2.78A2,2,0,0,0,220.14,447Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,477.94a1.19,1.19,0,1,0-.16,1.67A1.19,1.19,0,0,0,182.08,477.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,456.8a1.2,1.2,0,0,0-1.68-.15,1.19,1.19,0,1,0,1.68.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,449.89a2,2,0,1,0-.26,2.78A2,2,0,0,0,207.32,449.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.28,439.3a2.38,2.38,0,1,0-3.31-.55A2.37,2.37,0,0,0,257.28,439.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,431.68a2,2,0,1,0-2.77-.45A2,2,0,0,0,251,431.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,438.42a2,2,0,1,0-.46,2.77A2,2,0,0,0,241.1,438.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.47,488.56a1.95,1.95,0,1,0-.45,2.71A1.94,1.94,0,0,0,247.47,488.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,420.35a1.19,1.19,0,1,0-1.66-.27A1.18,1.18,0,0,0,245.45,420.35Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,449.65a1.19,1.19,0,1,0-1.66-.27A1.18,1.18,0,0,0,236.36,449.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,416a2.39,2.39,0,0,0-2.79-1.15,1.77,1.77,0,0,0-1.39-1.13,1.77,1.77,0,1,0-.52,3.51,1,1,0,0,0,.24,0,2.4,2.4,0,0,0,.28,1A2.38,2.38,0,0,0,253,416Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.94,418.19a1.6,1.6,0,0,0,2.16.65l.18-.13a1.45,1.45,0,1,0,1.54-2,1.43,1.43,0,0,0-1,.21,1.83,1.83,0,0,0-.11-.26,1.59,1.59,0,0,0-2.79,1.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,342.42a2,2,0,1,0,2.68.8A2,2,0,0,0,194.9,342.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.35,415.53a2,2,0,1,0,1.9,3.5,2,2,0,0,0-1.9-3.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.36,509.85a2.78,2.78,0,1,0-3.78-1.11A2.77,2.77,0,0,0,233.36,509.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,497a1.19,1.19,0,0,0-2.1,1.14,1.19,1.19,0,0,0,2.1-1.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,426.91a1.19,1.19,0,0,0-1.14-2.09,1.19,1.19,0,1,0,1.14,2.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.05,419.44a2,2,0,1,0-1.89-3.48,2,2,0,0,0,1.89,3.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.77,528.92a2.37,2.37,0,1,0-3.15-1.14A2.38,2.38,0,0,0,254.77,528.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.92,411.07a1.59,1.59,0,1,0-2.1-.76A1.59,1.59,0,0,0,276.92,411.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.39,399A2,2,0,1,0,269,400,2,2,0,0,0,266.39,399Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.15,407.4a2,2,0,0,0-2.64-.95,2,2,0,0,0-.94,2.63,2,2,0,0,0,2.63,1A2,2,0,0,0,257.15,407.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.7,390.46a1.18,1.18,0,1,0-1.58-.56A1.17,1.17,0,0,0,264.7,390.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,363.15a2,2,0,1,0,1.68,3.57,2,2,0,1,0-1.68-3.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.59,539a1.78,1.78,0,1,0-1.49-2A1.78,1.78,0,0,0,248.59,539Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,374.33a1.48,1.48,0,0,0,.43-2.92,1.48,1.48,0,0,0-1.68,1.25A1.46,1.46,0,0,0,265,374.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,383.58a1.47,1.47,0,0,0-1.24-1.68,1.49,1.49,0,0,0-1.62,1,1.39,1.39,0,0,0-.84.39,1.48,1.48,0,0,0,2.05,2.14,1.53,1.53,0,0,0,.38-.6A1.46,1.46,0,0,0,266.44,383.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,369.16a.88.88,0,0,0-1,.75.88.88,0,1,0,1.75.26A.9.9,0,0,0,257,369.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,389.27a.88.88,0,0,0-1,.74.89.89,0,0,0,.75,1,.9.9,0,0,0,1-.76A.89.89,0,0,0,268,389.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.54,390a1.47,1.47,0,0,0-.9,2.77l0,.1a1.18,1.18,0,0,0,1,1.33l0,.1a.9.9,0,0,0,.76,1,.88.88,0,0,0,1-.75.89.89,0,0,0-.49-.93,1.11,1.11,0,0,0,.14-.41,1.16,1.16,0,0,0-.35-1,1.55,1.55,0,0,0,.18-.51A1.47,1.47,0,0,0,259.54,390Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,413.27a1.77,1.77,0,1,0-1.5-2A1.78,1.78,0,0,0,258,413.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,407.85a1.18,1.18,0,1,0,1,1.34A1.17,1.17,0,0,0,260.62,407.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,406.36a1.48,1.48,0,1,0-1.24-1.68A1.47,1.47,0,0,0,233.56,406.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31,393.09a1.48,1.48,0,1,0,1.25,1.69A1.49,1.49,0,0,0,202.31,393.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.68,409a.89.89,0,1,0-.75-1A.89.89,0,0,0,242.68,409Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,427.38a.89.89,0,1,0,.75,1A.89.89,0,0,0,254,427.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,431a1.48,1.48,0,1,0-1.25-1.68A1.49,1.49,0,0,0,245,431Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.62,451.07a1.78,1.78,0,0,0-.52,3.52,1.78,1.78,0,0,0,.52-3.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.74,393.51a1.48,1.48,0,1,0,1.25,1.67A1.48,1.48,0,0,0,250.74,393.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48,404a1.48,1.48,0,1,0,1.25,1.68A1.49,1.49,0,0,0,250.48,404Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.09,470.13a1.45,1.45,0,1,0,1.22,1.64A1.44,1.44,0,0,0,241.09,470.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.27,392a.89.89,0,1,0,1-.75A.88.88,0,0,0,241.27,392Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29,411.36a.89.89,0,0,0-.25,1.76.87.87,0,0,0,1-.75A.89.89,0,0,0,253.29,411.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,470.89a1.48,1.48,0,1,0,1.25,1.68A1.48,1.48,0,0,0,233.3,470.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,423.21a1.78,1.78,0,1,0-1.49-2A1.78,1.78,0,0,0,265.92,423.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.15,415.75a1.77,1.77,0,1,0,1.5,2A1.77,1.77,0,0,0,276.15,415.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.25,413.83a1.18,1.18,0,0,0-1.34,1,1.18,1.18,0,0,0,2.34.35A1.19,1.19,0,0,0,278.25,413.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61,418.44a1.48,1.48,0,1,0-1.25-1.68A1.48,1.48,0,0,0,268.61,418.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,426a1.48,1.48,0,1,0,1.25,1.68A1.47,1.47,0,0,0,268.77,426Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,425.58a1.45,1.45,0,1,0-1.23-1.65A1.45,1.45,0,0,0,275,425.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.75,492.26a.88.88,0,1,0,.75,1A.89.89,0,0,0,199.75,492.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,433.37a.89.89,0,1,0-.26,1.76.88.88,0,0,0,1-.75A.9.9,0,0,0,271.59,433.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.67,437a1.48,1.48,0,1,0-1.24-1.68,1.39,1.39,0,0,0,.11.81,1.57,1.57,0,1,0,.25.39A1.43,1.43,0,0,0,262.67,437Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.31,490.28a1.78,1.78,0,1,0,1.49,2A1.78,1.78,0,0,0,267.31,490.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,406.11a1.19,1.19,0,1,0,1,1.35A1.2,1.2,0,0,0,292,406.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,409.47a1.48,1.48,0,1,0-1.68,1.25A1.48,1.48,0,0,0,284,409.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06,421.22a1.48,1.48,0,1,0-1.25-1.68A1.48,1.48,0,0,0,282.06,421.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.19,415a1.45,1.45,0,1,0,1.22,1.65A1.46,1.46,0,0,0,289.19,415Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,428a1.48,1.48,0,1,0-2.93-.44,1.48,1.48,0,0,0,2.93.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,331.34a1.78,1.78,0,0,0,2-1.49,1.78,1.78,0,1,0-3.52-.52A1.77,1.77,0,0,0,215.74,331.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,461.39a1.77,1.77,0,1,0-1.51-2A1.78,1.78,0,0,0,256.78,461.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,311.09A1.48,1.48,0,1,0,213,309.4,1.48,1.48,0,0,0,214.25,311.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,477.88a1.48,1.48,0,1,0-1.25-1.68A1.48,1.48,0,0,0,273.69,477.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.66,404.59a1.45,1.45,0,1,0-2.23,1l-.13,0a.89.89,0,1,0,.75,1,.9.9,0,0,0-.35-.83l.31.08A1.45,1.45,0,0,0,276.66,404.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,413.61a.88.88,0,1,0-.26,1.75.88.88,0,0,0,1-.75A.87.87,0,0,0,271.57,413.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.65,498.46a1.48,1.48,0,1,0,1.25,1.68A1.48,1.48,0,0,0,228.65,498.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,315.15a1.78,1.78,0,1,0-1.5-2A1.78,1.78,0,0,0,249.86,315.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.38,347.71a1.77,1.77,0,1,0-1.5-2A1.78,1.78,0,0,0,355.38,347.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,388.65a1.17,1.17,0,0,0,1,1.34,1.18,1.18,0,1,0,.35-2.34A1.17,1.17,0,0,0,294,388.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.62,532.11a1.48,1.48,0,1,0,1.25,1.68A1.48,1.48,0,0,0,256.62,532.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.13,353.25a1.48,1.48,0,1,0-1.25-1.67A1.48,1.48,0,0,0,248.13,353.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.82,571.19a1.45,1.45,0,1,0,1.22,1.64A1.44,1.44,0,0,0,254.82,571.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.7,387.08a.89.89,0,1,0-.26,1.77.89.89,0,0,0,.26-1.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7,407.93a.87.87,0,0,0,.42.9,1.84,1.84,0,0,0-.26.7,1.77,1.77,0,1,0,2-1.5,1.89,1.89,0,0,0-.41,0,.89.89,0,0,0-1.77-.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.59,276a2.68,2.68,0,1,0,.7-3.74A2.68,2.68,0,0,0,319.59,276Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.29,441.42a1.79,1.79,0,1,0-.47,2.48A1.79,1.79,0,0,0,329.29,441.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.78,464.2a2.27,2.27,0,0,0-.59,3.13l.12.13a1.48,1.48,0,1,0,1.13.75,2.24,2.24,0,1,0-.66-4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.83,549.43a2.19,2.19,0,1,0-.57,3.05A2.19,2.19,0,0,0,290.83,549.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,458.48a1.35,1.35,0,0,0-.35,1.87,1.34,1.34,0,1,0,.35-1.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.48,469.49a1.34,1.34,0,0,0,1.51,2.22,1.34,1.34,0,1,0-1.51-2.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.87,479.55a2.24,2.24,0,1,0-.59,3.11A2.24,2.24,0,0,0,333.87,479.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.56,523.33a2.66,2.66,0,1,0-.32,3.75A2.65,2.65,0,0,0,299.56,523.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05,508.2a2.65,2.65,0,1,0,3.74.33A2.67,2.67,0,0,0,301.05,508.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.26,506.67a1.77,1.77,0,1,0-2.49-.21A1.78,1.78,0,0,0,303.26,506.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.84,516.22a2.21,2.21,0,1,0-.27,3.12A2.2,2.2,0,0,0,296.84,516.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,526.67a2.22,2.22,0,1,0,3.13.27A2.24,2.24,0,0,0,305.2,526.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,516.17a2.11,2.11,0,0,0-.83-.6,2.18,2.18,0,0,0-.44-1.52,2.21,2.21,0,1,0-2.56,3.4,2.14,2.14,0,0,0,.5,1.51,2.17,2.17,0,0,0,3.33-2.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.63,525.07a1.32,1.32,0,1,0,.17-1.87A1.32,1.32,0,0,0,282.63,525.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.26,530.83a1.33,1.33,0,1,0,1.71,2,1.33,1.33,0,1,0-1.71-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.72,541.28a2.22,2.22,0,1,0-.28,3.12A2.21,2.21,0,0,0,311.72,541.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.37,498.92a2.66,2.66,0,1,0,.47-3.71A2.65,2.65,0,0,0,294.37,498.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.37,481.15a2.65,2.65,0,1,0-.47,3.72A2.64,2.64,0,0,0,304.37,481.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,478.92a1.77,1.77,0,1,0,.31-2.47A1.77,1.77,0,0,0,300.45,478.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.55,481.14a2.21,2.21,0,1,0-.39,3.1A2.21,2.21,0,0,0,284.55,481.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.05,499.23a2.21,2.21,0,1,0,3.11.4A2.21,2.21,0,0,0,304.05,499.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.46,489a2.17,2.17,0,1,0-.38,3A2.17,2.17,0,0,0,310.46,489Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5,497a1.33,1.33,0,1,0-1.87-.24A1.32,1.32,0,0,0,283.5,497Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.9,503.82a1.32,1.32,0,1,0,1.86.23A1.32,1.32,0,0,0,314.9,503.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,533.4a2.69,2.69,0,1,0-.3,3.78A2.68,2.68,0,0,0,329,533.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,518.13a2.68,2.68,0,1,0,3.77.32A2.68,2.68,0,0,0,330.36,518.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.58,516.57a1.78,1.78,0,0,0-2.31-2.72,1.78,1.78,0,1,0,2.31,2.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.17,526.24a2.24,2.24,0,1,0-.26,3.16A2.23,2.23,0,0,0,326.17,526.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.57,540.13a2.24,2.24,0,1,0-3.16-.25A2.22,2.22,0,0,0,337.57,540.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.51,537.38a2.19,2.19,0,1,0,.25-3.09A2.2,2.2,0,0,0,267.51,537.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,535.41a1.34,1.34,0,1,0-1.89-.15A1.33,1.33,0,0,0,313.79,535.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59,542.89a1.34,1.34,0,1,0-1.9-.15A1.35,1.35,0,0,0,347.59,542.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,551.16a2.23,2.23,0,1,0,3.15.26A2.25,2.25,0,0,0,338.18,551.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.08,523.53a2.71,2.71,0,1,0,.4-3.81A2.72,2.72,0,0,0,348.08,523.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.08,504.75a2.71,2.71,0,1,0,3.81.4A2.72,2.72,0,0,0,354.08,504.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.37,503.23a1.81,1.81,0,1,0-2.54-.27A1.8,1.8,0,0,0,356.37,503.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,512.83a2.25,2.25,0,1,0-.33,3.18A2.25,2.25,0,0,0,349.65,512.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.64,526.8a2.26,2.26,0,1,0,.33-3.18A2.26,2.26,0,0,0,357.64,526.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.65,456.24a2.21,2.21,0,1,0-.33,3.11A2.21,2.21,0,0,0,246.65,456.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,521.58a1.33,1.33,0,0,0,1.9.2,1.31,1.31,0,0,0,.36-.46,2.24,2.24,0,1,0-.61-1.8,1.35,1.35,0,0,0-1.44.16A1.34,1.34,0,0,0,335,521.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,530a1.34,1.34,0,0,0,1.9.21,1.35,1.35,0,1,0-1.7-2.11A1.35,1.35,0,0,0,369,530Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,538.29a2.25,2.25,0,1,0,3.18.32A2.25,2.25,0,0,0,361.15,538.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.33,499.25a2.69,2.69,0,1,0,3.78.48A2.7,2.7,0,0,0,325.33,499.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,407.92a2.7,2.7,0,1,0,.48-3.78A2.7,2.7,0,0,0,373.66,407.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23,467.77a1.79,1.79,0,1,0-.32,2.52A1.8,1.8,0,0,0,265.23,467.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.24,495.57a2.24,2.24,0,1,0-3.15-.4A2.24,2.24,0,0,0,326.24,495.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.85,503.74a2.25,2.25,0,1,0-3.56,2.76,2.25,2.25,0,0,0,3.56-2.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.21,493a2.2,2.2,0,0,0-3.68,2.39,2.27,2.27,0,0,0-1.07.38,2.23,2.23,0,0,0,2.52,3.69,2.21,2.21,0,0,0,.69-2.92,2.13,2.13,0,0,0,1.14-.45A2.21,2.21,0,0,0,341.21,493Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.14,498.92a1.35,1.35,0,1,0,1.65,2.13,1.35,1.35,0,1,0-1.65-2.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71,508a1.35,1.35,0,1,0,1.89.23A1.35,1.35,0,0,0,345.71,508Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,488.32a2.72,2.72,0,1,0,3.8.57A2.72,2.72,0,0,0,353.77,488.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.84,381.17a2.72,2.72,0,1,0,3.8.58A2.73,2.73,0,0,0,363.84,381.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,469.2a1.81,1.81,0,1,0,2.53.38A1.81,1.81,0,0,0,360.26,469.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.07,481a2.27,2.27,0,1,0,3.17.48A2.27,2.27,0,0,0,352.07,481Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,495.83a2.27,2.27,0,1,0,.48-3.17A2.27,2.27,0,0,0,362.63,495.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.35,485a2.22,2.22,0,1,0,.46-3.1A2.22,2.22,0,0,0,366.35,485Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.17,489.59a1.37,1.37,0,1,0,.29-1.91A1.37,1.37,0,0,0,340.17,489.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,499.51a1.35,1.35,0,0,0,1.9.29,1.36,1.36,0,1,0-1.61-2.19A1.35,1.35,0,0,0,373.85,499.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.18,510.69a2.27,2.27,0,1,0,.47-3.17A2.26,2.26,0,0,0,365.18,510.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,344.49a1.77,1.77,0,1,0,.18-2.51A1.76,1.76,0,0,0,277,344.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,332.06a1.78,1.78,0,1,0,2.5.2A1.78,1.78,0,0,0,280.57,332.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.49,329.23a1.18,1.18,0,1,0,1.67.12A1.19,1.19,0,0,0,280.49,329.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.81,337.44a1.49,1.49,0,0,0-2.09-.15,1.49,1.49,0,0,0,1.94,2.25A1.5,1.5,0,0,0,277.81,337.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.32,346.46a1.5,1.5,0,0,0,2.09.16,1.49,1.49,0,1,0-2.09-.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.21,339.2a1.45,1.45,0,0,0,2.2-1.89,1.45,1.45,0,1,0-2.2,1.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.64,343.55a.89.89,0,0,0,.1-1.25.91.91,0,0,0-1.26-.09.89.89,0,1,0,1.16,1.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,347.06a.9.9,0,0,0-.09,1.25.88.88,0,0,0,1.25.1.89.89,0,0,0,.1-1.26A.91.91,0,0,0,290.88,347.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.84,353.92a1.48,1.48,0,1,0,2.09.16A1.49,1.49,0,0,0,285.84,353.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,383.8a1.78,1.78,0,1,0,0-2.51A1.77,1.77,0,0,0,256.27,383.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.07,373.7a1.78,1.78,0,1,0,.05-2.51A1.78,1.78,0,0,0,259.07,373.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,370.06a1.18,1.18,0,1,0-1.64-1.7,1.18,1.18,0,0,0,1.64,1.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,376.68a1.48,1.48,0,1,0,2.09,0A1.49,1.49,0,0,0,254.59,376.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,479.13a1.46,1.46,0,1,0-2.06,0A1.46,1.46,0,0,0,245,479.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.47,365.12a1.78,1.78,0,1,0,2.53.11A1.81,1.81,0,0,0,261.47,365.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.06,355.21a1.77,1.77,0,1,0-.11,2.5A1.77,1.77,0,0,0,267.06,355.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.06,352.33a1.19,1.19,0,0,0-1.68-.07,1.19,1.19,0,1,0,1.68.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,360.56a1.48,1.48,0,1,0-.09,2.09A1.47,1.47,0,0,0,262,360.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.85,367.29a1.48,1.48,0,1,0,2.09.1A1.49,1.49,0,0,0,267.85,367.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.56,360.11a1.45,1.45,0,1,0-2.14,2,1.45,1.45,0,0,0,2.14-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,366.92a.88.88,0,1,0-1.26-.05A.88.88,0,0,0,254,366.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,371.07a.89.89,0,1,0-1.2-1.31.65.65,0,0,0-.15.18,1.11,1.11,0,0,0-.51-.21,1.18,1.18,0,0,0-1.35,1,1.2,1.2,0,0,0,1,1.35,1.19,1.19,0,0,0,1.3-.83A.88.88,0,0,0,276.54,371.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,376.77a1.47,1.47,0,0,0-.09,2.09,1.12,1.12,0,0,0,.2.18,1.49,1.49,0,0,0-.39.78,1.45,1.45,0,1,0,2.87.43,1.43,1.43,0,0,0-.55-1.35,1.47,1.47,0,0,0-2-2.13Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.58,547.07a1.78,1.78,0,1,0-2.51,0A1.77,1.77,0,0,0,262.58,547.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.3,380.81a1.77,1.77,0,1,0,2.5,0A1.76,1.76,0,0,0,276.3,380.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.69,378a1.18,1.18,0,1,0,0,1.67A1.17,1.17,0,0,0,277.69,378Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.83,388.45a1.47,1.47,0,1,0,0-2.09.27.27,0,0,1-.07.08.88.88,0,0,0-.2-.87.89.89,0,1,0-.06,1.29A1.46,1.46,0,0,0,271.83,388.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.06,354.06a1.48,1.48,0,1,0,0-2.09A1.47,1.47,0,0,0,222.06,354.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,385.1a2.07,2.07,0,0,0,2.91,2.95,2.09,2.09,0,0,0,0-2.94A2.07,2.07,0,0,0,281,385.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,393a.83.83,0,0,0,.35.22,1.49,1.49,0,0,0,.33,1.54,1.48,1.48,0,1,0,.83-2.49,1,1,0,0,0-.25-.52.91.91,0,0,0-1.26,0A.88.88,0,0,0,265,393Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.17,404.34a1.48,1.48,0,1,0-2.08-2.11,1.51,1.51,0,0,0-.42,1.22v0a1.48,1.48,0,1,0,.36.82l.06.08A1.48,1.48,0,0,0,285.17,404.34Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.38,385a1.77,1.77,0,1,0,2.52,0A1.78,1.78,0,0,0,290.38,385Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.13,374.86a1.77,1.77,0,0,0,0,2.51,1.78,1.78,0,0,0,2.55-2.48A1.77,1.77,0,0,0,293.13,374.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,373.73a1.18,1.18,0,1,0-1.65-1.7,1.18,1.18,0,0,0,1.65,1.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.72,380.4a1.48,1.48,0,1,0,0,2.1A1.48,1.48,0,0,0,290.72,380.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.82,387a1.48,1.48,0,1,0,2.07,2.12C299.47,388.5,297.4,386.38,296.82,387Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.3,379.65a1.45,1.45,0,1,0,0,2.06A1.46,1.46,0,0,0,300.3,379.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1,509.66a.9.9,0,0,0-1.26,0,.89.89,0,0,0,0,1.26.89.89,0,1,0,1.27-1.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.62,390.45a.89.89,0,0,0,0-1.27.88.88,0,0,0-1.25,0,.88.88,0,0,0,0,1.25A.89.89,0,0,0,305.62,390.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.12,314.84a1.48,1.48,0,1,0,2.07,2.12,1.47,1.47,0,0,0,0-2.09A1.49,1.49,0,0,0,291.12,314.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.89,373.58a1.78,1.78,0,1,0,.11-2.52A1.77,1.77,0,0,0,279.89,373.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,519.91a1.78,1.78,0,1,0-2.62,2.4,1.78,1.78,0,0,0,2.62-2.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.49,359.94a1.18,1.18,0,0,0,.08-1.67,1.2,1.2,0,0,0-1.68-.07,1.18,1.18,0,1,0,1.6,1.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.39,366.41a1.48,1.48,0,1,0,2.09.09A1.49,1.49,0,0,0,278.39,366.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,373.32a1.48,1.48,0,0,0-2.18,2,1.48,1.48,0,1,0,2.18-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,291.39a2.07,2.07,0,1,0,.13-2.93A2.07,2.07,0,0,0,300.15,291.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,371.57a.86.86,0,0,0-.29.62,1.7,1.7,0,0,0-.46.95,1.77,1.77,0,0,0,3.51.52,1.79,1.79,0,0,0-1.49-2h0v0A.89.89,0,0,0,271.32,371.57Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,503a1.48,1.48,0,1,0,2.09.09A1.47,1.47,0,0,0,274.1,503Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,363.83a1.78,1.78,0,1,0-2.63,2.39,1.78,1.78,0,0,0,2.63-2.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,353.81a1.77,1.77,0,1,0-.11,2.51A1.77,1.77,0,0,0,304,353.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.29,350.85a1.19,1.19,0,1,0,1.68.08A1.21,1.21,0,0,0,301.29,350.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,361.15a1.48,1.48,0,1,0,.09-2.09A1.47,1.47,0,0,0,296.67,361.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72,365.9a1.48,1.48,0,1,0,2.09.1A1.47,1.47,0,0,0,304.72,365.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,488.45a1.45,1.45,0,1,0-2.06-.09A1.45,1.45,0,0,0,266.22,488.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,364.25a.86.86,0,0,0-1.24-.06.88.88,0,0,0-.07,1.25.89.89,0,0,0,1.26.06A.88.88,0,0,0,290.92,364.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.45,375.48a1.48,1.48,0,1,0-2.18,2,1.48,1.48,0,1,0,2.18-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.71,407.82a1.78,1.78,0,1,0-.2,2.5A1.78,1.78,0,0,0,323.71,407.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,396.66a1.18,1.18,0,1,0-1.55-1.79,1.18,1.18,0,0,0,1.55,1.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.59,405a1.48,1.48,0,1,0,2.24-1.92,1.48,1.48,0,1,0-2.24,1.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,440.24a1.48,1.48,0,1,0,.16-2.09A1.48,1.48,0,0,0,385.12,440.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,437.64a1.45,1.45,0,1,0,.16-2.05A1.46,1.46,0,0,0,370.15,437.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,409.2a.92.92,0,0,0,.09-1.26.89.89,0,1,0-.09,1.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,414.06a.89.89,0,1,0-1.25-.1A.89.89,0,0,0,336.06,414.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,421.65a1.48,1.48,0,1,0,.16-2.09A1.49,1.49,0,0,0,329.7,421.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,449.49a1.78,1.78,0,1,0-2.51,0A1.77,1.77,0,0,0,302.8,449.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,473.54a1.18,1.18,0,1,0,0,1.68A1.17,1.17,0,0,0,335.6,473.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.61,442.33a1.47,1.47,0,1,0,2.05,2.12,1.46,1.46,0,0,0,0-2.09A1.48,1.48,0,0,0,298.61,442.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,451a1.47,1.47,0,0,0,2.09,0,1.48,1.48,0,1,0-2.06-2.13A1.47,1.47,0,0,0,306.73,451Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.32,451.19a.9.9,0,0,0,0,1.26.89.89,0,1,0,1.27-1.24A.89.89,0,0,0,314.32,451.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.65,460.43a1.48,1.48,0,1,0,.83-2.49.85.85,0,0,0-.25-.52.88.88,0,0,0-1.25,0,.9.9,0,0,0,0,1.26.91.91,0,0,0,.35.21A1.49,1.49,0,0,0,309.65,460.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.46,423.25a1.79,1.79,0,0,0,2.51.11,1.78,1.78,0,0,0-2.4-2.63A1.79,1.79,0,0,0,308.46,423.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.34,419.58a1.17,1.17,0,0,0,1.66.07,1.18,1.18,0,1,0-1.66-.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.88,428.67a1.55,1.55,0,0,0,0,1.56,1.45,1.45,0,0,0,.59.61,1.77,1.77,0,1,0,2.58,0,1.8,1.8,0,0,0-.55-.41,1.59,1.59,0,0,0,.14-1.73,1.56,1.56,0,0,0-1.41-.81,1.48,1.48,0,0,0-2.29-1.81,1.47,1.47,0,0,0-.09,2.08A1.44,1.44,0,0,0,304.88,428.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,433a1.48,1.48,0,1,0-.09,2.09A1.47,1.47,0,0,0,314,433Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.18,455.21a.89.89,0,1,0,1.25.06A.89.89,0,0,0,253.18,455.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,442.51a1.48,1.48,0,1,0-.1,2.08A1.46,1.46,0,0,0,316.63,442.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,479.69a1.78,1.78,0,1,0,0,2.51A1.76,1.76,0,0,0,266.28,479.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.71,443.63a1.17,1.17,0,0,0-1.67,0,1.18,1.18,0,1,0,1.67,0Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,327.22a1.48,1.48,0,1,0,0-2.09A1.47,1.47,0,0,0,258.26,327.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,496.47a1.49,1.49,0,0,0,2.09-.15,1.48,1.48,0,1,0-2.23-1.94A1.49,1.49,0,0,0,312.4,496.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,450.74a2.07,2.07,0,0,0,2.91,2.95,2.07,2.07,0,1,0-2.91-2.95Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,460.68a.89.89,0,1,0,0,1.27A.9.9,0,0,0,332.92,460.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.36,450.14a6.75,6.75,0,0,1-.61-4.1,1.49,1.49,0,0,0-2.13,2.08,1.52,1.52,0,0,0,.4.28,1.48,1.48,0,0,0,0,2,1.45,1.45,0,0,0,1.18.46,1.8,1.8,0,1,0,1.2-.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66,440.53a1.77,1.77,0,1,0,0,2.51A1.78,1.78,0,0,0,339.66,440.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.57,437.69a1.19,1.19,0,1,0,0,1.68A1.2,1.2,0,0,0,338.57,437.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.82,454.69a1.48,1.48,0,1,0,0-2.1A1.48,1.48,0,0,0,340.82,454.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.32,445.29a1.45,1.45,0,1,0,0,2A1.45,1.45,0,0,0,344.32,445.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6,487.44a.89.89,0,1,0,1.27-1.24.88.88,0,0,0-1.25,0A.9.9,0,0,0,276.6,487.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,456.06a.89.89,0,1,0,0-1.25A.89.89,0,0,0,348.39,456.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.81,462a1.48,1.48,0,1,0,2.09,0A1.48,1.48,0,0,0,343.81,462Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.34,505.88a1.78,1.78,0,1,0-.11,2.51A1.78,1.78,0,0,0,288.34,505.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,425.58a1.16,1.16,0,0,0,.08-1.66,1.19,1.19,0,1,0-1.75,1.6A1.17,1.17,0,0,0,328.51,425.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.51,432.14a1.48,1.48,0,0,0-2.18,2,1.48,1.48,0,0,0,2.18-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,439a1.49,1.49,0,1,0-.1,2.1A1.5,1.5,0,0,0,332.49,439Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,431.15a2.05,2.05,0,0,0-.13,2.92,2.07,2.07,0,0,0,3.09-2.75.92.92,0,0,0,.3-.18.9.9,0,0,0,.06-1.26.89.89,0,0,0-1.53.76A2.07,2.07,0,0,0,331.63,431.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.28,438.46a.88.88,0,1,0,.06-1.25A.88.88,0,0,0,315.28,438.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.26,431.86a1.78,1.78,0,1,0,.12-2.51A1.78,1.78,0,0,0,342.26,431.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.36,421.84a1.75,1.75,0,0,0,2.5.11,1.77,1.77,0,1,0-2.39-2.61A1.76,1.76,0,0,0,345.36,421.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.24,418.17a1.19,1.19,0,1,0,.08-1.67A1.18,1.18,0,0,0,345.24,418.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,426.89a1.48,1.48,0,1,0-2-2.19,1.48,1.48,0,0,0,2,2.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.83,431.64a1.48,1.48,0,1,0-.09,2.09A1.47,1.47,0,0,0,350.83,431.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.58,334.58a1.45,1.45,0,1,0-2.05-.09A1.45,1.45,0,0,0,302.58,334.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.17,435.27a.89.89,0,0,0,1.32-1.19.9.9,0,0,0-1.26-.06A.89.89,0,0,0,356.17,435.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,441a1.48,1.48,0,0,0,2,2.19,1.47,1.47,0,0,0,.1-2.09A1.49,1.49,0,0,0,351.38,441Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.45,441.9a2.36,2.36,0,1,0-2.93-1.57A2.36,2.36,0,0,0,88.45,441.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8,429.55a2.35,2.35,0,1,0-1.56,2.94A2.36,2.36,0,0,0,79.8,429.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.82,428.58a1.57,1.57,0,1,0-1,1.95A1.56,1.56,0,0,0,74.82,428.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,438.44a2,2,0,1,0-1.31,2.45A2,2,0,0,0,82.8,438.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.09,431.52a2,2,0,1,0,2.44,1.31A2,2,0,0,0,93.09,431.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72,426.69a1.92,1.92,0,1,0-1.28,2.4A1.93,1.93,0,0,0,87.72,426.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,450.31a1.18,1.18,0,1,0-.79,1.47A1.17,1.17,0,0,0,83.39,450.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,425.74a1.18,1.18,0,1,0-.79,1.47A1.19,1.19,0,0,0,101.27,425.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,435.08a2,2,0,1,0-1.31,2.44A2,2,0,0,0,108.38,435.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,389a2.35,2.35,0,1,0,.46-3.3A2.35,2.35,0,0,0,115,389Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,383.74a2.36,2.36,0,1,0,.47-3.3A2.36,2.36,0,0,0,102.1,383.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.84,381.7A1.57,1.57,0,0,0,98.05,383a1.18,1.18,0,0,0-.87.26,1.2,1.2,0,0,0-.16,1.67,1.21,1.21,0,0,0,1.68.17,1.23,1.23,0,0,0,.43-1,1.57,1.57,0,0,0,1.71-2.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78,406.2a4.71,4.71,0,1,0,1.69,3.56,2.19,2.19,0,0,1-1.69-3.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.32,339.29a2,2,0,0,0-2.38-3.14,1.94,1.94,0,0,0-.37,2.75A2,2,0,0,0,82.32,339.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,319.84a1.93,1.93,0,1,0,2.7.37A1.94,1.94,0,0,0,155.93,319.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,400.81a1.18,1.18,0,0,0-1.43-1.88,1.18,1.18,0,0,0,1.43,1.88Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.47,371.52a1.17,1.17,0,1,0-1.64-.22A1.16,1.16,0,0,0,124.47,371.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.41,458.81a2,2,0,1,0-3.13,2.37,2,2,0,0,0,3.13-2.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23,407.46a2.36,2.36,0,1,0-1,3.2A2.35,2.35,0,0,0,108.23,407.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.71,478a2.36,2.36,0,1,0-1,3.2A2.37,2.37,0,0,0,66.71,478Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.21,400.29a1.57,1.57,0,1,0-2.77,1.49,1.57,1.57,0,1,0,2.77-1.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89,413.76a2,2,0,1,0,.79-2.67A2,2,0,0,0,87.89,413.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,402.2a2,2,0,1,0-.07-1.69,1,1,0,0,0-.22-.53.91.91,0,0,0-1.26-.06.9.9,0,0,0-.06,1.26.89.89,0,0,0,1.26.05.53.53,0,0,0,.12-.14A2,2,0,0,0,109,402.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,460.51a1.93,1.93,0,0,0-3.4,1.83,1.93,1.93,0,0,0,3.4-1.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,419.93a1.18,1.18,0,0,0-2.08,1.12,1.18,1.18,0,0,0,2.08-1.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,391.74a1.18,1.18,0,1,0,1.61.48A1.18,1.18,0,0,0,115,391.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.83,399.17a2,2,0,1,0,2.66.8A2,2,0,0,0,122.83,399.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.44,365.53a2.37,2.37,0,1,0-.31,3.34A2.37,2.37,0,0,0,87.44,365.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,368.59a1.58,1.58,0,0,0,2.44-2,1.58,1.58,0,1,0-2.44,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.69,372.63a2,2,0,1,0-.27,2.79A2,2,0,0,0,93.69,372.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.23,228.61a2,2,0,1,0,.26-2.79A2,2,0,0,0,173.23,228.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,353.2a2.76,2.76,0,1,0-.37,3.89A2.76,2.76,0,0,0,57.91,353.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.36,258.24a2,2,0,0,0,2.79.25,2,2,0,1,0-2.79-.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,378.33a2.38,2.38,0,1,0,3.31.55A2.37,2.37,0,0,0,76,378.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.59,376a2.38,2.38,0,1,0,.55-3.32A2.39,2.39,0,0,0,62.59,376Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,376.1a1.58,1.58,0,1,0-1.84-2.57A1.58,1.58,0,1,0,61,376.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.21,380.73A2,2,0,1,0,69,383a2,2,0,0,0,3.22-2.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.32,373.54a2,2,0,1,0,.46-2.77A2,2,0,0,0,79.32,373.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.64,370.61a1.94,1.94,0,1,0-2.71-.45A1.94,1.94,0,0,0,72.64,370.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7,393.26a1.19,1.19,0,1,0,.27-1.65A1.19,1.19,0,0,0,74.7,393.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,364a1.19,1.19,0,1,0,.27-1.66A1.2,1.2,0,0,0,83.79,364Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67,396.94a2.39,2.39,0,1,0-3.24-1A2.39,2.39,0,0,0,70.67,396.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,395.92a1.59,1.59,0,1,0-2.16-.64A1.6,1.6,0,0,0,65.85,395.92Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,395.63a2,2,0,1,0,.8-2.7A2,2,0,0,0,84.38,395.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6,314a2.77,2.77,0,1,0-1.1,3.77A2.76,2.76,0,0,0,61.6,314Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.43,413.53a1.2,1.2,0,0,0-1.62-.47,1.19,1.19,0,1,0,1.62.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.61,387.14a1.19,1.19,0,1,0-1.61-.48A1.18,1.18,0,0,0,91.61,387.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27,396a2,2,0,1,0-2.7-.79A2,2,0,0,0,100.27,396Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.27,409.8A2.37,2.37,0,1,0,61.12,413,2.36,2.36,0,0,0,62.27,409.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.71,401.9a2.37,2.37,0,1,0-1.13,3.15A2.38,2.38,0,0,0,50.71,401.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,401.65a1.59,1.59,0,0,0-2.11-.76,1.58,1.58,0,1,0,2.11.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,410.32a2,2,0,0,0-2.63-.95,2,2,0,1,0,2.63.95Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.28,404.56a2,2,0,1,0,1-2.64A2,2,0,0,0,63.28,404.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.18,397.9a1.94,1.94,0,1,0-.93,2.58A1.95,1.95,0,0,0,58.18,397.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.31,422.06a1.19,1.19,0,1,0-.57,1.58A1.19,1.19,0,0,0,57.31,422.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,405.87A2,2,0,0,0,80.17,404a2.38,2.38,0,0,0,3.51-3.05,2.38,2.38,0,0,0-4.45,1.46,1.93,1.93,0,0,0-2.59.49,2,2,0,0,0-.23-1,2,2,0,1,0-.8,2.69,1.88,1.88,0,0,0,.62-.53,2.06,2.06,0,0,0,.18.87A2,2,0,0,0,79,405.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,475.54a2.35,2.35,0,1,0-1.57,2.94A2.35,2.35,0,0,0,135.32,475.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.64,367.08A2.35,2.35,0,0,0,100,369.8a2.33,2.33,0,0,0-1.12-.34,1.57,1.57,0,0,0,.69-1.79,1.57,1.57,0,1,0-1.78,2,2.19,2.19,0,0,0-.55.32,2.23,2.23,0,0,0-.43.49,1.8,1.8,0,0,0-.42-1.08,1.77,1.77,0,0,0-1.25-.61,2,2,0,0,0-2.82,2.71,2,2,0,0,0,2.15.73,1.77,1.77,0,0,0,1.73-.32.89.89,0,0,0,.19-.2,2.37,2.37,0,1,0,4.68-.38,2.35,2.35,0,1,0,.55-4.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.81,378.67a2,2,0,1,0,1.3-2.44A1.95,1.95,0,0,0,103.81,378.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.54,373.07a2,2,0,1,0,1.31-2.45A2,2,0,0,0,116.54,373.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21,368.19a1.93,1.93,0,0,0,1.35-1.72l.16-.13a1.8,1.8,0,0,0,0-2.52,1.79,1.79,0,0,0-3,.82,1.92,1.92,0,0,0,1.45,3.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,390.09a1.18,1.18,0,1,0,.79-1.47A1.18,1.18,0,0,0,105.9,390.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,364.05a1.18,1.18,0,0,0,.68,2.25,1.18,1.18,0,1,0-.68-2.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,374.52a.9.9,0,0,0,0-1.2.88.88,0,0,0-.86-.23,1.93,1.93,0,0,0-1.61-.23,2,2,0,1,0,2.51,1.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,324.83a2.36,2.36,0,1,0,3.3.46A2.36,2.36,0,0,0,140.19,324.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,322.83a2.36,2.36,0,1,0,.46-3.31A2.36,2.36,0,0,0,126.86,322.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,320.8a1.57,1.57,0,0,0-2.78,1.3,1.19,1.19,0,1,0,.64,2.1,1.17,1.17,0,0,0,.43-.95,1.57,1.57,0,0,0,1.71-2.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.52,327.3a2,2,0,0,0-2.75-.38,1.93,1.93,0,0,0-.77,1.52,1.18,1.18,0,1,0,.66,1.52,2,2,0,0,0,2.47.1A2,2,0,0,0,136.52,327.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,317.23a2,2,0,1,0,2.76.39A2,2,0,0,0,143.78,317.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,314.19a1.93,1.93,0,1,0,2.7.37A1.94,1.94,0,0,0,134.37,314.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,338.25a1.19,1.19,0,0,0-1.66-.23,1.19,1.19,0,0,0,1.43,1.89A1.19,1.19,0,0,0,141.19,338.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,310.4a1.19,1.19,0,0,0,1.89-1.43,1.18,1.18,0,0,0-1.66-.23A1.2,1.2,0,0,0,147.58,310.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,318a2,2,0,1,0-2.75-.38A2,2,0,0,0,159,318Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,401a2.36,2.36,0,1,0-1,3.2A2.36,2.36,0,0,0,190.92,401Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.79,347.49a2,2,0,1,0-.8,2.66A2,2,0,0,0,125.79,347.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.51,338.63a2,2,0,0,0,.68,3.68.89.89,0,1,0,1.31.9.87.87,0,0,0-.54-.95,2.41,2.41,0,0,0,.42-.16,2,2,0,1,0-1.87-3.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,272.24a1.93,1.93,0,1,0,.78-2.61A1.92,1.92,0,0,0,159.76,272.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,359a1.18,1.18,0,1,0-.48,1.6A1.18,1.18,0,0,0,128.74,359Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63,342.85a1.19,1.19,0,0,0,1.6.48,1.18,1.18,0,1,0-1.6-.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.59,338.26a2,2,0,1,0,1.87,3.46,2,2,0,0,0-1.87-3.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,309.09a2.37,2.37,0,1,0,3.35.31A2.37,2.37,0,0,0,122,309.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,307.65a2.36,2.36,0,0,0,3.34.32,2.37,2.37,0,1,0-3.34-.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,307.69a1.58,1.58,0,1,0,.2-2.24A1.61,1.61,0,0,0,104.76,307.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45,311.73a2,2,0,1,0-.27,2.78A2,2,0,0,0,118.45,311.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31,301.29a2,2,0,1,0,2.79.27A2,2,0,0,0,125.31,301.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84,294.25a1.18,1.18,0,1,0,.15-1.67A1.18,1.18,0,0,0,128.84,294.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,298.65a2,2,0,0,0-3.06,2.52,2,2,0,0,0,2.79.25A2,2,0,0,0,140.91,298.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.73,317.43a2.38,2.38,0,0,0-.81,2.83A1.78,1.78,0,0,0,98,323.15a1.77,1.77,0,0,0,3-1.72A2.37,2.37,0,0,0,104,318,2.35,2.35,0,0,0,100.73,317.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,187.71a2.38,2.38,0,1,0,.54-3.32A2.38,2.38,0,0,0,118.46,187.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14,313a1.59,1.59,0,1,0-.37,2.21A1.59,1.59,0,0,0,86.14,313Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,202.77a2,2,0,0,0,2.77.45,2,2,0,1,0-2.77-.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55,309.86a2,2,0,1,0,2.76.46A2,2,0,0,0,104.55,309.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,307a1.94,1.94,0,1,0-.45,2.71A1.95,1.95,0,0,0,97.85,307Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.46,332.36a1.23,1.23,0,0,0,.86.49l-.08.06a.88.88,0,1,0,.78-.22l.1-.05a1.19,1.19,0,0,0-1.38-1.94A1.2,1.2,0,0,0,99.46,332.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,303.34a1.21,1.21,0,0,0,.28-1.66,1.19,1.19,0,1,0-.28,1.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,307.83a2,2,0,1,0,2.77.46A2,2,0,0,0,117.55,307.83Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,340a2.38,2.38,0,0,0-4.44,1.46,2,2,0,1,0,1,1.59,2.37,2.37,0,0,0,3.49-3.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.24,332.86a1.59,1.59,0,1,0-.63,2.15A1.58,1.58,0,0,0,91.24,332.86Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.42,290.84a2,2,0,1,0-.8,2.7A2,2,0,0,0,59.42,290.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,253.84a2,2,0,1,0-.79,2.7A2,2,0,0,0,156,253.84Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.05,418.21a2.78,2.78,0,1,0-1.11,3.77A2.78,2.78,0,0,0,110.05,418.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,352.16a1.19,1.19,0,1,0,1.13,2.09l.12-.08a1.18,1.18,0,1,0,.48-.74,1.18,1.18,0,0,0-1.73-1.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.86,324.63a1.19,1.19,0,0,0-2.1,1.13,1.2,1.2,0,0,0,1.62.48A1.18,1.18,0,0,0,116.86,324.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87,347.75A2.37,2.37,0,1,0,87,348.89,2.38,2.38,0,0,0,83.87,347.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.48,341a2.38,2.38,0,1,0-1.14,3.16A2.38,2.38,0,0,0,75.48,341Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37,340.75a1.58,1.58,0,1,0-.76,2.09A1.56,1.56,0,0,0,70.37,340.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,351.1a2,2,0,1,0,.94-2.63A2,2,0,0,0,76.18,351.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,253.8a2,2,0,0,0,3.59-1.69A2,2,0,0,0,228,253.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.16,457.56a1.94,1.94,0,1,0-.93,2.58A1.93,1.93,0,0,0,103.16,457.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,362.74a1.19,1.19,0,0,0-1-2.15,1.19,1.19,0,0,0,1,2.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,395.05a2.36,2.36,0,1,0,2.94,1.57A2.35,2.35,0,0,0,187.47,395.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.19,387.21a2.36,2.36,0,1,0-1.57,2.93A2.36,2.36,0,0,0,180.19,387.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,385.18a1.57,1.57,0,0,0-1,.93.84.84,0,0,0-.33.21.88.88,0,0,0,0,1.25.86.86,0,0,0,.72.26,1.57,1.57,0,1,0,.62-2.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.18,396.1a2,2,0,1,0-1.31,2.45A2,2,0,0,0,183.18,396.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.61,392.94a2,2,0,1,0-2.46-1.31A2,2,0,0,0,194.61,392.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71,383.07a1.92,1.92,0,1,0,1.81,3.29,1.48,1.48,0,1,0,1.68-1.64,1.49,1.49,0,0,0-1,.23,2.06,2.06,0,0,0-.08-.6A1.91,1.91,0,0,0,185.71,383.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,408a1.18,1.18,0,1,0-2.25.68,1.19,1.19,0,0,0,1.47.79A1.17,1.17,0,0,0,183.77,408Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,382.61a1.18,1.18,0,0,0,.68,2.26,1.18,1.18,0,0,0-.68-2.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.45,395.18a2,2,0,1,0-2.44-1.31A2,2,0,0,0,207.45,395.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.35,346.7a2.36,2.36,0,1,0,.45-3.31A2.35,2.35,0,0,0,215.35,346.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.48,341.39a2.36,2.36,0,1,0,.46-3.3A2.36,2.36,0,0,0,202.48,341.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,345.48a2,2,0,1,0,2.76.39A2,2,0,0,0,209.38,345.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62,335.45a1.93,1.93,0,0,0,3.07-2.33,1.93,1.93,0,1,0-3.07,2.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81,356.81a1.18,1.18,0,1,0-.23,1.66A1.18,1.18,0,0,0,216.81,356.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.21,329a1.18,1.18,0,0,0,1.88-1.43,1.18,1.18,0,1,0-1.88,1.43Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.25,333.45a2,2,0,1,0,2.75.39A2,2,0,0,0,232.25,333.45Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,365.12a2.36,2.36,0,1,0-1,3.2A2.35,2.35,0,0,0,208.61,365.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.77,242.64a2.36,2.36,0,1,0,1-3.2A2.36,2.36,0,0,0,202.77,242.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,357.94a1.57,1.57,0,1,0-.63,2.13A1.56,1.56,0,0,0,191.59,357.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,182.51a2,2,0,1,0,.8-2.67A2,2,0,0,0,189,182.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8,358a2,2,0,0,0-3.47,1.87,2.18,2.18,0,0,1,1.7,3.55A9.49,9.49,0,0,0,212.8,358Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.55,296a1.93,1.93,0,1,0,.79-2.61A1.93,1.93,0,0,0,208.55,296Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,377.11a1.19,1.19,0,1,0,1.6.48A1.19,1.19,0,0,0,202.76,377.11Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.41,349.39a1.18,1.18,0,1,0,1.61.48A1.18,1.18,0,0,0,215.41,349.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,359.49a2,2,0,1,0,.8-2.67A2,2,0,0,0,222.41,359.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.71,327.16a1.74,1.74,0,0,0-1.27-.88,1.77,1.77,0,0,0-1.54.53,2,2,0,1,0-.41,2.8,2,2,0,0,0,.38-.39,1.73,1.73,0,0,0,.94.55,2.38,2.38,0,1,0,1.9-2.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.82,323.19a2.37,2.37,0,1,0-.31,3.34A2.37,2.37,0,0,0,187.82,323.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38,326.24a1.58,1.58,0,1,0,.21-2.23A1.57,1.57,0,0,0,180.38,326.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8,333.07a2,2,0,1,0-2.78-.27A2,2,0,0,0,193.8,333.07Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.66,322.64a2,2,0,1,0,.26-2.79A2,2,0,0,0,200.66,322.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,291.67a1.19,1.19,0,1,0,.16-1.66A1.19,1.19,0,0,0,238.72,291.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,312.81a1.19,1.19,0,1,0,.16-1.67A1.2,1.2,0,0,0,204.45,312.81Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.48,319.72a2,2,0,1,0,.26-2.78A2,2,0,0,0,213.48,319.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,330.31a2.38,2.38,0,1,0,3.31.55A2.39,2.39,0,0,0,163.53,330.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,337.93a2,2,0,1,0,2.77.46A2,2,0,0,0,169.82,337.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.71,331.19a2,2,0,1,0,.45-2.77A2,2,0,0,0,179.71,331.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.34,281.05a1.94,1.94,0,1,0,.45-2.71A1.95,1.95,0,0,0,173.34,281.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.36,349.26a1.19,1.19,0,0,0-.28,1.65,1.19,1.19,0,1,0,.28-1.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.44,320a1.19,1.19,0,0,0,1.38,1.94,1.17,1.17,0,0,0,.28-1.66A1.19,1.19,0,0,0,184.44,320Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.82,353.64a2.38,2.38,0,0,0,2.79,1.14,1.75,1.75,0,0,0,1.39,1.13,1.77,1.77,0,1,0,.52-3.51h-.24a2.56,2.56,0,0,0-.28-1,2.38,2.38,0,0,0-4.18,2.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,351.42a1.58,1.58,0,0,0-2.15-.64l-.18.12a1.45,1.45,0,1,0-1.55,2,1.42,1.42,0,0,0,1-.21,1.19,1.19,0,0,0,.11.26,1.58,1.58,0,1,0,2.78-1.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,427.19a2,2,0,1,0-1.9-3.49,2,2,0,0,0-.79,2.7A2,2,0,0,0,225.91,427.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,351.39a2,2,0,1,0-.8,2.69A2,2,0,0,0,188.26,351.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.45,259.76a2.78,2.78,0,1,0,3.78,1.11A2.78,2.78,0,0,0,187.45,259.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,272.61a1.19,1.19,0,1,0,.48-1.61A1.18,1.18,0,0,0,169.92,272.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.86,342.7a1.19,1.19,0,1,0,1.62.48A1.19,1.19,0,0,0,190.86,342.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,350.18a2,2,0,1,0,2.68.79A2,2,0,0,0,198.75,350.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,240.7a2.37,2.37,0,1,0,3.15,1.13A2.38,2.38,0,0,0,166,240.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.88,358.54a1.59,1.59,0,1,0,1.35,2.87,1.59,1.59,0,0,0-1.35-2.87Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,368a2,2,0,1,0-1,2.63A2,2,0,0,0,155.37,368Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,362.21a2,2,0,1,0,1-2.63A2,2,0,0,0,163.66,362.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.54,380.72a1.19,1.19,0,0,0,1.58.58,1.19,1.19,0,1,0-1.58-.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82,406.47a2,2,0,1,0-2.63-1A2,2,0,0,0,246.82,406.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,230.62a1.77,1.77,0,1,0,1.5,2A1.76,1.76,0,0,0,172.21,230.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,395.28A1.48,1.48,0,1,0,157,397,1.47,1.47,0,0,0,155.77,395.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,386a1.48,1.48,0,0,0,2.87.69,1.44,1.44,0,0,0,.83-.4,1.48,1.48,0,1,0-2.05-2.13,1.37,1.37,0,0,0-.37.59A1.48,1.48,0,0,0,154.36,386Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,398.69a.89.89,0,0,0-1,.76.87.87,0,0,0,.74,1,.88.88,0,0,0,1-.74A.89.89,0,0,0,164.06,398.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.79,380.35a.89.89,0,1,0,.26-1.76.89.89,0,0,0-.26,1.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,356.35a1.77,1.77,0,1,0-.52,3.51,1.77,1.77,0,1,0,.52-3.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.19,361.77a1.18,1.18,0,1,0-1-1.34A1.18,1.18,0,0,0,160.19,361.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.25,363.25a1.48,1.48,0,1,0,1.24,1.69A1.49,1.49,0,0,0,187.25,363.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,376.53a1.49,1.49,0,0,0,1.68-1.26,1.48,1.48,0,0,0-2.93-.43A1.49,1.49,0,0,0,218.5,376.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.12,360.58a.89.89,0,1,0,.76,1A.9.9,0,0,0,178.12,360.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.85,342.23a.89.89,0,1,0-.75-1A.88.88,0,0,0,166.85,342.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.78,338.63A1.48,1.48,0,1,0,177,340.3,1.48,1.48,0,0,0,175.78,338.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,318.55a1.78,1.78,0,1,0-1.5-2A1.78,1.78,0,0,0,192.19,318.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,373.18a1.48,1.48,0,1,0,1.24,1.68A1.47,1.47,0,0,0,170.5,373.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,365.62a1.48,1.48,0,1,0-1.25-1.69A1.48,1.48,0,0,0,170.33,365.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.72,299.49a1.45,1.45,0,1,0-1.23-1.65A1.45,1.45,0,0,0,179.72,299.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.54,377.61a.89.89,0,1,0-1,.74A.89.89,0,0,0,179.54,377.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,358.25a.89.89,0,1,0-.75-1A.9.9,0,0,0,167.51,358.25Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.51,298.73a1.48,1.48,0,1,0-1.25-1.69A1.49,1.49,0,0,0,187.51,298.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,346.41a1.78,1.78,0,1,0-.52,3.52,1.78,1.78,0,0,0,.52-3.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.17,350.36a1.77,1.77,0,1,0,1.49,2A1.76,1.76,0,0,0,145.17,350.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.56,355.78a1.18,1.18,0,0,0,1.34-1,1.19,1.19,0,1,0-1.34,1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,351.17a1.48,1.48,0,1,0,1.24,1.68A1.48,1.48,0,0,0,152.2,351.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,343.61a1.48,1.48,0,1,0-1.24-1.68A1.47,1.47,0,0,0,152,343.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,344a1.46,1.46,0,1,0,1.22,1.65A1.46,1.46,0,0,0,145.77,344Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.05,277.36a.89.89,0,0,0,1-.75.88.88,0,1,0-1.75-.26A.89.89,0,0,0,221.05,277.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,336.24a.89.89,0,1,0-.76-1A.9.9,0,0,0,149.22,336.24Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.13,332.64a1.48,1.48,0,0,0-.43,2.92,1.48,1.48,0,0,0,1.57-2.06,1.57,1.57,0,0,0,2.12.26,1.58,1.58,0,1,0-2.37-.64A1.48,1.48,0,0,0,158.13,332.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,279.33a1.77,1.77,0,1,0-1.5-2A1.77,1.77,0,0,0,153.5,279.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.83,363.5a1.18,1.18,0,1,0-1-1.35A1.19,1.19,0,0,0,128.83,363.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,360.14a1.48,1.48,0,1,0,1.68-1.25A1.47,1.47,0,0,0,136.8,360.14Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,348.39a1.49,1.49,0,1,0,1.25,1.69A1.49,1.49,0,0,0,138.74,348.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,351.75a1.45,1.45,0,1,0,1.23,1.65A1.45,1.45,0,0,0,132,351.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.73,341.6a1.48,1.48,0,1,0,1.68-1.25A1.48,1.48,0,0,0,142.73,341.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.06,438.27a1.78,1.78,0,1,0,1.5,2A1.77,1.77,0,0,0,205.06,438.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,308.23a1.76,1.76,0,0,0-2,1.49,1.78,1.78,0,1,0,2-1.49Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,458.53a1.48,1.48,0,1,0,1.24,1.68A1.48,1.48,0,0,0,206.56,458.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,291.73a1.49,1.49,0,0,0-.44,2.94,1.49,1.49,0,0,0,.44-2.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,365a1.46,1.46,0,1,0,2.24-1,.5.5,0,0,0,.13,0,.88.88,0,0,0,.26-1.75.89.89,0,0,0-.67,1.58,1.09,1.09,0,0,0-.31-.08A1.45,1.45,0,0,0,144.14,365Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,375.11a.88.88,0,0,0,.5.92,1.5,1.5,0,0,0-.15.42,1.19,1.19,0,0,0,.36,1,1.41,1.41,0,0,0-.18.51,1.48,1.48,0,1,0,2.92.43,1.46,1.46,0,0,0-.79-1.52.45.45,0,0,0,0-.11,1.17,1.17,0,0,0-.95-1.33.29.29,0,0,0,0-.09.89.89,0,0,0-1.76-.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.24,356a.89.89,0,0,0,1-.75.88.88,0,0,0-1.75-.26A.89.89,0,0,0,149.24,356Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.15,271.15a1.48,1.48,0,1,0-1.25-1.68A1.48,1.48,0,0,0,192.15,271.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,454.47a1.78,1.78,0,0,0-.52,3.52,1.78,1.78,0,0,0,.52-3.52Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.43,421.9a1.78,1.78,0,1,0,1.5,2A1.77,1.77,0,0,0,65.43,421.9Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,381a1.18,1.18,0,1,0-1.34,1A1.19,1.19,0,0,0,126.78,381Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,237.5a1.48,1.48,0,1,0-1.26-1.68A1.48,1.48,0,0,0,164.19,237.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68,416.36a1.48,1.48,0,1,0,1.24,1.68A1.48,1.48,0,0,0,172.68,416.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,198.43a1.44,1.44,0,0,0,1.64-1.22,1.45,1.45,0,1,0-1.64,1.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.11,382.53a.88.88,0,0,0,1-.74.89.89,0,1,0-1,.74Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.11,361.68a.91.91,0,0,0-.43-.9,1.8,1.8,0,0,0,.26-.69,1.77,1.77,0,1,0-2,1.5,1.41,1.41,0,0,0,.41,0,.89.89,0,0,0,1.77.09Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,493.62a2.68,2.68,0,1,0-.7,3.73A2.69,2.69,0,0,0,101.22,493.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.47,326.18a1.79,1.79,0,1,0-.46,2.49A1.78,1.78,0,0,0,94.47,326.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,270.79a2.23,2.23,0,0,0-3.8,2.34,2.2,2.2,0,1,0,1.56,3.93,2.19,2.19,0,0,0,.58-2.79,2.29,2.29,0,0,0,1.08-.37A2.24,2.24,0,0,0,84.93,270.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,305.41a2.25,2.25,0,0,0,.58-3.12,1.34,1.34,0,0,0-.11-.14,1.46,1.46,0,0,0,1.19-.41,1.48,1.48,0,0,0,0-2.1,1.48,1.48,0,0,0-2.34,1.77,2.18,2.18,0,0,0-1.86.3,2.24,2.24,0,0,0,2.53,3.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,220.19a2.19,2.19,0,1,0,.57-3.05A2.2,2.2,0,0,0,130,220.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,309.26a1.35,1.35,0,1,0-.36,1.87A1.35,1.35,0,0,0,114.57,309.26Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.32,300.12a1.34,1.34,0,1,0-1.86-.34A1.32,1.32,0,0,0,81.32,300.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.53,287a2.23,2.23,0,1,0,2.52,3.69,2.25,2.25,0,0,0,.58-3.12A2.22,2.22,0,0,0,87.53,287Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24,246.28a2.66,2.66,0,0,0,4.08-3.42,2.66,2.66,0,1,0-4.08,3.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,261.08a2.66,2.66,0,1,0,.32-3.74A2.66,2.66,0,0,0,116,261.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,262.94a1.77,1.77,0,1,0,2.49.22A1.76,1.76,0,0,0,117.55,262.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,253.4a2.21,2.21,0,1,0,.27-3.13A2.21,2.21,0,0,0,124,253.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,239.82a2.22,2.22,0,1,0-.27,3.13A2.21,2.21,0,0,0,115.87,239.82Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59,253.45a2.26,2.26,0,0,0,.82.6,2.2,2.2,0,1,0,3.94-1.18,2.14,2.14,0,0,0-.94-.7,2.17,2.17,0,1,0-3.82,1.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.18,244.54a1.33,1.33,0,1,0-2,1.71,1.33,1.33,0,0,0,2-1.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54,238.79a1.33,1.33,0,1,0-1.87-.16A1.34,1.34,0,0,0,104.54,238.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09,228.33a2.21,2.21,0,1,0,.27-3.12A2.2,2.2,0,0,0,109.09,228.33Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,270.69a2.65,2.65,0,1,0-.47,3.72A2.66,2.66,0,0,0,126.43,270.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.43,288.46a2.65,2.65,0,1,0,.48-3.71A2.66,2.66,0,0,0,116.43,288.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.36,290.69a1.77,1.77,0,1,0-.32,2.48A1.78,1.78,0,0,0,120.36,290.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,288.47a2.21,2.21,0,1,0,.4-3.1A2.2,2.2,0,0,0,136.25,288.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,270.38a2.21,2.21,0,1,0-3.1-.39A2.2,2.2,0,0,0,116.75,270.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,278a2.16,2.16,0,1,0-.38,3A2.16,2.16,0,0,0,113.76,278Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,272.64a1.33,1.33,0,1,0,1.86.24A1.33,1.33,0,0,0,137.31,272.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.91,265.79a1.33,1.33,0,0,0-1.62-2.1,1.33,1.33,0,1,0,1.62,2.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85,236.22a2.69,2.69,0,1,0,.3-3.78A2.69,2.69,0,0,0,91.85,236.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.68,251.17A2.68,2.68,0,1,0,87,247.4,2.67,2.67,0,0,0,86.68,251.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,253.05a1.78,1.78,0,1,0,2.31,2.72,1.8,1.8,0,0,0,.2-2.53A1.77,1.77,0,0,0,88.23,253.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,243.38a2.23,2.23,0,1,0,.26-3.16A2.24,2.24,0,0,0,94.64,243.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,229.48a2.24,2.24,0,1,0,3.15.25A2.23,2.23,0,0,0,83.24,229.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29,232.23a2.19,2.19,0,1,0-.24,3.09A2.19,2.19,0,0,0,153.29,232.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,234.2a1.34,1.34,0,0,0,1.75,2,1.34,1.34,0,0,0-1.75-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.22,226.72a1.35,1.35,0,0,0-.14,1.9,1.32,1.32,0,0,0,1.88.14,1.34,1.34,0,0,0,.16-1.88A1.36,1.36,0,0,0,73.22,226.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.48,218.2a2.23,2.23,0,1,0,.26-3.15A2.24,2.24,0,0,0,79.48,218.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,246.08a2.71,2.71,0,1,0-.39,3.82A2.71,2.71,0,0,0,72.72,246.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.92,264.46a2.7,2.7,0,1,0,.4-3.8A2.71,2.71,0,0,0,62.92,264.46Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.44,266.38a1.81,1.81,0,1,0,2.53.27A1.8,1.8,0,0,0,64.44,266.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,256.79a2.26,2.26,0,1,0,.34-3.18A2.27,2.27,0,0,0,71.15,256.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,242.48a2.26,2.26,0,1,0,3.18.33A2.25,2.25,0,0,0,60,242.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.16,313.38a2.21,2.21,0,1,0,.32-3.11A2.22,2.22,0,0,0,174.16,313.38Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.78,248a1.35,1.35,0,0,0-1.91-.19,1.3,1.3,0,0,0-.36.45,2.24,2.24,0,0,0-3-.23,2.25,2.25,0,1,0,2.75,3.55,2.22,2.22,0,0,0,.86-1.51A1.36,1.36,0,0,0,85.78,248Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86,239.66a1.35,1.35,0,1,0-.2,1.9A1.36,1.36,0,0,0,51.86,239.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47,231a2.26,2.26,0,1,0,.34-3.17A2.26,2.26,0,0,0,56.47,231Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.48,270.37a2.7,2.7,0,0,0-3.3-4.27,2.7,2.7,0,0,0,3.3,4.27Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.14,361.69a2.69,2.69,0,1,0-.48,3.79A2.7,2.7,0,0,0,47.14,361.69Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.57,301.85a1.8,1.8,0,1,0,.33-2.53A1.79,1.79,0,0,0,155.57,301.85Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.56,274a2.25,2.25,0,1,0,3.15.41A2.26,2.26,0,0,0,94.56,274Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.52,263.12a2.25,2.25,0,1,0-.4,3.15A2.24,2.24,0,0,0,86.52,263.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,270.46a1.35,1.35,0,0,0,2.13-1.65,1.35,1.35,0,1,0-2.13,1.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.09,261.61a1.35,1.35,0,0,0-1.65-2.14,1.37,1.37,0,0,0-.24,1.91A1.35,1.35,0,0,0,75.09,261.61Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,281.29a2.72,2.72,0,1,0-3.8-.57A2.71,2.71,0,0,0,67,281.29Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,388.44a2.72,2.72,0,1,0-3.8-.57A2.72,2.72,0,0,0,57,388.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.55,300.41a1.82,1.82,0,0,0,.37-2.54,1.81,1.81,0,1,0-.37,2.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,288.63a2.26,2.26,0,1,0-3.16-.47A2.26,2.26,0,0,0,68.73,288.63Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,273.78a2.27,2.27,0,1,0-.48,3.18A2.28,2.28,0,0,0,58.17,273.78Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.46,284.65a2.22,2.22,0,1,0-.47,3.11A2.22,2.22,0,0,0,54.46,284.65Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.64,280a1.36,1.36,0,0,0-2.19,1.62,1.37,1.37,0,0,0,1.9.28A1.36,1.36,0,0,0,80.64,280Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,270.1a1.36,1.36,0,1,0-.29,1.9A1.37,1.37,0,0,0,47,270.1Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,261.62a2.27,2.27,0,1,0,.49-3.17A2.28,2.28,0,0,0,52,261.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,425.12a1.78,1.78,0,1,0-2.69,2.32,1.78,1.78,0,1,0,2.69-2.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.24,437.55a1.77,1.77,0,1,0-2.5-.19A1.79,1.79,0,0,0,140.24,437.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,440.39a1.19,1.19,0,1,0-1.67-.13A1.19,1.19,0,0,0,140.32,440.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,432.17a1.48,1.48,0,0,0,2.24-1.93,1.48,1.48,0,1,0-2.24,1.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.49,423.16a1.48,1.48,0,1,0-.15,2.09A1.49,1.49,0,0,0,137.49,423.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,430.42a1.45,1.45,0,1,0-.16,2A1.45,1.45,0,0,0,135.6,430.42Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.17,426.06a.88.88,0,0,0-.1,1.25.89.89,0,1,0,1.35-1.16A.89.89,0,0,0,151.17,426.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,422.55a.89.89,0,1,0-1.25-.09A.89.89,0,0,0,129.92,422.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,415.7a1.48,1.48,0,1,0-2.09-.16A1.48,1.48,0,0,0,135,415.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,385.77a1.78,1.78,0,1,0,2.48,2.55,1.78,1.78,0,1,0-2.48-2.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.74,395.91a1.78,1.78,0,1,0-.05,2.52A1.78,1.78,0,0,0,161.74,395.91Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,399.55a1.19,1.19,0,1,0,1.65,1.71,1.19,1.19,0,0,0-1.65-1.71Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,392.93a1.48,1.48,0,1,0-2.09,0A1.47,1.47,0,0,0,166.22,392.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,290.48a1.46,1.46,0,0,0,0,2.06,1.45,1.45,0,0,0,2.09-2A1.46,1.46,0,0,0,175.84,290.48Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.33,404.5a1.78,1.78,0,1,0-2.52-.12A1.77,1.77,0,0,0,159.33,404.5Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,412a1.77,1.77,0,1,0-.11,2.51A1.76,1.76,0,0,0,156.36,412Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,417.28a1.18,1.18,0,1,0,.07-1.67A1.18,1.18,0,0,0,154.75,417.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.84,409.06a1.48,1.48,0,1,0,.09-2.1A1.5,1.5,0,0,0,158.84,409.06Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,402.32a1.48,1.48,0,0,0-2-2.19,1.48,1.48,0,1,0,2,2.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,407.54a1.45,1.45,0,0,0-2-.09,1.44,1.44,0,0,0-.09,2.05,1.45,1.45,0,1,0,2.14-2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07,402.75A.88.88,0,1,0,168,404,.88.88,0,0,0,168.07,402.75Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,398.55a.86.86,0,0,0-.06,1.25.9.9,0,0,0,1.26.06,1.33,1.33,0,0,0,.14-.19,1.16,1.16,0,0,0,.52.22,1.18,1.18,0,1,0-1-1.52A.88.88,0,0,0,144.27,398.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,392.84a1.47,1.47,0,0,0,.09-2.09l-.2-.18a1.34,1.34,0,0,0,.38-.78,1.45,1.45,0,1,0-2.32.93,1.47,1.47,0,0,0,2,2.12Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,222.54a1.78,1.78,0,1,0,2.51,0A1.8,1.8,0,0,0,158.23,222.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,388.8a1.78,1.78,0,1,0,0-2.52A1.78,1.78,0,0,0,142,388.8Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,390a1.18,1.18,0,1,0,1.66,1.68,1.18,1.18,0,0,0,0-1.67A1.17,1.17,0,0,0,143.13,390Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,381.16a1.48,1.48,0,1,0-2.1,2.08,1.46,1.46,0,0,0,2.09,0,.27.27,0,0,0,.07-.08.91.91,0,0,0,.21.88.89.89,0,0,0,1.28-1.24.9.9,0,0,0-1.23-.06A1.46,1.46,0,0,0,149,381.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,415.55a1.48,1.48,0,1,0,0,2.1A1.48,1.48,0,0,0,198.75,415.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,384.51a2.07,2.07,0,1,0-2.93,0A2.08,2.08,0,0,0,139.8,384.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,376.36a1.48,1.48,0,1,0-1.15,1,.84.84,0,0,0,.24.51.9.9,0,0,0,1.26,0,.89.89,0,0,0,0-1.26A1,1,0,0,0,155.5,376.36Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,365.28a1.48,1.48,0,1,0,2.5.89l0,0a1.45,1.45,0,1,0,.09-2.06,1.5,1.5,0,0,0-.46,1.23s0-.05-.06-.07A1.47,1.47,0,0,0,135.63,365.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.43,384.64a1.78,1.78,0,1,0-2.52,0A1.78,1.78,0,0,0,130.43,384.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,392.22a1.77,1.77,0,1,0,2.51,0A1.77,1.77,0,0,0,125.2,392.22Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.28,395.89a1.18,1.18,0,1,0,1.67,0A1.17,1.17,0,0,0,126.28,395.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,389.21a1.48,1.48,0,0,0,2.11-2.07,1.48,1.48,0,0,0-2.09,0A1.46,1.46,0,0,0,130.09,389.21Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,380.54a1.49,1.49,0,1,0,2.1,0A1.49,1.49,0,0,0,121.92,380.54Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5,390a1.45,1.45,0,0,0,2.09-2,1.45,1.45,0,0,0-2.09,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.71,260a.89.89,0,1,0,0-1.26A.9.9,0,0,0,204.71,260Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.18,379.17a.89.89,0,1,0,1.26,0A.9.9,0,0,0,115.18,379.17Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.68,454.77a1.48,1.48,0,1,0-2.09,0A1.47,1.47,0,0,0,129.68,454.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,396a1.78,1.78,0,1,0-.11,2.51A1.77,1.77,0,0,0,140.91,396Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.52,249.7a1.77,1.77,0,1,0,.1-2.5A1.77,1.77,0,0,0,180.52,249.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.31,409.67a1.19,1.19,0,1,0,1.68.07A1.2,1.2,0,0,0,136.31,409.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.41,403.2a1.48,1.48,0,1,0-2.08-.09A1.47,1.47,0,0,0,142.41,403.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,394.2a1.48,1.48,0,1,0,2.1.09A1.47,1.47,0,0,0,132.43,394.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,478.23a2.07,2.07,0,1,0-.13,2.93A2.07,2.07,0,0,0,120.65,478.23Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.49,398.05a.92.92,0,0,0,.29-.62,1.81,1.81,0,0,0,.46-.95,1.77,1.77,0,1,0-2,1.49h0l0,0A.89.89,0,0,0,149.49,398.05Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,266.62a1.48,1.48,0,1,0-2.09-.09A1.5,1.5,0,0,0,146.71,266.62Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,405.79a1.78,1.78,0,1,0,.12-2.51A1.77,1.77,0,0,0,119.94,405.79Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.47,413.41a1.77,1.77,0,1,0-.11,2.51A1.77,1.77,0,0,0,119.47,413.41Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,418.76a1.19,1.19,0,1,0-1.68-.08A1.18,1.18,0,0,0,119.52,418.76Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.14,408.47a1.48,1.48,0,1,0-.1,2.09A1.49,1.49,0,0,0,124.14,408.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.08,403.72a1.48,1.48,0,1,0-2.09-.1A1.49,1.49,0,0,0,116.08,403.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,281.16a1.45,1.45,0,1,0,2,.1A1.45,1.45,0,0,0,154.59,281.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.94,404.11a.9.9,0,0,0-.06,1.26.89.89,0,0,0,1.25.06.89.89,0,1,0-1.19-1.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,394.13a1.48,1.48,0,1,0,2.18-2,1.48,1.48,0,0,0-2.18,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.61,362a1.78,1.78,0,1,0-2.51-.19A1.79,1.79,0,0,0,99.61,362Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.75,373a1.18,1.18,0,1,0,1.67.12A1.19,1.19,0,0,0,94.75,373Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,366.53a1.48,1.48,0,1,0,.16-2.09A1.48,1.48,0,0,0,99,366.53Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.68,329.37a1.48,1.48,0,1,0-2.24,1.94,1.49,1.49,0,0,0,2.09.15A1.48,1.48,0,0,0,35.68,329.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.65,332a1.45,1.45,0,0,0-2.2,1.89,1.45,1.45,0,1,0,2.2-1.89Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.05,361.67a.89.89,0,1,0,.09-1.25A.89.89,0,0,0,107.05,361.67Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,355.66a.89.89,0,0,0-1.25-.1.9.9,0,0,0-.09,1.26A.89.89,0,1,0,86,355.66Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,348a1.48,1.48,0,1,0-.15,2.08A1.47,1.47,0,0,0,91.1,348Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,320.13a1.78,1.78,0,0,0,0,2.51,1.78,1.78,0,1,0,0-2.51Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,294.4a1.18,1.18,0,0,0,0,1.68,1.18,1.18,0,0,0,1.69-1.65A1.18,1.18,0,0,0,85.23,294.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,327.28a1.48,1.48,0,1,0-2.09,0A1.48,1.48,0,0,0,122.2,327.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08,318.58a1.48,1.48,0,1,0,0,2.1A1.48,1.48,0,0,0,114.08,318.58Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,317.16a.89.89,0,1,0,0,1.26A.9.9,0,0,0,106.51,317.16Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.16,309.19a1.48,1.48,0,1,0-2.13,2.05,1.5,1.5,0,0,0,1.3.44.89.89,0,1,0,1.5-.74.77.77,0,0,0-.35-.22A1.46,1.46,0,0,0,111.16,309.19Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,346.37a1.77,1.77,0,1,0-.11,2.51A1.77,1.77,0,0,0,112.34,346.37Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,350a1.19,1.19,0,0,0-1.75,1.6,1.19,1.19,0,1,0,1.75-1.6Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,340.94a1.55,1.55,0,0,0,0-1.56,1.65,1.65,0,0,0-.59-.61,1.77,1.77,0,1,0-2.59,0,2.18,2.18,0,0,0,.56.41,1.57,1.57,0,0,0,1.27,2.54,1.48,1.48,0,1,0,2.38-.28A1.52,1.52,0,0,0,115.93,340.94Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.94,336.68a1.49,1.49,0,1,0-2.09-.09A1.49,1.49,0,0,0,108.94,336.68Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63,314.4a.89.89,0,1,0-1.2-1.31.89.89,0,0,0,1.2,1.31Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.18,327.11a1.48,1.48,0,0,0,2.1.09,1.49,1.49,0,0,0,.08-2.09,1.48,1.48,0,0,0-2.18,2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.53,289.93a1.78,1.78,0,1,0,0-2.52A1.78,1.78,0,0,0,154.53,289.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.78,324.32a1.19,1.19,0,0,0-1.68,0,1.18,1.18,0,0,0,1.67,1.68A1.19,1.19,0,0,0,100.78,324.32Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,442.4a1.48,1.48,0,1,0,0,2.09A1.47,1.47,0,0,0,162.55,442.4Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,273.15a1.48,1.48,0,1,0,.15,2.09A1.48,1.48,0,0,0,108.4,273.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,315.93a2.07,2.07,0,1,0,2.93,0A2.08,2.08,0,0,0,92.86,315.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88,308.93a.89.89,0,0,0,1.27-1.25.9.9,0,0,0-1.26,0A.89.89,0,0,0,87.88,308.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.15,329.08a1.77,1.77,0,1,0,0-2.51A1.78,1.78,0,0,0,81.15,329.08Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.23,331.92a1.2,1.2,0,0,0,1.69,0,1.18,1.18,0,1,0-1.69,0Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,321.22a1.47,1.47,0,0,0-1.15-2.51,1.78,1.78,0,1,0-1.2.77,1.47,1.47,0,0,0,.21,1.7,1.42,1.42,0,0,0,.42.32,1.49,1.49,0,1,0,1.72-.28Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,314.93a1.48,1.48,0,1,0,0,2.1A1.47,1.47,0,0,0,80,314.93Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.56,322.3a1.45,1.45,0,1,0,0,2A1.44,1.44,0,0,0,78.56,322.3Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21,282.18a.89.89,0,1,0,0,1.25A.89.89,0,0,0,144.21,282.18Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.41,313.55a.89.89,0,1,0,0,1.25A.88.88,0,0,0,72.41,313.55Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,307.64a1.48,1.48,0,1,0-2.07-2.11A1.48,1.48,0,0,0,77,307.64Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,330.4a1.78,1.78,0,0,0-3.09,1.22,2.36,2.36,0,0,0-.66.23A2.38,2.38,0,1,0,95.42,336a2.36,2.36,0,0,0,1.09-2.91,1.74,1.74,0,0,0,.39-2.72Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.47,263.73a1.78,1.78,0,1,0,.11-2.51A1.77,1.77,0,0,0,132.47,263.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22,345.7A1.18,1.18,0,1,0,92.3,344,1.18,1.18,0,0,0,92.22,345.7Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,337.56a1.49,1.49,0,0,0,.08-2.09,1.48,1.48,0,1,0-2.18,2A1.5,1.5,0,0,0,98.4,337.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.41,328.56a1.48,1.48,0,1,0,2.09.08A1.47,1.47,0,0,0,88.41,328.56Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.17,338.47a2.07,2.07,0,0,0,.14-2.93,2.07,2.07,0,0,0-3.1,2.75.77.77,0,0,0-.29.19.88.88,0,0,0-.06,1.25.89.89,0,0,0,1.53-.76A2,2,0,0,0,89.17,338.47Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,331.15a.89.89,0,0,0-1.31,1.2.89.89,0,0,0,1.25.06A.91.91,0,0,0,105.53,331.15Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.55,337.76a1.78,1.78,0,1,0-2.63,2.39,1.78,1.78,0,0,0,2.63-2.39Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,347.77a1.78,1.78,0,1,0-.12,2.51A1.78,1.78,0,0,0,75.45,347.77Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.57,351.44a1.19,1.19,0,1,0-.08,1.67A1.18,1.18,0,0,0,75.57,351.44Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,342.73a1.48,1.48,0,1,0,2.09.1A1.47,1.47,0,0,0,78,342.73Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.17,336a1.48,1.48,0,1,0-.1,2.09A1.49,1.49,0,0,0,72.17,336Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.23,435a1.45,1.45,0,1,0,2,.1A1.46,1.46,0,0,0,118.23,435Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.63,334.34a.89.89,0,1,0-1.31,1.2.89.89,0,1,0,1.31-1.2Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.42,328.59a1.48,1.48,0,1,0-2.09-.09A1.49,1.49,0,0,0,69.42,328.59Z",
    style: {
      fill: "#575247",
      opacity: 0.5
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDioxin04);
export default __webpack_public_path__ + "static/media/dioxin_04.1a6f1e8faa93b90a396cc1f289d1a775.svg";
export { ForwardRef as ReactComponent };